const resources = {
  "en": {
    "translation": {
      "loginTitle": "Employees Portal",
      "loginSubtitle": "This page is dedicated only for Infinity Energy Solar's employees.",
      "home": "Home",
      "services": "Services",
      "machinesHero": "Our Equipment & Machinery",
      "machinesIntro": "We use high-performance, precision-engineered machines for every stage of solar park development. Our equipment ensures reliability, efficiency, and scalability.",
      "machine0Title": "Truck loader",
      "machine0Desc": "For efficient material handling and logistics.",
      "machine1Title": "Ramming machine",
      "machine1Desc": "For precise and stable foundation work.",
      "machine2Title": "Telescopic loaders",
      "machine2Desc": "For flexible lifting and transport in complex terrains.",
      "machine3Title": "9-ton tracked mini excavator",
      "machine3Desc": "For backing up the fleet for all the special needs.",
      "machinesBrowseGallery": "Browse Our Machinery",
      "machinesGalleryTitle": "Machinery gallery",
      "machineryListButton": "Machine list",
      "machineryFleetTitle": "Our fleet",
      "machineryFleetRow0": "Mazaka Hydraulic Pile Driving System",
      "machineryFleetRow1": "Orteco Pile Driver",
      "machineryFleetRow2": "Gayk Pile Driver",
      "machineryFleetRow3": "Bobcat Compact Skid Steer Loader (Model: T86)",
      "machineryFleetRow4": "Manitou Telescopic Loader (tele-handler)",
      "machineryFleetRow5": "Bobcat Telescopic Loader (tele-handler) (Model: T76)",
      "machineryFleetRow6": "Develon Crawler Excavator 9 ton",
      "machineryFleetRow7": "Develon Crawler Excavator 14 ton",
      "machineryFleetRow8": "Drilling machine",
      "machineryFleetRow9": "Bobcat Compact Excavator 3.5 ton (Model: E35)",
      "machineryFleetRow10": "Bobcat Compact Excavator 5.5 ton (Model: E55)",
      "machinesCloseModal": "Close",
      "machines": "Machines",
      "certificatesHero": "Our Certifications",
      "certificatesIntro": "We are certified to the highest industry standards, guaranteeing reliability, quality, and compliance in all our projects.",
      "certificate0Title": "ISO 9001:2015",
      "certificate0Desc": "Quality management systems certification for consistent performance.",
      "certificate1Title": "ISO 14001:2015",
      "certificate1Desc": "Environmental management systems certification to minimize ecological impact.",
      "certificate2Title": "ISO 45001:2018",
      "certificate2Desc": "Occupational health and safety certification for our teams and partners.",
      "certificates": "Certificates",
      "projects": "Projects",
      "projectsHero": "We are powering a cleaner and brighter Europe",
      "projectsIntro": "These are our projects in several countries across Europe - each is more than just a construction site to us. They embody strong partnerships, shared goals, and the trust our clients place in us. Each location represents a step toward a greener tomorrow, powered by innovation, reliability, and vision.",
      "countryBulgaria": "Bulgaria",
      "countryFrance": "France",
      "countryItaly": "Italy",
      "countryGermany": "Germany",
      "countrySerbia": "Serbia",
      "countryNorthMacedonia": "North Macedonia",
      "countryBelgium": "Belgium",
      "countryDenmark": "Denmark",
      "chooseCountry": "Choose a country",
      "selectCountry": "Select a country",
      "selectProject": "Select a project",
      "selectCountryToBrowse": "Select a country to browse projects",
      "selectProjectFromDropdown": "Select a project from the dropdown above",
      "projectsBelgiumTitle": "Belgium Projects",
      "projectsDenmarkTitle": "Denmark Projects",
      "projectsFranceTitle": "France Projects",
      "projectBelgiumMain": "Main Belgium Project",
      "projectsGermanyTitle": "Germany Projects",
      "projectsSerbiaTitle": "Serbia Projects",
      "projectsItalyTitle": "Italy Projects",
      "projectsNorthMacedoniaTitle": "North Macedonia Projects",
      "projectGermanyDiesel": "Diesel Technic",
      "projectNessebar": "Nessebar",
      "projectVitaminka": "Vitaminka, Prilep",
      "projectLapovo": "Lapovo",
      "projectPernikOne": "Pernik 1",
      "projectPernikTwo": "Pernik 2",
      "projectMoussoulens": "Moussoulens",
      "projectPerpignan": "Perpignan",
      "projectStGermain": "Saint Germain",
      "projectLesMes": "Les Mées",
      "projectSBRU": "SBRU",
      "projectStElix": "St. Elix",
      "projectSlivnitsa": "Slivnitsa",
      "projectRasovo": "Rasovo, Lom",
      "projectPolch": "Polch",
      "projectMonreale": "Monreale, Sicily",
      "projectVillerup": "Villerup",
      "nessebarTitle": "Nessebar",
      "lapovoTitle": "Lapovo",
      "vitaminkaTitle": "Vitaminka, Prilep",
      "pernikoneTitle": "Pernik 1",
      "perniktwoTitle": "Pernik 2",
      "slivnitsaTitle": "Slivnitsa",
      "rasovoTitle": "Rasovo, Lom",
      "polchTitle": "Polch",
      "villerupTitle": "Villerup",
      "monrealeTitle": "Monreale",
      "moussoulensTitle": "Moussoulens",
      "perpignanTitle": "Perpignan",
      "stgermainTitle": "Saint Germain",
      "lesmesTitle": "Les Mées",
      "sbruTitle": "SBRU",
      "stelixTitle": "Сент Еликс",
      "projectPower": "Total Power Capacity",
      "projectType": "Construction Type",
      "projectTypeStatic": "Static",
      "projectTypeTracker": "Tracker",
      "projectYear": "Year",
      "photoGallery": "Photo Gallery",
      "projectsBulgariaTitle": "Projects in Bulgaria",
      "projectsBulgariaIntro": "These are our projects in Bulgaria - each is more than just a construction site to us. They embody strong partnerships, shared goals, and the trust our clients place in us.",
      "projectKyustendil": "Kyustendil",
      "projectPlovdiv": "Plovdiv Installation",
      "projectRazlog": "Razlog Power Hub",
      "kyustendilTitle": "Kyustendil Solar Park",
      "loadingImage": "Loading image...",
      "back": "Back",
      "whyInfinity": "Why Infinity?",
      "whyHero": "Why Choose Infinity?",
      "whyIntro": "At Infinity Energy Solar, we combine cutting-edge technology with a team of passionate experts to deliver unparalleled solar energy solutions.",
      "why0Title": "Experience and Expertise",
      "why0Desc": "Our highly skilled team has a proven track record of successful solar projects across Europe.",
      "why1Title": "Customized Solutions",
      "why1Desc": "We tailor every photovoltaic system to meet your specific needs and site conditions.",
      "why2Title": "Sustainable Commitment",
      "why2Desc": "We prioritize eco-friendly practices and long-term sustainability in everything we build.",
      "why3Title": "Financial Support Assistance",
      "why3Desc": "We prepare technical and financial documentation to help secure funding from Bulgarian and international financial organizations for your project.",
      "why4Title": "Commitment to Excellence",
      "why4Desc": "Our dedication to quality and customer success drives us to provide only the best solutions, working with top-tier brands to ensure the best results.",
      "contact": "Contact",
      "contactHero": "Let's power your future together",
      "contactText": "We are here to assist you with your solar energy needs. Whether you have questions, need expert advice, or are ready to start your project, our team is ready to provide you with tailored solutions and support. Contact us today and let’s power the future together!",
      "contactTitle": "Contact Us",
      "contactPhone": "Phone",
      "contactEmail": "Email",
      "contactAddress": "Address",
      "contactFullAddress": "ul. \"Hristo Botev\" 2, 2760 Razlog, Bulgaria",
      "futureText": "Your future, powered by the Sun",
      "futureTextLine1": "Your future,",
      "futureTextLine2": "powered by the Sun!",
      "heroText": "Your future, powered by the Sun!",
      "heroSubtitle": "We develop solar parks across Europe, soon beyond.",
      "contactUs": "Contact Us",
      "exploreProjects": "Explore Our Projects",
      "whoAreWe": "Who are we?",
      "whoAreWeText": "Infinity Energy Solar is a young and rapidly expanding company that provides innovative and sustainable solutions for the production and storage of renewable energy. The company specializes in the design and construction of photovoltaic parks and has already successfully completed projects in Bulgaria and several European countries. With a strong emphasis on high standards and technological innovation, Infinity Energy Solar has established itself as a reliable partner in the implementation of solar installations of various scales. Our team of experts manages the entire process with a focus on efficiency, durability, and sustainability. The company develops customized solutions tailored to the specific needs and requirements of its partners and clients. Infinity Energy Solar has rapidly expanded and currently boasts a team of over 100 employees. We believe our success is driven by the dedication, expertise, and unity of our people, who are at the core of every successful step we take.",
      "homeAbout": "Infinity Energy Solar is a young and rapidly growing company offering innovative and sustainable solutions for the production and storage of renewable energy. Specializing in the design and construction of photovoltaic parks, the company has already successfully completed projects both in Bulgaria and across several European countries.\n\nWith a strong focus on high standards and technological innovation, we have established ourselves as a reliable partner in the implementation of solar installations of various scales. Our team of experts manages the entire process with a focus on efficiency, durability, and sustainability.\n\nThe company develops customized solutions tailored to the specific needs and requirements of its partners and clients. Infinity Energy Solar has quickly expanded and today boasts a team of over 180 employees. We believe our success is driven by the dedication, expertise, and unity of our people, who are at the heart of every successful step we take.",
      "getStarted": "Get Started",
      "projectsStat": "Projects",
      "powerStat": "Total Power Capacity",
      "countriesStat": "Countries",
      "workersStat": "Employees",
      "servicesHero": "Our services are engineered for excellence.",
      "servicesIntro": "From the initial design to long-term maintenance, we deliver comprehensive solutions tailored to every solar energy project.",
      "ourServices": "Our Services",
      "ourServicesDesc": "From the initial design to long-term maintenance, we deliver comprehensive solutions tailored to every solar energy project.",
      "labelPrintingTitle": "Label Printing",
      "labelPrintingDesc": "Our company offers professional label printing services for solar parks and other infrastructure projects using the Brady i7500 - ensuring durable, precise, compliant labels for panels, cables, equipment and infrastructure components.",
      "designTitle": "Design",
      "designDesc": "According to the needs of your business, we design your photovoltaic power system, providing an accurate design according to your idea.",
      "constructTitle": "Construct",
      "constructDesc": "Our team of specialists executes the installation in accordance with the most suitable solution for your system, ensuring a precise and detailed plan for its implementation at the designated location.",
      "maintainTitle": "Maintain",
      "kyustendilContractor": "Contractor: Rashev & Co LTD",
      "pernikoneContractor": "Contractor: Rashev & Co LTD",
      "slivnitsaContractor": "Contractor: Rashev & Co LTD",
      "moussoulensContractor": "Contractor: Rashev & Co LTD",
      "monrealeContractor": "Contractor: Rashev & Co LTD",
      "perpignanContractor": "Contractor: Rashev & Co LTD",
      "stgermainContractor": "Contractor: Rashev & Co LTD",
      "lesmesContractor": "Contractor: Rashev & Co LTD",
      "lesmesNotes": "Repowering",
      "maintainDesc": "Our team carries out technical maintenance of the built photovoltaic systems according to the requirements, observing all the technical requirements of the manufacturers we work with.",
      "upcomingProjects": "UPCOMING PROJECTS:",
      "projectsInProgressUpcoming": "Projects in Progress",
      "inProgress": "In Progress",
      "upcoming": "Upcoming",
      "projectAunslev": "Aunslev",
      "projectAunslevCapacity": "31 MWh",
      "projectStElix": "St. Elix",
      "projectStElixCapacity": "4.1 MWp",
      "projectBalkantsi": "Balkantsi, Bulgaria",
      "projectBalkantsiCapacity": "5 MWp",
      "projectIhtiman": "Ihtiman, Bulgaria",
      "projectIhtimanCapacity": "12 MWp",
      "projectMorocco": "Beni Mathar, Africa",
      "projectMoroccoCapacity": "120 MWp",
      "projectPrevancher": "Prévenchères, France",
      "projectPrevancherCapacity": "42 MWp",
      "upcomingProjectsDesc": "From January 2026, we are about to start several projects across Europe and Bulgaria.",
      "mapConsentRequired": "Google Maps is disabled until cookies are accepted.",
      "cookiesTitle": "Infinity Energy Solar - Cookies Policy",
      "cookiesHeader": "Cookies Policy",
      "cookiesIntro": "We use cookies to enhance your browsing experience and analyze site traffic. Cookies are small text files stored on your device that help us recognize you and remember your preferences.",
      "cookiesTypesTitle": "Types of Cookies We Use",
      "cookiesTypes.0": "Necessary Cookies – essential for core site functionality",
      "cookiesTypes.1": "Analytics Cookies – help us understand user behavior (e.g., Google Analytics)",
      "cookiesTypes.2": "Functional Cookies – remember your preferences (e.g., language)",
      "cookiesThirdPartyTitle": "Third-Party Services",
      "cookiesThirdParty": "We use Google Maps to display our company’s location on the Contact page. Google may set cookies and collect usage data. You can view their Privacy Policy.",
      "cookiesManageTitle": "Managing Cookies",
      "cookiesManage": "You can control or disable cookies through your browser settings. Disabling some types may impact site functionality.",
      "cookiesContactTitle": "Contact",
      "cookiesContact": "If you have any questions about our cookie policy, please contact us at office@infisolarbg.com.",
      "cookieBannerText": "This website uses cookies. By continuing, you accept or reject our Cookies Policy.",
      "cookieBannerLearnMore": "Learn More",
      "cookieBannerAccept": "Accept",
      "cookieBannerDecline": "Decline",
      "employeesTitle": "For employees",
      "employeesInfo": "These contacts are exclusively for employees to report any problems, unsafe work conditions, or other workplace issues. All reports are treated with strict confidentiality, ensuring employees can raise concerns without fear of repercussions. This communication channel is managed by our Human Resources department to provide a safe and supportive work environment for everyone.",
      "admin.dashboard": "Dashboard",
      "admin.welcomeMessage": "Welcome to the administrative dashboard",
      "admin.languageSwitcher": "Език",
      "admin.bulgarian": "Bulgarian",
      "admin.english": "English",
      "admin.loadingDashboard": "Loading your dashboard...",
      "admin.loadingData": "Loading dashboard data...",
      "admin.welcomeUser": "Welcome",
      "admin.userRole": "Unknown role",
      "admin.noEmail": "No email",
      "admin.notification": "Notifications",
      "admin.totalProjects": "Total projects",
      "admin.activeProjects": "active",
      "admin.totalEmployees": "Total employees",
      "admin.administrators": "administrators",
      "admin.activeWorkers": "Active workers",
      "admin.ofTotal": "from total",
      "admin.projectSummary": "Project Summary",
      "weatherPanel.enterCity": "Enter City",
      "weatherPanel.set": "Set",
      "weatherPanel.loadingWeather": "Loading Weather...",
      "weatherPanel.weatherDataUnavailable": "Weather data not available",
      "weatherPanel.retry": "Retry",
      "weatherPanel.noWeatherData": "No weather data",
      "weatherPanel.currentWeather": "Current weather",
      "weatherPanel.wind": "Wind",
      "weatherPanel.humidity": "Humidity",
      "weatherPanel.kmh": "km/h",
      "weatherPanel.celsius": "°C",
      "projectSummary.onTrack": "On Track",
      "projectSummary.atRisk": "At Risk",
      "projectSummary.completed": "Completed",
      "projectSummary.notStarted": "Not Started",
      "adminLayout.adminPanel": "Admin Panel",
      "adminLayout.home": "Home",
      "adminLayout.projects": "Projects",
      "adminLayout.assignProjects": "Assign Projects",
      "adminLayout.dailyLogs": "Daily Logs",
      "adminLayout.analytics": "Analytics",
      "adminLayout.forecasting": "Forecasting",
      "adminLayout.autoPark": "Auto Park",
      "adminLayout.inventory": "Inventory",
      "adminLayout.invoices": "Invoices",
      "adminLayout.contracts": "Contracts",
      "adminLayout.workers": "Workers",
      "adminLayout.users": "Users",
      "adminLayout.resources": "Resources",
      "adminLayout.notifications": "Notifications",
      "adminLayout.settings": "Settings",
      "adminLayout.hideSidebar": "Hide Sidebar",
      "adminLayout.showSidebar": "Show Sidebar",
      "adminLayout.logout": "Logout",
      "adminProjects.addNewProject": "Add New Project",
      "adminProjects.projectName": "Project Name",
      "adminProjects.enterProjectName": "Enter project name",
      "adminProjects.powerCapacity": "Power Capacity",
      "adminProjects.enterPowerCapacity": "Enter power capacity",
      "adminProjects.constructionType": "Construction Type",
      "adminProjects.enterConstructionType": "Enter construction type",
      "adminProjects.dueDate": "Due Date",
      "adminProjects.notificationThresholds": "Notification Thresholds",
      "adminProjects.cancel": "Cancel",
      "adminProjects.createProject": "Create Project",
      "adminProjects.noAuthToken": "No authentication token",
      "adminProjects.authenticationFailed": "Authentication failed",
      "adminProjects.failedToLoad": "Failed to load projects",
      "adminProjects.projectManagement": "Project Management",
      "adminProjects.manageDescription": "Manage and monitor all your solar energy projects",
      "adminProjects.loadingProjects": "Loading projects...",
      "adminProjects.active": "Active",
      "adminProjects.completed": "Completed",
      "adminProjects.createProject": "Create Project",
      "adminProjects.projectName": "Project Name",
      "adminProjects.powerCapacity": "Power Capacity",
      "adminProjects.constructionType": "Construction Type",
      "adminProjects.status": "Status",
      "adminProjects.percentCompleted": "% Completed",
      "adminProjects.noActiveProjects": "No active projects found",
      "adminProjects.noCompletedProjects": "No completed projects found",
      "adminProjects.getStartedMessage": "Get started by creating a new project.",
      "adminProjects.noCompletedMessage": "No completed projects yet.",
      "adminProjects.addNewProject": "Add New Project",
      "adminProjects.enterProjectName": "Enter project name",
      "adminProjects.enterPowerCapacity": "Enter power capacity",
      "adminProjects.enterConstructionType": "Enter construction type",
      "adminProjects.dueDate": "Due Date",
      "adminProjects.notificationThresholds": "Notification Thresholds",
      "adminProjects.cancel": "Cancel",
      "adminProjects.tryAgain": "Try Again",
      "adminProjects.goToLogin": "Go to Login",
      "adminProjects.authenticationFailed": "Authentication failed. Please log in again.",
      "adminProjects.failedToLoad": "Failed to load projects. Please try again.",
      "adminProjects.noAuthToken": "No authentication token found. Please log in.",
      "adminProjects.activeProjects": "active projects",
      "adminProjects.completedProjects": "completed projects",
      "constructionType.tracker": "Tracker",
      "constructionType.static": "Static",
      "projectStatus.onTrack": "On Track",
      "projectStatus.atRisk": "At Risk",
      "projectStatus.completed": "Completed",
      "projectStatus.notStarted": "Not Started",
      "projectDetails.projectDetails": "Project Details",
      "projectDetails.viewManageDescription": "View and manage project information, activities and progress",
      "projectDetails.exportToPDF": "Export to PDF",
      "projectDetails.generatingPDF": "Generating PDF...",
      "projectDetails.exportFailed": "Export failed",
      "projectDetails.projectInfo": "Project Information",
      "projectDetails.projectName": "Project Name",
      "projectDetails.percentCompleted": "% Completed",
      "projectDetails.status": "Status",
      "projectDetails.assignedEmployee": "Project Manager",
      "projectDetails.assignedWorkers": "Site Workers",
      "projectDetails.notificationMatrix": "Notification Matrix",
      "projectDetails.workingHours": "Working Hours",
      "projectDetails.additionalWorkingHours": "Additional Working Hours",
      "projectDetails.totalWorkingHours": "Total Working Hours",
      "projectDetails.firstLogDate": "First Log Date",
      "projectDetails.finishDate": "Completion Date",
      "projectDetails.daysLeft": "Days Remaining",
      "projectDetails.selectActivity": "Select Activity",
      "projectDetails.select": "Select...",
      "projectDetails.cancel": "Cancel",
      "projectDetails.add": "Add",
      "projectDetails.activities": "Activities",
      "projectDetails.activity": "Activity",
      "projectDetails.unit": "Unit",
      "projectDetails.planned": "Planned",
      "projectDetails.dailyTarget": "Daily Target",
      "projectDetails.completed": "Completed",
      "projectDetails.remaining": "Remaining",
      "projectDetails.percentCompletedCol": "% Completed",
      "projectDetails.addActivity": "+ Add Activity",
      "projectDetails.assignWorkers": "Assign Workers",
      "projectDetails.saveActivities": "Save Activities",
      "projectDetails.activitiesSaved": "Activities saved successfully!",
      "projectDetails.errorSavingActivities": "Error saving activities.",
      "projectDetails.dailyLogs": "Daily Logs",
      "projectDetails.noLogsAvailable": "No logs available.",
      "projectDetails.date": "Date",
      "projectDetails.workingHoursLogs": "Working Hours",
      "projectDetails.logWorkingHours": "Log Working Hours",
      "projectDetails.from": "From:",
      "projectDetails.to": "To:",
      "projectDetails.clear": "Clear",
      "projectDetails.worker": "Worker",
      "projectDetails.totalPerDay": "Total per Day",
      "projectDetails.selectedDatesHours": "Selected dates hours:",
      "projectDetails.grandTotalHours": "Grand Total Hours:",
      "projectDetails.saveWorkingHours": "Save Working Hours",
      "projectDetails.workingHoursSaved": "Working hours saved!",
      "projectDetails.errorSavingHours": "Error saving working hours",
      "projectDetails.logHoursForToday": "Log hours for today",
      "projectDetails.save": "Save",
      "projectDetails.additionalWork": "Additional Work",
      "projectDetails.addAdditionalWork": "+ Add",
      "projectDetails.description": "Description",
      "projectDetails.hours": "Hours",
      "projectDetails.comments": "Comments",
      "projectDetails.total": "Total",
      "projectDetails.addAdditionalWorkModal": "Add Additional Work",
      "projectDetails.projectPhotos": "Project Photos",
      "projectDetails.uploaded": "Uploaded",
      "projectDetails.loadingProjectDetails": "Loading project details...",
      "projectDetails.assignTitle": "Assign Workers",
      "projectDetails.assign.Search": "Search workers by name, email, or phone...",
      "projectDetails.assignSelectAll": "Select All",
      "projectDetails.assignClearAll": "Clear All", 
      "projectDetails.assignCancel": "Cancel",
      "projectDetails.assignAssign": "Assign",
      "adminAssignEmployees.assignProjectToEmployee": "Assign Project to Employee",
      "adminAssignEmployees.manageProjectAssignments": "Manage project assignments and team distribution",
      "adminAssignEmployees.loading": "Loading...",
      "adminAssignEmployees.tryAgain": "Try Again",
      "adminAssignEmployees.projectAssignment": "Project Assignment",
      "adminAssignEmployees.selectProject": "All Projects",
      "adminAssignEmployees.chooseProject": "Choose project...",
      "adminAssignEmployees.selectEmployee": "All Employees",
      "adminAssignEmployees.chooseEmployee": "Choose employee...",
      "adminAssignEmployees.assignProject": "Assign Project",
      "adminAssignEmployees.currentAssignments": "Current Assignments",
      "adminAssignEmployees.project": "Project",
      "adminAssignEmployees.assignedTo": "Assigned To",
      "adminAssignEmployees.noOneAssigned": "No one assigned",
      "adminAssignEmployees.noAssignmentsFound": "No assignments found",
      "adminAssignEmployees.getStartedMessage": "Get started by assigning a project to an employee.",
      "adminAssignEmployees.employeeId": "Employee ID",
      "adminAssignEmployees.unknown": "Unknown",
      "adminAssignEmployees.selectBothProjectAndEmployee": "Please select both a project and an employee.",
      "adminAssignEmployees.projectAssignedSuccessfully": "Project assigned successfully!",
      "adminAssignEmployees.assignmentFailed": "Assignment failed. Please try again.",
      "adminDaily.dailyLogs": "Daily Logs",
      "adminDaily.trackDailyActivities": "Track daily activities and project progress",
      "adminDaily.failedToLoadProjects": "Failed to load projects. Please try again.",
      "adminDaily.tryAgain": "Try Again",
      "adminDaily.selectProject": "Select a Project",
      "adminDaily.status": "Status",
      "adminDaily.completed": "Completed",
      "adminDaily.atRisk": "At Risk",
      "adminDaily.onTrack": "On Track",
      "adminDaily.notStarted": "Not Started",
      "adminDaily.progress": "Progress",
      "adminDaily.assigned": "Assigned",
      "adminDaily.notAssigned": "Not assigned",
      "adminDaily.project": "Project",
      "adminDaily.loadingLogs": "Loading logs...",
      "adminAnalytics.overview": "Overview",
      "adminAnalytics.activities": "Activities",
      "adminAnalytics.comparisons": "Comparisons",
      "adminAnalytics.insights": "Insights",
      "adminAnalytics.performance": "Performance",
      "adminAnalytics.workLogs": "Work Logs",
      "adminAnalytics.failedToLoadProjects": "Failed to load projects. Please try again.",
      "adminAnalytics.analyticsDashboard": "Analytics Dashboard",
      "adminAnalytics.monitorProjectPerformance": "Monitor project performance and track key metrics",
      "adminAnalytics.projects": "Projects",
      "adminAnalytics.loading": "Loading...",
      "adminAnalytics.noProjectsFound": "No projects found",
      "adminAnalytics.overallProgress": "Overall Progress",
      "adminAnalytics.assignedWorkers": "Assigned Workers",
      "adminAnalytics.loggedWorkers": "Logged Workers",
      "adminAnalytics.comingSoon": "Coming Soon",
      "adminAnalytics.featureUnderDevelopment": "This feature is under development and will be available soon.",
      "adminAnalytics.noProjectSelected": "No Project Selected",
      "adminAnalytics.selectProjectFromSidebar": "Please select a project from the sidebar to view analytics.",
      "adminForecasting.forecastResults": "Forecast Results",
      "adminForecasting.notEnoughData": "Not enough data to generate forecast. Please add more completed projects.",
      "adminForecasting.estimatedDuration": "Estimated Duration",
      "adminForecasting.estimatedWorkers": "Estimated Workers",
      "adminForecasting.estimatedTotalWorkingHours": "Estimated Total Working Hours",
      "adminForecasting.notificationThresholds": "Notification Thresholds",
      "adminForecasting.fillRequiredFields": "Please fill in all required fields.",
      "adminForecasting.projectForecasting": "Project Forecasting",
      "adminForecasting.generateAccurateForecasts": "Generate accurate project forecasts based on historical data",
      "adminForecasting.projectDetails": "Project Details",
      "adminForecasting.projectName": "Project Name",
      "adminForecasting.projectNamePlaceholder": "e.g. Solar Park Alpha",
      "adminForecasting.powerCapacity": "Power Capacity (MW)",
      "adminForecasting.powerCapacityPlaceholder": "e.g. 1000",
      "adminForecasting.constructionType": "Construction Type",
      "adminForecasting.similarProjectsFound": "Similar projects found",
      "adminForecasting.calculating": "Calculating...",
      "adminForecasting.generateForecast": "Generate Forecast",
      "adminForecasting.static": "Static",
      "adminForecasting.roof": "Roof", 
      "adminForecasting.tracker": "Tracker",
      "autoPark.carsAndMachinery": "Cars and Machinery",
      "autoPark.manageVehicleFleet": "Manage your vehicle fleet and equipment inventory",
      "autoPark.addNewCar": "Add New Car",
      "autoPark.addNewMachine": "Add New Machine",
      "autoPark.cars": "Cars",
      "autoPark.machinery": "Machinery",
      "autoPark.searchCars": "Search cars...",
      "autoPark.searchMachinery": "Search machinery...",
      "autoPark.allStatuses": "All Statuses",
      "autoPark.active": "Active",
      "autoPark.maintenance": "Maintenance",
      "autoPark.repair": "Repair",
      "autoPark.inactive": "Inactive",
      "autoPark.retired": "Retired",
      "autoPark.model": "Model",
      "autoPark.plate": "Plate",
      "autoPark.driver": "Driver",
      "autoPark.type": "Type",
      "autoPark.insurance": "Insurance",
      "autoPark.vignette": "Vignette",
      "autoPark.techInsp": "Tech Insp.",
      "autoPark.status": "Status",
      "autoPark.contact": "Contact",
      "autoPark.actions": "Actions",
      "autoPark.machineName": "Machine Name",
      "autoPark.operator": "Operator",
      "autoPark.location": "Location",
      "autoPark.nextMaintenance": "Next Maintenance",
      "autoPark.noCarsFound": "No cars found",
      "autoPark.noMachineryFound": "No machinery found",
      "autoPark.tryAdjustingSearch": "Try adjusting your search criteria or status filter.",
      "autoPark.getStartedAddingCar": "Get started by adding a new car.",
      "autoPark.getStartedAddingMachinery": "Get started by adding new machinery.",
      "autoPark.totalCars": "Total Cars",
      "autoPark.totalMachinery": "Total Machinery",
      "autoPark.editCar": "Edit Car",
      "autoPark.carModel": "Car Model",
      "autoPark.licensePlate": "License Plate",
      "autoPark.techInspectionExpiry": "Tech Inspection Expiry",
      "autoPark.insuranceExpiry": "Insurance Expiry",
      "autoPark.vignetteExpiry": "Vignette Expiry",
      "autoPark.driverName": "Driver Name",
      "autoPark.carType": "Car Type",
      "autoPark.contactNumber": "Contact Number",
      "autoPark.save": "Save",
      "autoPark.cancel": "Cancel",
      "autoPark.carInformation": "Car Information",
      "autoPark.techInspExpiry": "Tech Insp. Expiry",
      "autoPark.notSet": "Not set",
      "autoPark.services": "Services",
      "autoPark.addService": "Add Service",
      "autoPark.notes": "Notes",
      "autoPark.addNote": "Add Note",
      "autoPark.exportToPDF": "Export to PDF",
      "autoPark.preparingPDF": "Preparing PDF...",
      "autoPark.statusActive": "Active",
      "autoPark.statusMaintenance": "Maintenance", 
      "autoPark.statusRepair": "Repair",
      "autoPark.statusInactive": "Inactive",
      "autoPark.statusRetired": "Retired",
      "autoPark.description": "Description",
      "autoPark.date": "Date",
      "autoPark.price": "Price",
      "autoPark.total": "Total",
      "autoPark.noServicesYet": "No services yet.",
      "autoPark.noNotesYet": "No notes yet.",
      "autoPark.serviceType": "Service Type",
      "autoPark.regularService": "Regular Service",
      "autoPark.techInspection": "Tech Inspection",
      "autoPark.insurance": "Insurance",
      "autoPark.vignette": "Vignette",
      "autoPark.serviceDescriptionPlaceholder": "Service description...",
      "autoPark.newExpiryDate": "New Expiry Date",
      "autoPark.noteDescriptionPlaceholder": "Enter note description...",
      "autoPark.reset": "Reset",
      "autoPark.manufacturer": "Manufacturer",
      "autoPark.year": "Year",
      "autoPark.cost": "Cost",
      "autoPark.fuelType": "Fuel Type",
      "autoPark.lastMaintenance": "Last Maintenance",
      "autoPark.registrationExpiry": "Registration Expiry",
      "autoPark.machineryInformation": "Detailed information",
      "autoPark.noServicesRecordedYet": "No services yet.",
      "adminInventory.inventoryManagement": "Inventory Management",
      "adminInventory.manageCompanyAssets": "Manage company assets, devices, and equipment assignments",
      "adminInventory.addNewAsset": "Add New Asset",
      "adminInventory.searchAssets": "Search assets...",
      "adminInventory.name": "Name",
      "adminInventory.email": "Email",
      "adminInventory.device": "Device",
      "adminInventory.brand": "Brand",
      "adminInventory.model": "Model",
      "adminInventory.serialNumber": "Serial Number",
      "adminInventory.actions": "Actions",
      "adminInventory.protocol": "Protocol",
      "adminInventory.noAssetsFound": "No assets found",
      "adminInventory.tryAdjustingSearch": "Try adjusting your search criteria.",
      "adminInventory.getStartedAddingAsset": "Get started by adding a new asset.",
      "adminInventory.download": "Download",
      "adminInventory.totalAssets": "Total Assets",
      "adminInventory.editAsset": "Edit Asset",
      "adminInventory.employeeWorker": "Employee/Worker",
      "adminInventory.selectEmployeeAdminWorker": "Select Employee/Admin/Worker",
      "adminInventory.deviceType": "Device Type",
      "adminInventory.selectDeviceType": "Select Device Type",
      "adminInventory.enterBrandName": "Enter brand name",
      "adminInventory.enterModelName": "Enter model name",
      "adminInventory.enterSerialNumber": "Enter serial number",
      "adminInventory.updateAsset": "Update Asset",
      "adminInventory.createAsset": "Create Asset",
      "adminInventory.close": "Close",
      "adminInventory.assetInformation": "Asset Information",
      "adminInventory.addedAt": "Added At",
      "adminInventory.updatedAt": "Updated At",
      "adminInventory.cancel": "Cancel",
      "adminInventory.pleaseFillRequiredFields": "Please fill in all required fields: Device Type, Brand, and Serial Number",
      "adminInventory.failedToSave": "Failed to save",
      "adminInventory.failedToSaveAsset": "Failed to save asset. Please try again.",
      "adminUsers.areYouSureDeleteUser": "Are you sure you want to delete this user?",
      "adminUsers.cannotDeleteUserInventory": "Cannot delete user. The user has assigned inventory items that must be returned first. Please return all assigned items before deleting the user.",
      "adminUsers.failedToDeleteUser": "Failed to delete user. Please try again.",
      "adminUsers.user": "User",
      "adminUsers.email": "Email",
      "adminUsers.role": "Role",
      "adminUsers.actions": "Actions",
      "adminUsers.hasAssignedInventoryItems": "Has {count} assigned inventory item(s)",
      "adminUsers.cannotDeleteAssignedInventory": "Cannot delete - user has assigned inventory",
      "adminUsers.deleteUser": "Delete User",
      "adminUsers.noUsersFound": "No users found",
      "adminUsers.tryAdjustingSearch": "Try adjusting your search criteria.",
      "adminUsers.getStartedCreatingUser": "Get started by creating a new user.",
      "adminUsers.noDeletedUsersToDisplay": "No deleted users to display.",
      "adminUsers.usersManagement": "Users Management",
      "adminUsers.manageOrganizationUsers": "Manage all your organization users",
      "adminUsers.addNewUser": "Add New User",
      "adminUsers.searchUsers": "Search users...",
      "adminUsers.currentUsers": "Current Users",
      "adminUsers.deletedUsers": "Deleted Users",
      "adminUsers.totalUsers": "Total Users",
      "adminUsers.fullName": "Full Name",
      "adminUsers.enterFullName": "Enter full name",
      "adminUsers.enterEmailAddress": "Enter email address",
      "adminUsers.password": "Password",
      "adminUsers.enterPassword": "Enter password",
      "adminUsers.avatar": "Avatar",
      "adminUsers.useDefaultAvatar": "Use default avatar",
      "adminUsers.uploadCustomAvatar": "Upload custom avatar",
      "adminUsers.enterImageURL": "Enter image URL...",
      "adminUsers.cancel": "Cancel",
      "adminUsers.createUser": "Create User",
      "adminUsers.userDetails": "User Details",
      "adminUsers.assignedProjects": "Assigned Projects",
      "adminUsers.loading": "Loading...",
      "adminUsers.noAssignedProjects": "No assigned projects.",
      "adminUsers.assignedAssets": "Assigned Assets",
      "adminUsers.noAssetsAssigned": "No assets assigned.",
      "adminUsers.close": "Close",
      "adminUsers.specialPermissions": "Special Permissions",
      "adminUsers.autoparkAccess": "Auto Park Access",
      "adminUsers.inventoryAccess": "Inventory Access",
      "adminUsers.contractsAccess": "Contracts Access",
      "adminUsers.workersAccess": "Workers Access",
      "adminUsers.invoicesAccess": "Invoices Access",
      "adminUsers.analyticsAccess": "Analytics Access",
      "adminUsers.forecastingAccess": "Forecasting Access",
      "adminUsers.resourcesAccess": "Resources Access",
      "adminUsers.usersAccess": "Users Access",
      "adminUsers.settingsAccess": "Settings Access",
      "adminUsers.specialPermissionsNote": "These permissions allow employees to access specific admin pages.",
      "adminUsers.failedToUpdatePermissions": "Failed to update permissions. Please try again.",
      "adminUsers.unsavedChanges": "You have unsaved changes",
      "adminUsers.saveChanges": "Save Changes",
      "adminUsers.saving": "Saving...",
      "accessDenied.title": "Access Denied",
      "accessDenied.autoparkMessage": "You don't have permission to access the Auto Park page.",
      "accessDenied.inventoryMessage": "You don't have permission to access the Inventory page.",
      "accessDenied.contractsMessage": "You don't have permission to access the Contracts page.",
      "accessDenied.contactAdmin": "Please contact your administrator to request access.",
      "employeeAccess.restrictedAccess": "Restricted Access",
      "employeeAccess.autoparkDescription": "You have limited access to Auto Park management.",
      "employeeAccess.inventoryDescription": "You have limited access to Inventory management.",
      "employeeAccess.contractsDescription": "You have limited access to Contracts management.",
      "adminUsers.employee": "Employee",
      "adminUsers.admin": "Admin",
      "adminResources.resourcesManagement": "Resources Management",
      "adminResources.manageBusinessResources": "Manage all your resources for activities",
      "adminResources.addNewResource": "Add New Resource",
      "adminResources.searchResources": "Search resources...",
      "adminResources.resourceName": "Resource Name",
      "adminResources.actions": "Actions",
      "adminResources.deleteResource": "Delete Resource",
      "adminResources.noResourcesFound": "No resources found",
      "adminResources.tryAdjustingSearch": "Try adjusting your search criteria.",
      "adminResources.getStartedCreatingResource": "Get started by creating a new resource.",
      "adminResources.totalResources": "Total Resources",
      "adminResources.enterResourceName": "Enter resource name",
      "adminResources.cancel": "Cancel",
      "adminResources.createResource": "Create Resource",
      "allNotifications.notifications": "Notifications",
      "allNotifications.viewAndManageNotifications": "View and manage all your notifications",
      "allNotifications.unread": "Unread",
      "allNotifications.totalNotifications": "Total Notifications",
      "allNotifications.noNotifications": "No notifications",
      "allNotifications.allCaughtUp": "You're all caught up! No new notifications.",
      "allNotifications.status": "Status",
      "allNotifications.message": "Message",
      "allNotifications.date": "Date",
      "allNotifications.actions": "Actions",
      "allNotifications.read": "Read",
      "allNotifications.markAsRead": "Mark as read",
      "adminSettings.advancedSettings": "Advanced Settings",
      "adminSettings.manageUserPermissions": "Manage user permissions, roles and access control",
      "adminSettings.permissions": "Permissions",
      "adminSettings.roleManagement": "Role Management",
      "adminSettings.customRoles": "Custom Roles",
      "adminSettings.users": "Users",
      "adminSettings.loadingUsers": "Loading users...",
      "adminSettings.noUsersFound": "No users found",
      "adminSettings.noUserSelected": "No user selected",
      "adminSettings.selectUserToConfigure": "Please select a user from the list to configure their settings.",
      "adminSettings.custom": "Custom",
      "adminSettings.active": "Active",
      "adminSettings.inactive": "Inactive",
      "adminSettings.pagePermissions": "Page Permissions",
      "adminSettings.readOnlyMode": "Read-Only Mode",
      "adminSettings.fullAccess": "Full Access",
      "adminSettings.page": "Page",
      "adminSettings.access": "Access",
      "adminSettings.selectAll": "Select All",
      "adminSettings.restrictUserToViewOnly": "Restrict user to view-only access",
      "adminSettings.saveChanges": "Save Changes",
      "adminSettings.roleHierarchyAndPermissions": "Role Hierarchy & Permissions",
      "adminSettings.roleHierarchy": "Role Hierarchy",
      "adminSettings.level": "Level",
      "adminSettings.canManage": "Can Manage",
      "adminSettings.cannotManage": "Cannot Manage",
      "adminSettings.defaultPermissions": "Default Permissions",
      "adminSettings.pagesAccessible": "pages accessible",
      "adminSettings.customRoleManagement": "Custom Role Management",
      "adminSettings.removeCustomRole": "Remove Custom Role",
      "adminSettings.assignCustomRole": "Assign Custom Role",
      "adminSettings.currentCustomRole": "Current Custom Role",
      "adminSettings.createCustomRole": "Create Custom Role",
      "adminSettings.roleName": "Role Name",
      "adminSettings.enterCustomRoleName": "Enter custom role name",
      "adminSettings.description": "Description",
      "adminSettings.describeCustomRole": "Describe this custom role",
      "adminSettings.cancel": "Cancel",
      "adminUsers.admin": "Administrator",
      "adminUsers.employee": "Employee",
"invoices.dashboard": "Dashboard",
"invoices.invoiceList": "Invoice List",
"invoices.company": "Company",
"invoices.partners": "Partners",
"invoices.creditNotes": "Credit Notes",
"invoices.debitNotes": "Debit Notes",
"invoices.reports": "Reports",
"invoices.incomingInvoices": "Incoming Invoices",
"invoices.financeDashboard": "Finance Dashboard",
"invoices.manageInvoicesCompanyPartners": "Manage your invoices, company details, and partners",
"invoiceDashboard.failedToLoadDashboardData": "Failed to load dashboard data",
"invoiceDashboard.loadingDashboard": "Loading dashboard...",
"invoiceDashboard.totalPartners": "Total Partners",
"invoiceDashboard.active": "Active",
"invoiceDashboard.totalInvoices": "Total Invoices",
"invoiceDashboard.paid": "Paid",
"invoiceDashboard.sentInvoices": "Sent Invoices",
"invoiceDashboard.overdue": "Overdue",
"invoiceDashboard.totalPaymentsReceived": "Total Payments Received",
"invoiceDashboard.fromAllInvoices": "From all invoices",
"invoiceDashboard.recentInvoices": "Recent Invoices",
"invoiceDashboard.viewAll": "View All",
"invoiceDashboard.noInvoicesYet": "No invoices yet",
"invoiceDashboard.createFirstInvoice": "Create First Invoice",
"invoiceDashboard.unknownPartner": "Unknown Partner",
"invoiceDashboard.due": "Due",
"invoiceDashboard.viewInvoiceDetails": "View Invoice Details",
"invoiceDashboard.quickActions": "Quick Actions",
"invoiceDashboard.createInvoice": "Create Invoice",
"invoiceDashboard.addPartner": "Add Partner",
"invoiceDashboard.viewAllInvoices": "View All Invoices",
"invoiceDashboard.invoiceStatus": "Invoice Status",
"invoiceDashboard.draft": "Draft",
"invoiceDashboard.sent": "Sent",
"invoiceDashboard.partial": "Partial",
"invoiceDashboard.statusDraft": "Draft",
"invoiceDashboard.statusSent": "Sent", 
"invoiceDashboard.statusPaid": "Paid",
"invoiceDashboard.statusPartial": "Partial",
"invoiceDashboard.statusOverdue": "Overdue",
"invoiceList.failedToFetchInvoices": "Failed to fetch invoices",
"invoiceList.failedToLoadInvoices": "Failed to load invoices",
"invoiceList.failedToDeleteInvoice": "Failed to delete invoice",
"invoiceList.invoiceDeletedSuccessfully": "Invoice deleted successfully!",
"invoiceList.failedToUpdateInvoiceStatus": "Failed to update invoice status",
"invoiceList.invoiceStatusUpdatedSuccessfully": "Invoice status updated successfully!",
"invoiceList.failedToDownloadInvoiceAsPDF": "Failed to download invoice as PDF",
"invoiceList.invoiceDownloadedSuccessfully": "Invoice downloaded as {{type}} PDF successfully!",
"invoiceList.failedToLoadInvoiceForPrinting": "Failed to load invoice for printing",
"invoiceList.failedToPrintInvoice": "Failed to print invoice",
"invoiceList.invoices": "Invoices",
"invoiceList.manageInvoicesTrackPayments": "Manage your invoices, track payments, and monitor financial performance",
"invoiceList.newInvoice": "New Invoice",
"invoiceList.searchInvoicesItemsNotes": "Search invoices, items, notes...",
"invoiceList.allStatus": "All Status",
"invoiceList.draft": "Draft",
"invoiceList.sent": "Sent",
"invoiceList.partial": "Partial",
"invoiceList.paid": "Paid",
"invoiceList.overdue": "Overdue",
"invoiceList.cancelled": "Cancelled",
"invoiceList.allPartners": "All Partners",
"invoiceList.allCompanies": "All Companies",
"invoiceList.allProjects": "All Projects",
"invoiceList.loadingInvoices": "Loading invoices...",
"invoiceList.noInvoicesFound": "No invoices found",
"invoiceList.createFirstInvoice": "Create First Invoice",
"invoiceList.invoicesFound": "{{count}} invoice{{count !== 1 ? 's' : ''}} found",
"invoiceList.invoice": "Invoice",
"invoiceList.partner": "Partner",
"invoiceList.project": "Project",
"invoiceList.amount": "Amount",
"invoiceList.status": "Status",
"invoiceList.issueDate": "Issue Date",
"invoiceList.dueDate": "Due Date",
"invoiceList.actions": "Actions",
"invoiceList.unknownCompany": "Unknown Company",
"invoiceList.unknownPartner": "Unknown Partner",
"invoiceList.noProject": "No Project",
"invoiceList.itemsCount": "{{count}} items",
"invoiceList.statusDraft": "Draft",
"invoiceList.statusSent": "Sent",
"invoiceList.statusPartial": "Partial",
"invoiceList.statusPaid": "Paid",
"invoiceList.statusOverdue": "Overdue",
"invoiceList.statusCancelled": "Cancelled",
"invoiceList.downloadOriginal": "Download Original",
"invoiceList.downloadCopy": "Download Copy",
"invoiceList.printOriginal": "Print Original",
"invoiceList.printCopy": "Print Copy",
"invoiceList.previous": "Previous",
"invoiceList.next": "Next",
"invoiceList.showingResults": "Showing <span class=\"font-medium\">{{start}}</span> to <span class=\"font-medium\">{{end}}</span> of <span class=\"font-medium\">{{total}}</span> results",
"invoiceList.deleteInvoice": "Delete Invoice",
"invoiceList.deleteInvoiceConfirmation": "Are you sure you want to delete invoice <strong>{{invoiceNumber}}</strong>? This action cannot be undone.",
"invoiceList.cancel": "Cancel",
"invoiceList.deleting": "Deleting...",
"invoiceList.delete": "Delete",
"invoiceList.oneInvoiceFound": "1 invoice found",
"invoiceList.multipleInvoicesFound": "{{count}} invoices found",
"invoiceCreate.loadingInvoiceForm": "Loading invoice form...",
"invoiceCreate.failedToLoadData": "Failed to load partners and companies data",
"invoiceCreate.pleaseSelectPartner": "Please select a partner",
"invoiceCreate.pleaseFillItemDescriptions": "Please fill in all item descriptions",
"invoiceCreate.invoiceCreatedSuccessfully": "Invoice created successfully!",
"invoiceCreate.failedToCreateInvoice": "Failed to create invoice",
"invoiceCreate.createNewInvoice": "Create New Invoice",
"invoiceCreate.createProfessionalInvoice": "Create a professional invoice for your client",
"invoiceCreate.invoiceDetails": "Invoice Details",
"invoiceCreate.company": "Company",
"invoiceCreate.selectCompany": "Select a company",
"invoiceCreate.bankAccountForPayment": "Bank Account for Payment",
"invoiceCreate.selectBankAccount": "Select bank account",
"invoiceCreate.default": "(Default)",
"invoiceCreate.partnerClient": "Partner/Client",
"invoiceCreate.selectPartner": "Select a partner",
"invoiceCreate.project": "Project",
"invoiceCreate.optional": "Optional",
"invoiceCreate.selectProjectOptional": "Select a project (optional)",
"invoiceCreate.currency": "Currency",
"invoiceCreate.bgnBulgarianLev": "BGN (Bulgarian Lev)",
"invoiceCreate.eurEuro": "EUR (Euro)",
"invoiceCreate.usdUsDollar": "USD (US Dollar)",
"invoiceCreate.issueDate": "Issue Date",
"invoiceCreate.dueDate": "Due Date",
"invoiceCreate.dateFormat": "DD.MM.YYYY",
"invoiceCreate.items": "Items",
"invoiceCreate.addItem": "Add Item",
"invoiceCreate.description": "Description",
"invoiceCreate.chars": "chars",
"invoiceCreate.itemDescription": "Item description",
"invoiceCreate.quantity": "Quantity",
"invoiceCreate.unitPrice": "Unit Price",
"invoiceCreate.total": "Total",
"invoiceCreate.invoiceSummary": "Invoice Summary",
"invoiceCreate.subtotal": "Subtotal",
"invoiceCreate.taxAmount": "Tax Amount",
"invoiceCreate.totalAmount": "Total Amount",
"invoiceCreate.euroConversion": "Euro (1 EUR = 1.95583 BGN)",
"invoiceCreate.additionalNotes": "Additional Notes",
"invoiceCreate.notes": "Notes",
"invoiceCreate.addNotesPlaceholder": "Add any additional notes or terms...",
"invoiceCreate.cancel": "Cancel",
"invoiceCreate.creatingInvoice": "Creating Invoice...",
"invoiceCreate.createInvoice": "Create Invoice",
"invoiceDetails.loadingInvoiceDetails": "Loading invoice details...",
"invoiceDetails.invoiceNotFound": "Invoice not found",
"invoiceDetails.backToInvoiceList": "Back to Invoice List",
"invoiceDetails.failedToLoadInvoiceDetails": "Failed to load invoice details",
"invoiceDetails.failedToDeleteInvoice": "Failed to delete invoice",
"invoiceDetails.failedToUpdateInvoiceStatus": "Failed to update invoice status",
"invoiceDetails.failedToRecordPayment": "Failed to record payment",
"invoiceDetails.failedToDownloadInvoiceAsPDF": "Failed to download invoice as PDF",
"invoiceDetails.failedToLoadInvoiceForPrinting": "Failed to load invoice for printing",
"invoiceDetails.failedToPrintInvoice": "Failed to print invoice",
"invoiceDetails.invoiceDeletedSuccessfully": "Invoice deleted successfully",
"invoiceDetails.invoiceStatusUpdatedSuccessfully": "Invoice status updated successfully",
"invoiceDetails.paymentRecordedSuccessfully": "Payment recorded successfully",
"invoiceDetails.invoiceDownloadedSuccessfully": "Invoice downloaded successfully",
"invoiceDetails.pleaseEnterValidPaymentAmount": "Please enter a valid payment amount",
"invoiceDetails.invoiceDetails": "Invoice Details",
"invoiceDetails.invoiceInformation": "Invoice Information",
"invoiceDetails.lineItems": "Line Items",
"invoiceDetails.notes": "Notes",
"invoiceDetails.companyAndPartner": "Company & Partner",
"invoiceDetails.paymentStatus": "Payment Status",
"invoiceDetails.statusActions": "Status Actions",
"invoiceDetails.paymentHistory": "Payment History",
"invoiceDetails.invoiceNumber": "Invoice Number",
"invoiceDetails.invoiceType": "Invoice Type",
"invoiceDetails.status": "Status",
"invoiceDetails.issueDate": "Issue Date",
"invoiceDetails.dueDate": "Due Date",
"invoiceDetails.currency": "Currency",
"invoiceDetails.project": "Project",
"invoiceDetails.description": "Description",
"invoiceDetails.quantity": "Quantity",
"invoiceDetails.unitPrice": "Unit Price",
"invoiceDetails.total": "Total",
"invoiceDetails.subtotal": "Subtotal",
"invoiceDetails.taxAmount": "Tax Amount",
"invoiceDetails.totalAmount": "Total Amount",
"invoiceDetails.fromCompany": "From (Company)",
"invoiceDetails.toPartner": "To (Partner)",
"invoiceDetails.taxId": "Tax ID",
"invoiceDetails.vatTaxId": "VAT Tax ID",
"invoiceDetails.contact": "Contact",
"invoiceDetails.email": "Email",
"invoiceDetails.noProjectAssigned": "No project assigned",
"invoiceDetails.amountPaid": "Amount Paid",
"invoiceDetails.remaining": "Remaining",
"invoiceDetails.recordPayment": "Record Payment",
"invoiceDetails.amount": "Amount",
"invoiceDetails.paymentMethod": "Payment Method",
"invoiceDetails.reference": "Reference",
"invoiceDetails.date": "Date",
"invoiceDetails.method": "Method",
"invoiceDetails.euroEquivalent": "Euro Equivalent",
"invoiceDetails.total": "Total",
"invoiceDetails.paid": "Paid",
"invoiceDetails.markAsSent": "Mark as Sent",
"invoiceDetails.markAsPaid": "Mark as Paid",
"invoiceDetails.markAsDraft": "Mark as Draft",
"invoiceDetails.deleteInvoice": "Delete Invoice",
"invoiceDetails.deleteInvoiceConfirmation": "Are you sure you want to delete invoice",
"invoiceDetails.deleteInvoiceWarning": "This action cannot be undone.",
"invoiceDetails.cancel": "Cancel",
"invoiceDetails.delete": "Delete",
"invoiceDetails.referenceOptional": "Reference (Optional)",
"invoiceDetails.transactionReference": "Transaction reference",
"invoiceDetails.recording": "Recording...",
"invoiceDetails.max": "Max",
"invoiceDetails.downloadAsPDF": "Download as PDF",
"invoiceDetails.downloadOriginal": "Download Original",
"invoiceDetails.downloadCopy": "Download Copy",
"invoiceDetails.printPDF": "Print PDF",
"invoiceDetails.printOriginal": "Print Original",
"invoiceDetails.printCopy": "Print Copy",
"invoiceDetails.overdue": "Overdue",
"invoiceDetails.bankTransfer": "Bank Transfer",
"invoiceDetails.cash": "Cash",
"invoiceDetails.card": "Card",
"invoiceDetails.check": "Check",
"invoiceDetails.statusPaid": "Paid",
"invoiceDetails.statusSent": "Sent",
"invoiceDetails.statusPartial": "Partial",
"invoiceDetails.statusOverdue": "Overdue",
"invoiceDetails.statusDraft": "Draft",
"invoiceDetails.invoiceTypeORIGINAL": "ORIGINAL",
"invoiceDetails.invoiceTypeCOPY": "COPY",
"companyManagement.failedToLoadCompanies": "Failed to load companies",
"companyManagement.pleaseFillAllRequiredFields": "Please fill in all required fields",
"companyManagement.bankAccountUpdatedSuccessfully": "Bank account {action} successfully!",
"companyManagement.updated": "updated",
"companyManagement.added": "added",
"companyManagement.confirmDeleteBankAccount": "Are you sure you want to delete this bank account?",
"companyManagement.bankAccountDeletedSuccessfully": "Bank account deleted successfully!",
"companyManagement.defaultBankAccountUpdatedSuccessfully": "Default bank account updated successfully!",
"companyManagement.eitherTaxIdOrVatTaxIdRequired": "Either Tax ID or VAT Tax ID must be provided",
"companyManagement.companySavedSuccessfully": "Company {action} successfully!",
"companyManagement.created": "created",
"companyManagement.failedToSaveCompany": "Failed to save company",
"companyManagement.confirmDeleteCompany": "Are you sure you want to delete this company? This action cannot be undone.",
"companyManagement.companyDeletedSuccessfully": "Company deleted successfully!",
"companyManagement.failedToDeleteCompany": "Failed to delete company",
"companyManagement.loadingCompanies": "Loading companies...",
"companyManagement.companies": "Companies",
"companyManagement.manageCompanyInformation": "Manage your company information and settings",
"companyManagement.addCompany": "Add Company",
"companyManagement.noCompaniesFound": "No companies found",
"companyManagement.addYourFirstCompany": "Add your first company",
"companyManagement.companiesFound": "{count} compan{plural} found",
"companyManagement.company": "Company",
"companyManagement.contact": "Contact",
"companyManagement.location": "Location",
"companyManagement.mrp": "MRP",
"companyManagement.bankAccounts": "Bank Accounts",
"companyManagement.actions": "Actions",
"companyManagement.taxId": "Tax ID",
"companyManagement.vatTaxId": "VAT Tax ID",
"companyManagement.notSpecified": "Not specified",
"companyManagement.bankAccountsCount": "{count} account{plural}",
"companyManagement.defaultSet": "Default set",
"companyManagement.noDefault": "No default",
"companyManagement.editCompany": "Edit Company",
"companyManagement.addNewCompany": "Add New Company",
"companyManagement.companyInformation": "Company Information",
"companyManagement.companyName": "Company Name",
"companyManagement.taxIdRequired": "Tax ID (required if no VAT Tax ID)",
"companyManagement.vatTaxIdRequired": "VAT Tax ID (ИН по ДДС) (required if no Tax ID)",
"companyManagement.city": "City",
"companyManagement.address": "Address",
"companyManagement.mrpName": "MRP Name",
"companyManagement.country": "Country",
"companyManagement.contactInformation": "Contact Information",
"companyManagement.contactEmail": "Contact Email",
"companyManagement.contactPhone": "Contact Phone",
"companyManagement.website": "Website",
"companyManagement.logoUrl": "Logo URL",
"companyManagement.addBank": "Add Bank",
"companyManagement.noBankAccountsAdded": "No bank accounts added yet",
"companyManagement.default": "Default",
"companyManagement.invoiceSettings": "Invoice Settings",
"companyManagement.defaultCurrency": "Default Currency",
"companyManagement.bgnBulgarianLev": "BGN (Bulgarian Lev)",
"companyManagement.eurEuro": "EUR (Euro)",
"companyManagement.usdUsDollar": "USD (US Dollar)",
"companyManagement.defaultTaxRate": "Default Tax Rate",
"companyManagement.percent": "%",
"companyManagement.paymentTerms": "Payment Terms",
"companyManagement.days": "Days",
"companyManagement.invoiceNumberPrefix": "Invoice Number Prefix",
"companyManagement.cancel": "Cancel",
"companyManagement.saving": "Saving...",
"companyManagement.updateCompany": "Update Company",
"companyManagement.createCompany": "Create Company",
"companyManagement.editBankAccount": "Edit Bank Account",
"companyManagement.addBankAccount": "Add Bank Account",
"companyManagement.bankName": "Bank Name",
"companyManagement.swiftCode": "SWIFT Code",
"companyManagement.iban": "IBAN",
"companyManagement.setAsDefaultBankAccount": "Set as default bank account",
"companyManagement.update": "Update",
"companyManagement.companyFound": "company found",
"companyManagement.companiesFound": "companies found",
"companyManagement.bankAccount": "account",
"companyManagement.bankAccounts": "accounts",
"partnerManagement.failedToLoadPartners": "Failed to load partners",
"partnerManagement.eitherTaxIdOrVatTaxIdRequired": "Either Tax ID or VAT Tax ID must be provided",
"partnerManagement.partnerUpdatedSuccessfully": "Partner updated successfully!",
"partnerManagement.partnerCreatedSuccessfully": "Partner created successfully!",
"partnerManagement.failedToSavePartner": "Failed to save partner",
"partnerManagement.confirmDeletePartner": "Are you sure you want to delete this partner?",
"partnerManagement.partnerDeletedSuccessfully": "Partner deleted successfully!",
"partnerManagement.failedToDeletePartner": "Failed to delete partner",
"partnerManagement.partners": "Partners",
"partnerManagement.manageBusinessPartners": "Manage your business partners and clients",
"partnerManagement.addPartner": "Add Partner",
"partnerManagement.searchPartners": "Search partners...",
"partnerManagement.allStatus": "All Status",
"partnerManagement.statusActive": "Active",
"partnerManagement.statusInactive": "Inactive",
"partnerManagement.loadingPartners": "Loading partners...",
"partnerManagement.noPartnersFound": "No partners found",
"partnerManagement.addYourFirstPartner": "Add your first partner",
"partnerManagement.partnerFound": "partner found",
"partnerManagement.partnersFound": "partners found",
"partnerManagement.partner": "Partner",
"partnerManagement.contact": "Contact",
"partnerManagement.location": "Location",
"partnerManagement.status": "Status",
"partnerManagement.paymentTerms": "Payment Terms",
"partnerManagement.bankDetails": "Bank Details",
"partnerManagement.actions": "Actions",
"partnerManagement.taxId": "Tax ID",
"partnerManagement.vatTaxId": "VAT Tax ID",
"partnerManagement.days": "days",
"partnerManagement.notSpecified": "Not specified",
"partnerManagement.previous": "Previous",
"partnerManagement.next": "Next",
"partnerManagement.showing": "Showing",
"partnerManagement.to": "to",
"partnerManagement.of": "of",
"partnerManagement.results": "results",
"partnerManagement.editPartner": "Edit Partner",
"partnerManagement.addNewPartner": "Add New Partner",
"partnerManagement.partnerName": "Partner Name",
"partnerManagement.taxIdRequired": "Tax ID (required if no VAT Tax ID)",
"partnerManagement.vatTaxIdRequired": "VAT Tax ID (ИН по ДДС) (required if no Tax ID)",
"partnerManagement.address": "Address",
"partnerManagement.city": "City",
"partnerManagement.country": "Country",
"partnerManagement.contactPerson": "Contact Person",
"partnerManagement.email": "Email",
"partnerManagement.phone": "Phone",
"partnerManagement.creditLimit": "Credit Limit",
"partnerManagement.bankName": "Bank Name",
"partnerManagement.swiftCode": "SWIFT Code",
"partnerManagement.iban": "IBAN",
"partnerManagement.notes": "Notes",
"partnerManagement.cancel": "Cancel",
"partnerManagement.saving": "Saving...",
"partnerManagement.updatePartner": "Update Partner",
"partnerManagement.createPartner": "Create Partner",
"reports.authenticationFailed": "Authentication failed. Please log in again.",
"reports.failedToLoadReportsData": "Failed to load reports data",
"reports.reportGeneratedSuccessfully": "{type} report generated successfully!",
"reports.failedToGenerateReport": "Failed to generate report",
"reports.overdueAlertSentSuccessfully": "Overdue alert sent successfully!",
"reports.failedToSendAlert": "Failed to send alert",
"reports.failedToSendOverdueAlert": "Failed to send overdue alert",
"reports.loadingReports": "Loading reports...",
"reports.financialReportsAndAnalytics": "Financial Reports & Analytics",
"reports.comprehensiveFinancialInsights": "Comprehensive financial insights, revenue analysis, and overdue monitoring",
"reports.exportRevenueReport": "Export Revenue Report",
"reports.exportOverdueReport": "Export Overdue Report",
"reports.dateRange": "Date Range",
"reports.lastWeek": "Last Week",
"reports.lastMonth": "Last Month",
"reports.lastQuarter": "Last Quarter",
"reports.lastYear": "Last Year",
"reports.company": "Company",
"reports.allCompanies": "All Companies",
"reports.partner": "Partner",
"reports.allPartners": "All Partners",
"reports.applyFilters": "Apply Filters",
"reports.analyticsDashboard": "Analytics Dashboard",
"reports.revenueReports": "Revenue Reports",
"reports.overdueAlerts": "Overdue Alerts",
"reports.alertSettings": "Alert Settings",
"reports.totalRevenue": "Total Revenue",
"reports.paymentsReceived": "Payments Received",
"reports.outstanding": "Outstanding",
"reports.totalInvoiceAmount": "Total Invoice Amount",
"reports.revenueTrend": "Revenue Trend",
"reports.invoiceStatusDistribution": "Invoice Status Distribution",
"reports.topPartnersByRevenue": "Top Partners by Revenue",
"reports.monthlyRevenueReport": "Monthly Revenue Report",
"reports.comprehensiveMonthlyRevenueAnalysis": "Comprehensive monthly revenue analysis with partner breakdown",
"reports.generateReport": "Generate Report",
"reports.partnerPerformanceReport": "Partner Performance Report",
"reports.detailedAnalysisOfPartnerPayment": "Detailed analysis of partner payment behavior and revenue contribution",
"reports.collectionEfficiencyReport": "Collection Efficiency Report",
"reports.analysisOfPaymentCollectionRates": "Analysis of payment collection rates and outstanding amounts",
"reports.revenueSummary": "Revenue Summary",
"reports.averageInvoice": "Average Invoice",
"reports.overdueInvoices": "Overdue Invoices",
"reports.exportReport": "Export Report",
"reports.noOverdueInvoicesFound": "No overdue invoices found!",
"reports.invoice": "Invoice",
"reports.amount": "Amount",
"reports.dueDate": "Due Date",
"reports.daysOverdue": "Days Overdue",
"reports.severity": "Severity",
"reports.actions": "Actions",
"reports.unknownPartner": "Unknown Partner",
"reports.days": "days",
"reports.sendAlert": "Send Alert",
"reports.viewInvoice": "View Invoice",
"reports.overdueAlertSettings": "Overdue Alert Settings",
"reports.enableOverdueAlerts": "Enable Overdue Alerts",
"reports.automaticallySendAlerts": "Automatically send alerts for overdue invoices",
"reports.earlyWarning": "Early Warning",
"reports.moderateAlert": "Moderate Alert",
"reports.criticalAlert": "Critical Alert",
"reports.alertSettingsSavedSuccessfully": "Alert settings saved successfully!",
"reports.saveSettings": "Save Settings",
"reports.severityHigh": "HIGH",
"reports.severityMedium": "MEDIUM", 
"reports.severityLow": "LOW",
"incomingInvoices.failedToLoadIncomingInvoices": "Failed to load incoming invoices",
"incomingInvoices.invoiceUploadedSuccessfully": "Invoice uploaded successfully! Please review it below.",
"incomingInvoices.uploadFailed": "Upload failed",
"incomingInvoices.failedToUploadInvoice": "Failed to upload invoice",
"incomingInvoices.partnerCreatedSuccessfully": "Partner created successfully!",
"incomingInvoices.partnerCreatedSuccessfullyInvoicePending": "Partner created successfully! Invoice is now in pending review.",
"incomingInvoices.failedToCreatePartner": "Failed to create partner",
"incomingInvoices.confirmDeleteInvoice": "Are you sure you want to delete this invoice?",
"incomingInvoices.invoiceDeletedSuccessfully": "Invoice deleted successfully!",
"incomingInvoices.failedToDeleteInvoice": "Failed to delete invoice",
"incomingInvoices.invoiceApprovedSuccessfully": "Invoice approved successfully!",
"incomingInvoices.failedToApproveInvoice": "Failed to approve invoice",
"incomingInvoices.provideRejectionReason": "Please provide a reason for rejection:",
"incomingInvoices.invoiceRejectedSuccessfully": "Invoice rejected successfully!",
"incomingInvoices.failedToRejectInvoice": "Failed to reject invoice",
"incomingInvoices.loadingIncomingInvoices": "Loading incoming invoices...",
"incomingInvoices.incomingInvoices": "Incoming Invoices",
"incomingInvoices.uploadAndManageIncomingInvoices": "Upload and manage incoming invoices with OCR processing",
"incomingInvoices.uploadInvoice": "Upload Invoice",
"incomingInvoices.incomingInvoicesList": "Incoming Invoices List",
"incomingInvoices.uploadAFile": "Upload a file",
"incomingInvoices.orDragAndDrop": "or drag and drop",
"incomingInvoices.fileTypesSupported": "PNG, JPG, PDF up to 10MB",
"incomingInvoices.processingInvoice": "Processing invoice...",
"incomingInvoices.pendingReview": "Pending Review",
"incomingInvoices.invoice": "invoice",
"incomingInvoices.invoices": "invoices",
"incomingInvoices.awaitingReview": "awaiting review",
"incomingInvoices.noInvoicesPendingReview": "No invoices pending review",
"incomingInvoices.uploadInvoiceToStartReview": "Upload an invoice to start the review process",
"incomingInvoices.supplier": "Supplier",
"incomingInvoices.amount": "Amount",
"incomingInvoices.uploaded": "Uploaded",
"incomingInvoices.actions": "Actions",
"incomingInvoices.viewDetails": "View Details",
"incomingInvoices.approve": "Approve",
"incomingInvoices.reject": "Reject",
"incomingInvoices.searchInvoices": "Search invoices...",
"incomingInvoices.allPartners": "All Partners",
"incomingInvoices.allPaymentTypes": "All Payment Types",
"incomingInvoices.paymentTypeCash": "Cash",
"incomingInvoices.paymentTypeBankTransfer": "Bank Transfer",
"incomingInvoices.paymentTypeUnknown": "Unknown",
"incomingInvoices.clearFilters": "Clear Filters",
"incomingInvoices.incomingInvoice": "incoming invoice",
"incomingInvoices.found": "found",
"incomingInvoices.noIncomingInvoicesYet": "No incoming invoices yet",
"incomingInvoices.noInvoicesMatchFilters": "No invoices match your filters",
"incomingInvoices.uploadInvoiceToGetStarted": "Upload an invoice to get started",
"incomingInvoices.tryAdjustingSearchOrFilters": "Try adjusting your search or filters",
"incomingInvoices.issueDate": "Issue Date",
"incomingInvoices.dueDate": "Due Date",
"incomingInvoices.status": "Status",
"incomingInvoices.paymentType": "Payment Type",
"incomingInvoices.edit": "Edit",
"incomingInvoices.delete": "Delete",
"incomingInvoices.createNewPartner": "Create New Partner",
"incomingInvoices.newSupplierDetected": "A new supplier was detected. Please review and confirm the partner details.",
"incomingInvoices.supplierNameNotExtracted": "Supplier name could not be extracted automatically. Please enter the partner details manually.",
"incomingInvoices.partnerName": "Partner Name",
"incomingInvoices.taxIdIfStartsWithoutBG": "Tax ID (if starts without BG)",
"incomingInvoices.vatTaxIdIfStartsWithBG": "VAT Tax ID (if starts with BG)",
"incomingInvoices.address": "Address",
"incomingInvoices.city": "City",
"incomingInvoices.country": "Country",
"incomingInvoices.mrp": "MRP",
"incomingInvoices.bankName": "Bank Name",
"incomingInvoices.swiftBicCode": "SWIFT/BIC Code",
"incomingInvoices.iban": "IBAN",
"incomingInvoices.email": "Email",
"incomingInvoices.phone": "Phone",
"incomingInvoices.cancel": "Cancel",
"incomingInvoices.createPartner": "Create Partner",
"incomingInvoices.statusPaid": "Paid",
"incomingInvoices.statusPending": "Pending",
"incomingInvoices.statusRejected": "Rejected",
"incomingInvoiceDetails.failedToFetchInvoiceDetails": "Failed to fetch invoice details",
"incomingInvoiceDetails.failedToLoadInvoiceDetails": "Failed to load invoice details",
"incomingInvoiceDetails.invoiceDeletedSuccessfully": "Invoice deleted successfully!",
"incomingInvoiceDetails.failedToDeleteInvoice": "Failed to delete invoice",
"incomingInvoiceDetails.invoiceStatusUpdatedSuccessfully": "Invoice status updated successfully!",
"incomingInvoiceDetails.failedToUpdateInvoiceStatus": "Failed to update invoice status",
"incomingInvoiceDetails.loadingInvoiceDetails": "Loading invoice details...",
"incomingInvoiceDetails.invoiceNotFound": "Invoice not found",
"incomingInvoiceDetails.backToIncomingInvoices": "Back to Incoming Invoices",
"incomingInvoiceDetails.incomingInvoiceDetails": "Incoming Invoice Details",
"incomingInvoiceDetails.invoiceInformation": "Invoice Information",
"incomingInvoiceDetails.invoiceNumber": "Invoice Number",
"incomingInvoiceDetails.invoiceType": "Invoice Type",
"incomingInvoiceDetails.original": "ORIGINAL",
"incomingInvoiceDetails.status": "Status",
"incomingInvoiceDetails.createdAt": "Created At",
"incomingInvoiceDetails.issueDate": "Issue Date",
"incomingInvoiceDetails.dueDate": "Due Date",
"incomingInvoiceDetails.currency": "Currency",
"incomingInvoiceDetails.paymentType": "Payment Type",
"incomingInvoiceDetails.unknown": "Unknown",
"incomingInvoiceDetails.lineItems": "Line Items",
"incomingInvoiceDetails.description": "Description",
"incomingInvoiceDetails.quantity": "Quantity",
"incomingInvoiceDetails.unitPrice": "Unit Price",
"incomingInvoiceDetails.total": "Total",
"incomingInvoiceDetails.noItemsExtractedFromOCR": "No items could be extracted from OCR data",
"incomingInvoiceDetails.subtotal": "Subtotal",
"incomingInvoiceDetails.vat": "VAT",
"incomingInvoiceDetails.totalAmount": "Total Amount",
"incomingInvoiceDetails.euroEquivalent": "Euro Equivalent",
"incomingInvoiceDetails.partnerDetails": "Partner Details",
"incomingInvoiceDetails.contact": "Contact",
"incomingInvoiceDetails.email": "Email",
"incomingInvoiceDetails.phone": "Phone",
"incomingInvoiceDetails.taxId": "Tax ID",
"incomingInvoiceDetails.vatTaxId": "VAT Tax ID",
"incomingInvoiceDetails.bank": "Bank",
"incomingInvoiceDetails.noPartnerDetailsAvailable": "No partner details available",
"incomingInvoiceDetails.paymentStatus": "Payment Status",
"incomingInvoiceDetails.amountPaid": "Amount Paid",
"incomingInvoiceDetails.remaining": "Remaining",
"incomingInvoiceDetails.paid": "Paid",
"incomingInvoiceDetails.statusActions": "Status Actions",
"incomingInvoiceDetails.markAsApproved": "Mark as Approved",
"incomingInvoiceDetails.markAsRejected": "Mark as Rejected",
"incomingInvoiceDetails.markAsPaid": "Mark as Paid",
"incomingInvoiceDetails.deleteInvoice": "Delete Invoice",
"incomingInvoiceDetails.confirmDeleteInvoice": "Are you sure you want to delete invoice",
"incomingInvoiceDetails.actionCannotBeUndone": "This action cannot be undone.",
"incomingInvoiceDetails.cancel": "Cancel",
"incomingInvoiceDetails.delete": "Delete",
"incomingInvoiceDetails.statusPaid": "Paid",
"incomingInvoiceDetails.statusPending": "Pending",
"incomingInvoiceDetails.statusApproved": "Approved",
"incomingInvoiceDetails.statusRejected": "Rejected",
"creditNoteCreate.failedToCreateCreditNote": "Failed to create credit note",
"creditNoteCreate.creditNoteCreatedSuccessfully": "Credit note created successfully!",
"creditNoteCreate.createCreditNote": "Create Credit Note",
"creditNoteCreate.createNewCreditNoteDescription": "Create a new credit note for returns, discounts, or corrections",
"creditNoteCreate.originalInvoice": "Original Invoice",
"creditNoteCreate.selectOriginalInvoice": "Select Original Invoice",
"creditNoteCreate.chooseAnInvoice": "Choose an invoice...",
"creditNoteCreate.selectedInvoiceDetails": "Selected Invoice Details",
"creditNoteCreate.invoiceNumber": "Invoice Number",
"creditNoteCreate.partner": "Partner",
"creditNoteCreate.issueDate": "Issue Date",
"creditNoteCreate.totalAmount": "Total Amount",
"creditNoteCreate.creditNoteDetails": "Credit Note Details",
"creditNoteCreate.dueDate": "Due Date",
"creditNoteCreate.currency": "Currency",
"creditNoteCreate.items": "Items",
"creditNoteCreate.addItem": "Add Item",
"creditNoteCreate.description": "Description",
"creditNoteCreate.itemDescription": "Item description",
"creditNoteCreate.quantity": "Quantity",
"creditNoteCreate.unitPrice": "Unit Price",
"creditNoteCreate.total": "Total",
"creditNoteCreate.summary": "Summary",
"creditNoteCreate.subtotal": "Subtotal",
"creditNoteCreate.taxAmount": "Tax Amount",
"creditNoteCreate.notes": "Notes",
"creditNoteCreate.additionalNotesOrComments": "Additional notes or comments...",
"creditNoteCreate.cancel": "Cancel",
"creditNoteCreate.creating": "Creating...",
"creditNoteCreate.createCreditNote": "Create Credit Note",
"creditNoteList.failedToFetchCreditNotes": "Failed to fetch credit notes",
"creditNoteList.failedToLoadCreditNotes": "Failed to load credit notes",
"creditNoteList.failedToDownloadCreditNoteAsPDF": "Failed to download credit note as PDF",
"creditNoteList.creditNoteDownloadedSuccessfully": "Credit note downloaded as {type} PDF successfully!",
"creditNoteList.failedToLoadCreditNoteForPrinting": "Failed to load credit note for printing",
"creditNoteList.failedToPrintCreditNote": "Failed to print credit note",
"creditNoteList.confirmDeleteCreditNote": "Are you sure you want to delete this credit note?",
"creditNoteList.failedToDeleteCreditNote": "Failed to delete credit note",
"creditNoteList.creditNoteDeletedSuccessfully": "Credit note deleted successfully!",
"creditNoteList.creditNotes": "Credit Notes",
"creditNoteList.manageCreditNotesDescription": "Manage credit notes for returns, discounts, and corrections",
"creditNoteList.newCreditNote": "New Credit Note",
"creditNoteList.searchCreditNotes": "Search credit notes...",
"creditNoteList.allStatuses": "All Statuses",
"creditNoteList.statusDraft": "Draft",
"creditNoteList.statusSent": "Sent",
"creditNoteList.statusPaid": "Paid",
"creditNoteList.statusPartial": "Partial",
"creditNoteList.statusOverdue": "Overdue",
"creditNoteList.statusCancelled": "Cancelled",
"creditNoteList.allPartners": "All Partners",
"creditNoteList.allCompanies": "All Companies",
"creditNoteList.clearFilters": "Clear Filters",
"creditNoteList.creditNote": "credit note",
"creditNoteList.creditNotes": "credit notes",
"creditNoteList.found": "found",
"creditNoteList.originalInvoice": "Original Invoice",
"creditNoteList.partner": "Partner",
"creditNoteList.issueDate": "Issue Date",
"creditNoteList.dueDate": "Due Date",
"creditNoteList.amount": "Amount",
"creditNoteList.status": "Status",
"creditNoteList.actions": "Actions",
"creditNoteList.notAvailable": "N/A",
"creditNoteList.viewDetails": "View Details",
"creditNoteList.download": "Download",
"creditNoteList.downloadOriginal": "Download Original",
"creditNoteList.downloadCopy": "Download Copy",
"creditNoteList.print": "Print",
"creditNoteList.printOriginal": "Print Original",
"creditNoteList.printCopy": "Print Copy",
"creditNoteList.edit": "Edit",
"creditNoteList.delete": "Delete",
"creditNoteList.previous": "Previous",
"creditNoteList.next": "Next",
"creditNoteList.showing": "Showing",
"creditNoteList.to": "to",
"creditNoteList.of": "of",
"creditNoteList.results": "results",
"creditNoteList.noCreditNotes": "No credit notes",
"creditNoteList.getStartedByCreatingNewCreditNote": "Get started by creating a new credit note.",
"creditNoteDetails.creditNoteDetails": "Credit Note Details",
"creditNoteDetails.backToCreditNotes": "Back to Credit Notes",
"creditNoteDetails.downloadAsPDF": "Download as PDF",
"creditNoteDetails.downloadOriginal": "Download Original",
"creditNoteDetails.downloadCopy": "Download Copy",
"creditNoteDetails.printPDF": "Print PDF",
"creditNoteDetails.printOriginal": "Print Original",
"creditNoteDetails.printCopy": "Print Copy",
"creditNoteDetails.creditNoteInformation": "Credit Note Information",
"creditNoteDetails.items": "Items",
"creditNoteDetails.summary": "Summary",
"creditNoteDetails.notes": "Notes",
"creditNoteDetails.companyInformation": "Company (Supplier)",
"creditNoteDetails.partnerInformation": "Partner (Recipient)",
"creditNoteDetails.bankAccountInformation": "Bank Account",
"creditNoteDetails.creditNoteNumber": "Credit Note Number",
"creditNoteDetails.originalInvoice": "Original Invoice",
"creditNoteDetails.issueDate": "Issue Date",
"creditNoteDetails.dueDate": "Due Date",
"creditNoteDetails.status": "Status",
"creditNoteDetails.currency": "Currency",
"creditNoteDetails.type": "Type",
"creditNoteDetails.no": "No",
"creditNoteDetails.description": "Description",
"creditNoteDetails.quantity": "Quantity",
"creditNoteDetails.unitPrice": "Unit Price",
"creditNoteDetails.total": "Total",
"creditNoteDetails.bgn": "BGN",
"creditNoteDetails.eur": "EUR",
"creditNoteDetails.subtotal": "Subtotal",
"creditNoteDetails.taxAmount": "Tax Amount (20%)",
"creditNoteDetails.totalAmount": "Total Amount",
"creditNoteDetails.mol": "MOL",
"creditNoteDetails.vatTaxId": "VAT Tax ID",
"creditNoteDetails.taxId": "Tax ID",
"creditNoteDetails.contact": "Contact",
"creditNoteDetails.bank": "Bank",
"creditNoteDetails.bic": "BIC",
"creditNoteDetails.iban": "IBAN",
"creditNoteDetails.authenticationRequired": "Authentication Required",
"creditNoteDetails.pleaseLoginToContinue": "Please log in to continue viewing credit note details.",
"creditNoteDetails.refreshAndLogin": "Refresh and Login",
"creditNoteDetails.noTokenError": "No authentication token found. Please log in again.",
"creditNoteDetails.authenticationError": "Authentication error: JWT expired",
"creditNoteDetails.pleaseLoginAgain": "Please log in again to continue.",
"creditNoteDetails.failedToFetchCreditNote": "Failed to fetch credit note",
"creditNoteDetails.failedToLoadCreditNoteDetails": "Failed to load credit note details",
"creditNoteDetails.creditNoteNotFound": "Credit note not found",
"creditNoteDetails.failedToDownloadCreditNote": "Failed to download credit note",
"creditNoteDetails.downloadSuccess": "Credit note downloaded as {type} PDF successfully!",
"creditNoteDetails.failedToPrintCreditNote": "Failed to print credit note",
"creditNoteDetails.printSuccess": "Credit note printed as {type} successfully!",
"creditNoteDetails.statusDraft": "Draft",
"creditNoteDetails.statusSent": "Sent",
"creditNoteDetails.statusPaid": "Paid", 
"creditNoteDetails.statusPartial": "Partial",
"creditNoteDetails.statusOverdue": "Overdue",
"creditNoteDetails.statusCancelled": "Cancelled",
"creditNoteDetails.typeORIGINAL": "ORIGINAL",
"creditNoteDetails.typeCOPY": "COPY",
"debitNoteCreate.title": "Create Debit Note",
  "debitNoteCreate.subtitle": "Create a new debit note for additional charges, corrections, or supplementary billing",
  "debitNoteCreate.originalInvoice.title": "Original Invoice",
  "debitNoteCreate.originalInvoice.selectLabel": "Select Original Invoice",
  "debitNoteCreate.originalInvoice.placeholder": "Choose an invoice...",
  "debitNoteCreate.originalInvoice.detailsTitle": "Selected Invoice Details",
  "debitNoteCreate.originalInvoice.invoiceNumber": "Invoice Number",
  "debitNoteCreate.originalInvoice.partner": "Partner",
  "debitNoteCreate.originalInvoice.issueDate": "Issue Date",
  "debitNoteCreate.originalInvoice.totalAmount": "Total Amount",
  "debitNoteCreate.details.title": "Debit Note Details",
  "debitNoteCreate.details.issueDate": "Issue Date",
  "debitNoteCreate.details.dueDate": "Due Date",
  "debitNoteCreate.details.currency": "Currency",
  "debitNoteCreate.items.title": "Items",
  "debitNoteCreate.items.addItem": "Add Item",
  "debitNoteCreate.items.description": "Description",
  "debitNoteCreate.items.descriptionPlaceholder": "Item description",
  "debitNoteCreate.items.quantity": "Quantity",
  "debitNoteCreate.items.unitPrice": "Unit Price",
  "debitNoteCreate.items.total": "Total",
  "debitNoteCreate.summary.title": "Summary",
  "debitNoteCreate.summary.subtotal": "Subtotal",
  "debitNoteCreate.summary.taxAmount": "Tax Amount",
  "debitNoteCreate.summary.totalAmount": "Total Amount",
  "debitNoteCreate.notes.title": "Notes",
  "debitNoteCreate.notes.placeholder": "Additional notes or comments...",
  "debitNoteCreate.buttons.cancel": "Cancel",
  "debitNoteCreate.buttons.create": "Create Debit Note",
  "debitNoteCreate.buttons.creating": "Creating...",
  "debitNoteCreate.successMessage": "Debit note created successfully!",
 "debitNoteList.failedToFetchDebitNotes": "Failed to fetch debit notes",
  "debitNoteList.failedToFetchPartners": "Failed to fetch partners",
  "debitNoteList.failedToFetchCompanies": "Failed to fetch companies",
  "debitNoteList.downloadSuccess": "Debit note downloaded as {type} PDF successfully!",
  "debitNoteList.failedToDownload": "Failed to download debit note as PDF",
  "debitNoteList.failedToLoadForPrinting": "Failed to load debit note for printing",
  "debitNoteList.failedToPrint": "Failed to print debit note",
  "debitNoteList.confirmDelete": "Are you sure you want to delete this debit note?",
  "debitNoteList.failedToDelete": "Failed to delete debit note",
  "debitNoteList.deleteSuccess": "Debit note deleted successfully!",
  "debitNoteList.statusDraft": "Draft",
  "debitNoteList.statusSent": "Sent",
  "debitNoteList.statusPartial": "Partial",
  "debitNoteList.statusPaid": "Paid",
  "debitNoteList.statusOverdue": "Overdue",
  "debitNoteList.statusCancelled": "Cancelled",
  "debitNoteList.title": "Debit Notes",
  "debitNoteList.subtitle": "Manage debit notes for additional charges and corrections",
  "debitNoteList.newDebitNote": "New Debit Note",
  "debitNoteList.searchPlaceholder": "Search debit notes...",
  "debitNoteList.allStatuses": "All Statuses",
  "debitNoteList.allPartners": "All Partners",
  "debitNoteList.allCompanies": "All Companies",
  "debitNoteList.clearFilters": "Clear Filters",
  "debitNoteList.debitNote": "debit note",
  "debitNoteList.debitNotes": "debit notes",
  "debitNoteList.found": "found",
  "debitNoteList.originalInvoice": "Original Invoice",
  "debitNoteList.partner": "Partner",
  "debitNoteList.issueDate": "Issue Date",
  "debitNoteList.amount": "Amount",
  "debitNoteList.status": "Status",
  "debitNoteList.actions": "Actions",
  "debitNoteList.notAvailable": "N/A",
  "debitNoteList.viewDetails": "View Details",
  "debitNoteList.download": "Download",
  "debitNoteList.downloadOriginal": "Download Original",
  "debitNoteList.downloadCopy": "Download Copy",
  "debitNoteList.print": "Print",
  "debitNoteList.printOriginal": "Print Original",
  "debitNoteList.printCopy": "Print Copy",
  "debitNoteList.edit": "Edit",
  "debitNoteList.delete": "Delete",
  "debitNoteList.previous": "Previous",
  "debitNoteList.next": "Next",
  "debitNoteList.showingPage": "Showing page",
  "debitNoteList.of": "of",
  "debitNoteList.noDebitNotesFound": "No debit notes found.",
  "debitNoteDetails.failedToFetchDebitNote": "Failed to fetch debit note",
  "debitNoteDetails.failedToLoadDebitNoteDetails": "Failed to load debit note details",
  "debitNoteDetails.failedToDownloadDebitNote": "Failed to download debit note",
  "debitNoteDetails.downloadSuccess": "Debit note downloaded as {type} PDF successfully!",
  "debitNoteDetails.failedToPrintDebitNote": "Failed to print debit note",
  "debitNoteDetails.printSuccess": "Debit note opened for printing as {type}!",
  "debitNoteDetails.statusDraft": "Draft",
  "debitNoteDetails.statusSent": "Sent",
  "debitNoteDetails.statusPaid": "Paid",
  "debitNoteDetails.statusPartial": "Partial",
  "debitNoteDetails.statusOverdue": "Overdue",
  "debitNoteDetails.statusCancelled": "Cancelled",
  "debitNoteDetails.debitNoteNotFound": "Debit note not found",
  "debitNoteDetails.backToDebitNotes": "Back to Debit Notes",
  "debitNoteDetails.debitNoteDetails": "Debit Note Details",
  "debitNoteDetails.downloadAsPDF": "Download as PDF",
  "debitNoteDetails.downloadOriginal": "Download Original",
  "debitNoteDetails.downloadCopy": "Download Copy",
  "debitNoteDetails.printPDF": "Print PDF",
  "debitNoteDetails.printOriginal": "Print Original",
  "debitNoteDetails.printCopy": "Print Copy",
  "debitNoteDetails.debitNoteInformation": "Debit Note Information",
  "debitNoteDetails.debitNoteNumber": "Debit Note Number",
  "debitNoteDetails.originalInvoice": "Original Invoice",
  "debitNoteDetails.issueDate": "Issue Date",
  "debitNoteDetails.dueDate": "Due Date",
  "debitNoteDetails.status": "Status",
  "debitNoteDetails.currency": "Currency",
  "debitNoteDetails.type": "Type",
  "debitNoteDetails.items": "Items",
  "debitNoteDetails.no": "No",
  "debitNoteDetails.description": "Description",
  "debitNoteDetails.quantity": "Quantity",
  "debitNoteDetails.unitPrice": "Unit Price",
  "debitNoteDetails.total": "Total",
  "debitNoteDetails.summary": "Summary",
  "debitNoteDetails.subtotal": "Subtotal",
  "debitNoteDetails.taxAmount": "Tax Amount",
  "debitNoteDetails.totalAmount": "Total Amount",
  "debitNoteDetails.notes": "Notes",
  "debitNoteDetails.companySupplier": "Company (Supplier)",
  "debitNoteDetails.mol": "MOL",
  "debitNoteDetails.vatTaxId": "VAT Tax ID",
  "debitNoteDetails.taxId": "Tax ID",
  "debitNoteDetails.partnerRecipient": "Partner (Recipient)",
  "debitNoteDetails.contact": "Contact",
  "debitNoteDetails.bankAccount": "Bank Account",
  "debitNoteDetails.bank": "Bank",
  "debitNoteDetails.bic": "BIC",
  "debitNoteDetails.iban": "IBAN",
  "debitNoteDetails.typeORIGINAL": "ORIGINAL",
  "debitNoteDetails.typeCOPY": "COPY",
 "contracts.contractsManagement": "Contracts Management",
  "contracts.manageBusinessContracts": "Manage all your business contracts and documents",
  "contracts.addNewContract": "Add New Contract",
  "contracts.contracts": "Contracts",
  "contracts.settings": "Settings",
  "contracts.searchContracts": "Search contracts...",
  "contracts.allStatuses": "All Statuses",
  "contracts.active": "Active",
  "contracts.pending": "Pending",
  "contracts.completed": "Completed",
  "contracts.terminated": "Terminated",
  "contracts.expired": "Expired",
  "contracts.contractId": "Contract ID",
  "contracts.name": "Name",
  "contracts.client": "Client",
  "contracts.type": "Type",
  "contracts.value": "Value",
  "contracts.status": "Status",
  "contracts.expiryDate": "Expiry Date",
  "contracts.actions": "Actions",
  "contracts.noContractsFound": "No contracts found",
  "contracts.tryAdjustingSearch": "Try adjusting your search or filter criteria.",
  "contracts.getStartedCreatingContract": "Get started by creating a new contract.",
  "contracts.storageConfiguration": "Storage Configuration",
  "contracts.uploadDirectory": "Upload Directory",
  "contracts.enterFullPathToStorage": "Enter full path to storage directory",
  "contracts.saving": "Saving...",
  "contracts.savePath": "Save Path",
  "contracts.resetToDefault": "Reset to Default",
  "contracts.enterFullPathForContractFiles": "Enter the full path where you want to store uploaded contract files",
  "contracts.examplePaths": "Example: /Users/username/Documents/Contracts or C:\\Users\\username\\Documents\\Contracts",
  "contracts.currentStorageDirectory": "Current Storage Directory",
  "contracts.defaultBackendDirectory": "Default backend directory",
  "contracts.newFilesWillBeStoredHere": "New files will be stored in this location",
  "contracts.maximumFileSize": "Maximum File Size",
  "contracts.allowedFileTypes": "Allowed File Types",
  "contracts.contractTemplates": "Contract Templates",
  "contracts.autoGenerateContractId": "Auto-generate Contract ID",
  "contracts.requireProjectAssignment": "Require Project Assignment",
  "contracts.sendExpiryNotifications": "Send Expiry Notifications",
  "contracts.contractStatusManagement": "Contract Status Management",
  "contracts.automaticallyUpdateContractStatuses": "Automatically update all contract statuses based on their start and end dates.",
  "contracts.updating": "Updating...",
  "contracts.updateAllContractStatuses": "Update All Contract Statuses",
  "contracts.statusUpdateFlow": "This will update Pending → Active → Expired based on current date",
  "contracts.editContract": "Edit Contract",
  "contracts.contractName": "Contract Name",
  "contracts.clientName": "Client Name",
  "contracts.contractType": "Contract Type",
  "contracts.service": "Service",
  "contracts.supply": "Supply",
  "contracts.construction": "Construction",
  "contracts.consulting": "Consulting",
  "contracts.other": "Other",
  "contracts.startDate": "Start Date",
  "contracts.contractValue": "Contract Value",
  "contracts.description": "Description",
  "contracts.responsiblePerson": "Responsible Person",
  "contracts.cancel": "Cancel",
  "contracts.createContract": "Create Contract",
  "contracts.updateContract": "Update Contract",
  "contracts.contractDetails": "Contract Details",
  "contracts.createdBy": "Created By",
  "contracts.unknown": "Unknown",
  "contracts.attachedFiles": "Attached Files",
  "contracts.openFileLocation": "Open File Location",
  "contracts.deleteFile": "Delete File",
  "contracts.close": "Close",
  "contracts.uploadFiles": "Upload Files",
  "contracts.fileCategory": "File Category",
  "contracts.mainContract": "Main Contract",
  "contracts.amendment": "Amendment",
  "contracts.attachment": "Attachment",
  "contracts.selectFiles": "Select Files",
  "contracts.maxFileSizeAndTypes": "Max file size: 10MB. Allowed types: PDF, DOC, DOCX, TXT, JPG, JPEG, PNG",
  "contracts.selectedFiles": "Selected Files",
  "contracts.storageDirectoryUpdated": "Storage directory updated successfully!",
  "contracts.errorUpdatingStorageDirectory": "Error updating storage directory. Please check the path and permissions.",
  "contracts.resetToDefaultDirectory": "Reset to default directory successfully!",
  "contracts.errorResettingToDefault": "Error resetting to default directory.",
  "contracts.successfullyUpdatedContractStatuses": "Successfully updated {{count}} contract statuses!",
  "contracts.errorUpdatingContractStatuses": "Error updating contract statuses. Please try again.",
  "contracts.errorSavingContract": "Error saving contract. Please try again.",
  "contracts.confirmDeleteContract": "Are you sure you want to delete this contract?",
  "contracts.errorDeletingContract": "Error deleting contract. Please try again.",
  "contracts.confirmDeleteFile": "Are you sure you want to delete this file?",
  "contracts.errorDeletingFile": "Error deleting file. Please try again.",
  "contracts.contractNotFound": "Contract not found",
  "contracts.fileNotFound": "File not found",
  "contracts.couldNotOpenFileLocation": "Could not open file location. The file might have been moved or deleted.",
  "contracts.errorOpeningFileLocation": "Error opening file location. Please check if the file still exists.",
  "contracts.fileUploadFailed": "File upload failed",
  "contracts.errorUploadingFiles": "Error uploading files: {{error}}",
  "contracts.viewDetails": "View Details",
  "contracts.manageFiles": "Manage Files",
  "contracts.deleteContract": "Delete Contract",
  "contracts.mb": "MB",
  "contracts.loading": "Loading...",
  "contracts.statusActive": "Active",
  "contracts.statusPending": "Pending",
  "contracts.statusCompleted": "Completed",
  "contracts.statusTerminated": "Terminated",
  "contracts.statusExpired": "Expired",
"workers.workersManagement": "Workers Management",
  "workers.manageWorkersAnalyzeProjects": "Manage workers, analyze project assignments, and track working hours",
  "workers.addWorker": "Add Worker",
  "workers.importExcel": "Import Excel",
  "workers.readOnlyMode": "Read-only mode",
  "workers.searchWorkers": "Search workers...",
  "workers.searchDisabledReadOnly": "Search disabled in read-only mode",
  "workers.tabSwitchingDisabledReadOnly": "Tab switching disabled in read-only mode",
  "workers.activeWorkers": "Active Workers",
  "workers.workerAnalysis": "Worker Analysis",
  "workers.archivedWorkers": "Archived Workers",
  "workers.workerName": "Worker Name",
  "workers.location": "Location",
  "workers.contact": "Contact",
  "workers.status": "Status",
  "workers.totalHours": "Total Hours",
  "workers.projects": "Projects",
  "workers.actions": "Actions",
  "workers.loadingWorkersData": "Loading workers data...",
  "workers.noWorkersFound": "No workers found",
  "workers.tryAdjustingSearchCriteria": "Try adjusting your search criteria.",
  "workers.getStartedAddingNewWorker": "Get started by adding a new worker.",
  "workers.projectDetails": "Project Details",
  "workers.totalWorkers": "Total Workers",
  "workers.selectProject": "Select Project",
  "workers.chooseAProject": "Choose a project...",
  "workers.project": "Project",
  "workers.unknownProject": "Unknown Project",
  "workers.additionalWorkingHours": "Additional Working Hours",
  "workers.noProjectDataAvailable": "No project data available",
  "workers.projectNoWorkingHoursRecorded": "This project may not have any working hours recorded yet.",
  "workers.view": "View",
  "workers.hours": "Hours",
  "workers.percentage": "Percentage",
  "workers.showWeekends": "Show Weekends",
  "workers.showHolidays": "Show Holidays",
  "workers.worker": "Worker",
  "workers.monthlyTotals": "Monthly Totals",
  "workers.loadingMonthlyDutyData": "Loading monthly duty data...",
  "workers.noWorkersFoundForProject": "No workers found for this project in {{month}} {{year}}",
  "workers.dailyTotals": "Daily Totals",
  "workers.workingDays": "Working Days",
  "workers.avgDailyWorkers": "Avg Daily Workers",
  "workers.noMonthlyDutyDataAvailable": "No monthly duty data available",
  "workers.projectNoWorkingHoursRecordedForMonth": "This project may not have any working hours recorded for {{month}} {{year}}.",
  "workers.searchArchivedWorkers": "Search archived workers...",
  "workers.loadingArchivedWorkers": "Loading archived workers...",
  "workers.noArchivedWorkersFound": "No archived workers found",
  "workers.noWorkersArchivedYet": "No workers have been archived yet.",
  "workers.totalArchivedWorkers": "Total Archived Workers",
  "workers.contractFrom": "Contract From",
  "workers.editWorker": "Edit Worker",
  "workers.addNewWorker": "Add New Worker",
  "workers.name": "Name",
  "workers.enterWorkerName": "Enter worker name",
  "workers.cityVillage": "City/Village",
  "workers.phoneNumberOrEmail": "Phone number or email",
  "workers.statusActive": "Active",
  "workers.statusInactive": "Inactive",
  "workers.cancel": "Cancel",
  "workers.save": "Save",
  "workers.inputDisabledReadOnly": "Input disabled in read-only mode",
  "workers.selectDisabledReadOnly": "Select disabled in read-only mode",
  "workers.cancelDisabledReadOnly": "Cancel disabled in read-only mode",
  "workers.saveDisabledReadOnly": "Save disabled in read-only mode",
  "workers.noPermissionToEdit": "You do not have permission to edit.",
  "workers.importComplete": "Import complete: {{added}} added, {{skipped}} skipped.",
  "workers.importFailed": "Import failed.",
  "workers.january": "January",
  "workers.february": "February",
  "workers.march": "March",
  "workers.april": "April",
  "workers.may": "May",
  "workers.june": "June",
  "workers.july": "July",
  "workers.august": "August",
  "workers.september": "September",
  "workers.october": "October",
  "workers.november": "November",
  "workers.december": "December",
  "workers.project": "project",
  "workers.projects": "projects",
  "workers.day": "day",
  "workers.days": "days",
 "employeeDashboard.loadingYourDashboard": "Loading your dashboard...",
  "employeeDashboard.noAuthenticationTokenFound": "No authentication token found. Please log in.",
  "employeeDashboard.userDataNotFound": "User data not found. Please log in again.",
  "employeeDashboard.authenticationFailed": "Authentication failed. Please log in again.",
  "employeeDashboard.failedToLoadData": "Failed to load data. Please try again.",
  "employeeDashboard.tryAgain": "Try Again",
  "employeeDashboard.goToLogin": "Go to Login",
  "employeeDashboard.welcomeBack": "Welcome back",
  "employeeDashboard.employee": "Employee",
  "employeeDashboard.online": "Online",
  "employeeDashboard.offline": "Offline",
  "employeeDashboard.notifications": "Notifications",
  "employeeDashboard.noNotifications": "No notifications",
  "employeeDashboard.loadingNotifications": "Loading notifications...",
  "employeeDashboard.lastUpdated": "Last updated",
  "employeeDashboard.totalProjects": "Total Projects",
  "employeeDashboard.activeProjects": "Active Projects",
  "employeeDashboard.completedToday": "Completed Today",
  "employeeDashboard.totalHours": "Total Hours",
  "employeeDashboard.yourProjects": "Your Projects",
  "employeeDashboard.progress": "Progress",
  "employeeDashboard.location": "Location",
  "employeeDashboard.dueDate": "Due Date",
  "employeeDashboard.assignedWorkers": "Assigned Workers",
  "employeeDashboard.dailyTargets": "Daily Targets",
  "employeeDashboard.workingHours": "Working Hours",
  "employeeDashboard.additionalWork": "Additional Work",
  "employeeDashboard.totalProjectHours": "Total Project Hours",
  "employeeDashboard.workers": "workers",
  "employeeDashboard.units": "units",
  "employeeDashboard.hrs": "hrs",
  "employeeDashboard.noProjectsAssignedYet": "No projects assigned yet",
  "employeeDashboard.youWillSeeYourAssignedProjects": "You'll see your assigned projects here once they're available.",
  "employeeDashboard.quickActions": "Quick Actions",
  "employeeDashboard.schedule": "Schedule",
  "employeeDashboard.timeTrack": "Time Track",
  "employeeDashboard.reports": "Reports",
  "employeeDashboard.teamChat": "Team Chat",
  "employeeDashboard.specialAccess": "Special Access",
  "employeeDashboard.autoPark": "Auto Park",
  "employeeDashboard.inventory": "Inventory",
  "employeeDashboard.contracts": "Contracts",
  "employeeDashboard.workers": "Workers",
  "employeeDashboard.noSpecialAccess": "No special access granted"



    }
  },
  "bg": {
    "translation": {
      "loginTitle": "Портал за служители",
      "loginSubtitle": "Тази страница е предназначена само за служители на Infinity Energy Solar.",
      "home": "Начало",
      "services": "Услуги",
      "machinesHero": "Нашето оборудване и машини",
      "machinesIntro": "Използваме високоефективни и прецизни машини за всеки етап от изграждането на соларни паркове. Нашето оборудване гарантира надеждност, ефективност и мащабируемост.",
      "machine0Title": "Челен товарач",
      "machine0Desc": "За ефективно пренасяне на материали и логистика.",
      "machine1Title": "Набивна машина",
      "machine1Desc": "За прецизна и стабилна работа по основите.",
      "machine2Title": "Телескопичен товарач",
      "machine2Desc": "За гъвкаво повдигане и транспортиране в сложен терен.",
      "machine3Title": "9-тонен мини багер",
      "machine3Desc": "За подкрепа на автопарка при специални нужди.",
      "machinesBrowseGallery": "Разгледайте нашите машини",
      "machinesGalleryTitle": "Галерия с машини",
      "machineryListButton": "Списък машини",
      "machineryFleetTitle": "Нашият парк машини",
      "machineryFleetRow0": "Хидравлична набивна система Mazaka",
      "machineryFleetRow1": "Набивна машина Orteco",
      "machineryFleetRow2": "Набивна машина Gayk",
      "machineryFleetRow3": "Компактен челен товарач Bobcat (модел: T86)",
      "machineryFleetRow4": "Телескопичен товарач Manitou",
      "machineryFleetRow5": "Телескопичен товарач Bobcat (модел: T76)",
      "machineryFleetRow6": "Верижен багер Develon 9 т",
      "machineryFleetRow7": "Верижен багер Develon 14 т",
      "machineryFleetRow8": "Сондажна машина",
      "machineryFleetRow9": "Компактен багер Bobcat 3,5 т (модел: E35)",
      "machineryFleetRow10": "Компактен багер Bobcat 5,5 т (модел: E55)",
      "machinesCloseModal": "Затвори",
      "machines": "Машини",
      "certificatesHero": "Нашите сертификати",
      "certificatesIntro": "Ние сме сертифицирани по най-високите индустриални стандарти, гарантиращи надеждност, качество и съответствие във всички наши проекти.",
      "certificate0Title": "ISO 9001:2015",
      "certificate0Desc": "Сертификат за система за управление на качеството за последователна ефективност.",
      "certificate1Title": "ISO 14001:2015",
      "certificate1Desc": "Сертификат за система за управление на околната среда за намаляване на екологичния отпечатък.",
      "certificate2Title": "ISO 45001:2018",
      "certificate2Desc": "Сертификат за здраве и безопасност при работа за нашите екипи и партньори.",
      "certificates": "Сертификати",
      "projects": "Проекти",
      "projectsHero": "Ние захранваме по-чиста и по-светла Европа",
      "projectsIntro": "Това са нашите проекти в няколко европейски държави - всеки от тях е повече от строителен обект за нас. Те олицетворяват силни партньорства, споделени цели и доверието, което клиентите ни гласуват. Всяка локация е стъпка към по-зелено утре, захранено от иновации, надеждност и визия.",
      "countryBulgaria": "България",
      "countryFrance": "Франция",
      "countryItaly": "Италия",
      "countryGermany": "Германия",
      "countrySerbia": "Сърбия",
      "countryNorthMacedonia": "Северна Македония",
      "countryBelgium": "Белгия",
      "countryDenmark": "Дания",
      "chooseCountry": "Изберете държава",
      "selectCountry": "Изберете държава",
      "selectProject": "Изберете проект",
      "selectCountryToBrowse": "Изберете държава, за да разгледате проекти",
      "selectProjectFromDropdown": "Изберете проект от падащото меню по-горе",
      "projectsBelgiumTitle": "Проекти в Белгия",
      "projectsDenmarkTitle": "Проекти в Дания",
      "projectsFranceTitle": "Проекти във Франция",
      "projectBelgiumMain": "Основен проект в Белгия",
      "projectsGermanyTitle": "Проекти в Германия",
      "projectsSerbiaTitle": "Проекти в Сърбия",
      "projectsItalyTitle": "Проекти в Италия",
      "projectsNorthMacedoniaTitle": "Проекти в Северна Македония",
      "projectGermanyDiesel": "Дизел Техник",
      "projectNessebar": "Несебър",
      "projectLapovo": "Лапово",
      "projectVitaminka": "Витаминка, Прилеп",
      "projectPernikOne": "Перник 1",
      "projectPernikTwo": "Перник 2",
      "projectMoussoulens": "Мосулен",
      "projectPerpignan": "Перпинян",
      "projectStGermain": "Сен Жермен",
      "projectLesMes": "Лес Меес",
      "projectSBRU": "SBRU",
      "projectStElix": "St. Elix",
      "projectSlivnitsa": "Сливница",
      "projectRasovo": "Расово, Лом",
      "projectPolch": "Полх",
      "projectMonreale": "Монреале, Сицилия",
      "projectVillerup": "Вилеруп",
      "nessebarTitle": "Несебър",
      "lapovoTitle": "Лапово",
      "vitaminkaTitle": "Витаминка, Прилеп",
      "pernikoneTitle": "Перник 1",
      "perniktwoTitle": "Перник 2",
      "slivnitsaTitle": "Сливница",
      "rasovoTitle": "Расово, Лом",
      "polchTitle": "Полх",
      "villerupTitle": "Вилеруп",
      "monrealeTitle": "Монреале",
      "perpignanTitle": "Перпинян",
      "stgermainTitle": "Сен Жермен",
      "lesmesTitle": "Лес Меес",
      "sbruTitle": "SBRU",
      "stelixTitle": "Сент Еликс",
      "moussoulensTitle": "Мосулен",
      "projectPower": "Обща мощност",
      "projectType": "Тип на конструкцията",
      "projectTypeStatic": "Статична",
      "projectTypeTracker": "Tракер",
      "projectYear": "Година",
      "photoGallery": "Фотогалерия",
      "projectsBulgariaTitle": "Проекти в България",
      "projectsBulgariaIntro": "Това са нашите проекти в България - всеки от тях е повече от строителен обект за нас. Те олицетворяват силни партньорства, споделени цели и доверието, което клиентите ни оказват.",
      "projectKyustendil": "Кюстендил",
      "projectPlovdiv": "Инсталация Пловдив",
      "projectRazlog": "Енергиен хъб Разлог",
      "kyustendilTitle": "Соларен парк Кюстендил",
      "loadingImage": "Зареждане на изображение...",
      "back": "Назад",
      "whyInfinity": "Защо Инфинити?",
      "whyHero": "Защо да изберете Инфинити?",
      "whyIntro": "В Infinity Energy Solar съчетаваме съвременни технологии с екип от мотивирани експерти, за да предоставим несравними решения за соларна енергия.",
      "why0Title": "Опит и експертиза",
      "why0Desc": "Нашият висококвалифициран екип има доказан опит в реализирането на успешни соларни проекти в цяла Европа.",
      "why1Title": "Индивидуални решения",
      "why1Desc": "Проектираме всяка фотоволтаична система според вашите нужди и особеностите на терена.",
      "why2Title": "Устойчив ангажимент",
      "why2Desc": "Залагаме на екологични практики и дългосрочна устойчивост във всеки наш проект.",
      "why3Title": "Съдействие при финансиране",
      "why3Desc": "Изготвяме техническа и финансова документация за осигуряване на финансиране от български и международни организации.",
      "why4Title": "Ангажимент към съвършенство",
      "why4Desc": "Нашата отдаденост към качеството и успеха на клиента ни води към най-добрите решения с доказани марки и резултати.",
      "contact": "Контакти",
      "contactHero": "Нека заедно захраним вашето бъдеще",
      "contactText": "Ние сме тук, за да ви помогнем с вашите нужди в областта на соларната енергия. Независимо дали имате въпроси, нужда от експертен съвет или сте готови да стартирате проект, нашият екип е на разположение да ви предложи индивидуални решения и подкрепа. Свържете се с нас днес и нека заедно захраним бъдещето!",
      "contactTitle": "Свържете се с нас",
      "contactPhone": "Телефон",
      "contactEmail": "Имейл",
      "contactAddress": "Адрес",
      "contactFullAddress": "ул. \"Христо Ботев\" 2, 2760 Разлог, България",
      "futureText": "Вашето бъдеще, захранено от Слънцето",
      "futureTextLine1": "Вашето бъдеще,",
      "futureTextLine2": "захранено от Слънцето!",
      "heroText": "Вашето бъдеще, захранено от Слънцето!",
      "heroSubtitle": "Развиваме соларни паркове в цяла Европа, скоро и отвъд.",
      "contactUs": "Свържете се с нас",
      "exploreProjects": "Разгледайте нашите проекти",
      "whoAreWe": "Кои сме ние?",
      "whoAreWeText": "Infinity Energy Solar е млада и бързо развиваща се компания, която предоставя иновативни и устойчиви решения за производство и съхранение на възобновяема енергия. Компанията е специализирана в проектирането и изграждането на фотоволтаични паркове и вече успешно е реализирала проекти в България и няколко европейски държави. Със силен акцент върху високите стандарти и технологичните иновации, Infinity Energy Solar се утвърди като надежден партньор при реализацията на соларни инсталации с различен мащаб. Нашият екип от експерти управлява целия процес с фокус върху ефективността, дълготрайността и устойчивостта. Компанията разработва индивидуални решения, съобразени със специфичните нужди и изисквания на своите партньори и клиенти. Infinity Energy Solar бързо се разрасна и в момента разполага с екип от над 100 служители. Убедени сме, че нашият успех се дължи на отдадеността, експертизата и единството на хората ни, които са в основата на всяка успешна стъпка, която правим.",
      "homeAbout": "Infinity Energy Solar е млада и бързо развиваща се компания, предлагаща иновативни и устойчиви решения за производство и съхранение на възобновяема енергия. Специализирана в проектирането и изграждането на фотоволтаични паркове, компанията вече успешно е реализирала проекти както в България, така и в няколко европейски държави.\n\nСъс силен фокус върху високите стандарти и технологичните иновации, ние се утвърдихме като надежден партньор при реализацията на соларни инсталации с различен мащаб. Нашият екип от експерти управлява целия процес с внимание към ефективността, устойчивостта и дълготрайността.\n\nКомпанията разработва индивидуални решения, съобразени със специфичните нужди и изисквания на своите партньори и клиенти. Infinity Energy Solar бързо се разрасна и днес разполага с екип от над 180 служители. Убедени сме, че нашият успех се дължи на отдадеността, експертизата и екипния дух на хората ни, които стоят зад всяка наша успешна стъпка.",
      "getStarted": "Започнете",
      "projectsStat": "Проекта",
      "powerStat": "Обща мощност",
      "countriesStat": "Държави",
      "workersStat": "Служители",
      "servicesHero": "Нашите услуги са създадени с внимание към детайла.",
      "servicesIntro": "От първоначалния проект до дългосрочната поддръжка, ние предлагаме цялостни решения, съобразени с всеки соларен проект.",
      "ourServices": "Нашите услуги",
      "ourServicesDesc": "От първоначалния проект до дългосрочната поддръжка, ние предлагаме цялостни решения, съобразени с всеки соларен проект.",
      "labelPrintingTitle": "Печат на етикети",
      "labelPrintingDesc": "Нашата компания предлага професионални услуги за печат на етикети за соларни паркове и други инфраструктурни проекти, използвайки Brady i7500 - осигурявайки издръжливи, прецизни и съответстващи на стандартите етикети за панели, кабели, оборудване и инфраструктурни компоненти.",
      "designTitle": "Проектиране",
      "designDesc": "Съобразявайки се с нуждите на Вашия бизнес, ние проектираме вашата фотоволтаична система, осигурявайки точен проект според Вашата идея.",
      "constructTitle": "Изграждане",
      "constructDesc": "Нашият екип от специалисти извършва инсталацията според най-подходящото решение, осигурявайки прецизен и детайлен план за реализация на обекта.",
      "maintainTitle": "Поддръжка",
      "kyustendilContractor": "Възложител: Рашев и Ко ЕООД",
      "pernikoneContractor": "Възложител: Рашев и Ко ЕООД",
      "slivnitsaContractor": "Възложител: Рашев и Ко ЕООД",
      "moussoulensContractor": "Възложител: Рашев и Ко ЕООД",
      "monrealeContractor": "Възложител: Рашев и Ко ЕООД",
      "perpignanContractor": "Възложител: Рашев и Ко ЕООД",
      "stgermainContractor": "Възложител: Рашев и Ко ЕООД",
      "lesmesContractor": "Възложител: Рашев и Ко ЕООД",
      "lesmesNotes": "Репауъринг",			
      "maintainDesc": "Нашият екип извършва техническа поддръжка на изградените фотоволтаични системи, спазвайки всички изисквания на производителите, с които работим.",
      "upcomingProjects": "ПРЕДСТОЯЩИ ПРОЕКТИ:",
      "projectsInProgressUpcoming": "Проекти в процес",
      "inProgress": "В процес",
      "upcoming": "Предстоящи",
      "projectAunslev": "Аунслев",
      "projectAunslevCapacity": "31 MWh",
      "projectStElix": "Сент Еликс",
      "projectStElixCapacity": "4.1 MWp",
      "projectBalkantsi": "Балканци, България",
      "projectBalkantsiCapacity": "5 MWp",
      "projectIhtiman": "Ихтиман, България",
      "projectIhtimanCapacity": "12 MWp",
      "projectMorocco": "Бени Матар, Африка",
      "projectMoroccoCapacity": "120 MWp",
      "projectPrevancher": "Превеншер, Франция",
      "projectPrevancherCapacity": "42 MWp",
      "upcomingProjectsDesc": "От януари 2026 г. започваме няколко проекта в цяла Европа и България.",
      "mapConsentRequired": "Google Maps e деактивиран, докато не приемете бисквитките.",
      "cookiesTitle": "Infinity Energy Solar - Бисквитки",
      "cookiesHeader": "Политика за бисквитки",
      "cookiesIntro": "Използваме бисквитки, за да подобрим вашето сърфиране и да анализираме трафика на сайта. Бисквитките са малки текстови файлове, съхранявани на вашето устройство, които ни помагат да ви разпознаем и да запомним вашите предпочитания.",
      "cookiesTypesTitle": "Видове бисквитки, които използваме",
      "cookiesTypes.0": "Задължителни бисквитки – необходими за основната функционалност на сайта",
      "cookiesTypes.1": "Аналитични бисквитки – помагат ни да разберем поведението на потребителите (например Google Analytics)",
      "cookiesTypes.2": "Функционални бисквитки – запомнят вашите предпочитания (например език)",
      "cookiesThirdPartyTitle": "Услуги от трети страни",
      "cookiesThirdParty": "Използваме Google Maps, за да покажем местоположението на нашата компания на страницата Контакти. Google може да зададе бисквитки и да събира данни за използване. Можете да видите тяхната Политика за поверителност.",
      "cookiesManageTitle": "Управление на бисквитки",
      "cookiesManage": "Можете да контролирате или деактивирате бисквитки чрез настройките на вашия браузър. Деактивирането на някои типове може да повлияе на функционалността на сайта.",
      "cookiesContactTitle": "Контакт",
      "cookiesContact": "Ако имате въпроси относно нашата политика за бисквитки, моля, свържете се с нас на office@infisolarbg.com.",
      "cookieBannerText": "Този уебсайт използва бисквитки. Продължавайки вие приемате или отхвърляте нашата Политика за Бисквитки.",
      "cookieBannerLearnMore": "Научете повече",
      "cookieBannerAccept": "Приемам",
      "cookieBannerDecline": "Отхвърлям",
      "employeesTitle": "За служители",
      "employeesInfo": "Следните контакти са предназначени само за служители на компанията, за да докладват проблеми, опасни условия на труд или други въпроси, свързани с работната среда. Всички сигнали се третират с пълна конфиденциалност, като се гарантира, че служителите могат да изразят опасенията си без страх от последствия. Тези комуникационни канали се управляват от нашия отдел „Човешки ресурси“ с цел осигуряване на безопасна и подкрепяща работна среда за всички.",
      "admin.dashboard": "Tабло",
      "admin.welcomeMessage": "Добре дошли във вашето табло за управление на проекти",
      "admin.dashboard": "Табло",
      "admin.languageSwitcher": "Език",
      "admin.bulgarian": "Български",
      "admin.english": "English",
      "admin.loadingDashboard": "Зареждане на вашето табло...",
      "admin.loadingData": "Зареждане на данни за таблото...",
      "admin.welcomeUser": "Добре дошъл",
      "admin.userRole": "Роля неизвестна",
      "admin.noEmail": "Няма имейл",
      "admin.notification": "Известия",
      "admin.totalProjects": "Общо проекти",
      "admin.activeProjects": "активни",
      "admin.totalEmployees": "Общо служители",
      "admin.administrators": "администратори",
      "admin.activeWorkers": "Активни работници",
      "admin.ofTotal": "от общо",
      "admin.projectSummary": "Обобщение на проекти",
      "weatherPanel.enterCity": "Въведете град",
      "weatherPanel.set": "Задай",
      "weatherPanel.loadingWeather": "Зареждане на времето...",
      "weatherPanel.weatherDataUnavailable": "Не са налични данни за времето",
      "weatherPanel.retry": "Повторен опит",
      "weatherPanel.noWeatherData": "Няма данни за времето",
      "weatherPanel.currentWeather": "Времето в момента",
      "weatherPanel.wind": "Вятър",
      "weatherPanel.humidity": "Влажност",
      "weatherPanel.kmh": "км/ч",
      "weatherPanel.celsius": "°C",
      "projectSummary.onTrack": "По график",
      "projectSummary.atRisk": "Рисков",
      "projectSummary.completed": "Завършен",
      "projectSummary.notStarted": "Не е започнат",
      "adminLayout.adminPanel": "Админ Панел",
      "adminLayout.home": "Начало",
      "adminLayout.projects": "Проекти",
      "adminLayout.assignProjects": "Възлагане на проекти",
      "adminLayout.dailyLogs": "Дневни отчети",
      "adminLayout.analytics": "Анализи",
      "adminLayout.forecasting": "Прогнози",
      "adminLayout.autoPark": "Автопарк",
      "adminLayout.inventory": "Инвентар",
      "adminLayout.invoices": "Фактури",
      "adminLayout.contracts": "Договори",
      "adminLayout.workers": "Работници",
      "adminLayout.users": "Потребители",
      "adminLayout.resources": "Ресурси",
      "adminLayout.notifications": "Известия",
      "adminLayout.settings": "Настройки",
      "adminLayout.logout": "Изход",
      "adminLayout.showSidebar": "Покажи панела",
      "adminLayout.hideSidebar": "Скрий панела",
      "adminProjects.projectManagement": "Управление на проекти",
      "adminProjects.manageDescription": "Управлявайте и наблюдавайте всички ваши слънчеви енергийни проекти",
      "adminProjects.loadingProjects": "Зареждане на проекти...",
      "adminProjects.active": "Активни",
      "adminProjects.completed": "Завършени",
      "adminProjects.createProject": "Създай проект",
      "adminProjects.projectName": "Име на проекта",
      "adminProjects.powerCapacity": "Мощност",
      "adminProjects.constructionType": "Тип конструкция",
      "adminProjects.status": "Статус",
      "adminProjects.percentCompleted": "% Завършено",
      "adminProjects.noActiveProjects": "Няма намерени активни проекти",
      "adminProjects.noCompletedProjects": "Няма намерени завършени проекти",
      "adminProjects.getStartedMessage": "Започнете като създадете нов проект.",
      "adminProjects.noCompletedMessage": "Все още няма завършени проекти.",
      "adminProjects.addNewProject": "Добави нов проект",
      "adminProjects.enterProjectName": "Въведете име на проекта",
      "adminProjects.enterPowerCapacity": "Въведете мощност",
      "adminProjects.enterConstructionType": "Въведете тип конструкция",
      "adminProjects.dueDate": "Краен срок",
      "adminProjects.notificationThresholds": "Прагове за известия",
      "adminProjects.cancel": "Отказ",
      "adminProjects.tryAgain": "Опитайте отново",
      "adminProjects.goToLogin": "Отидете на входа",
      "adminProjects.authenticationFailed": "Удостоверяването не бе успешно. Моля, влезте отново.",
      "adminProjects.failedToLoad": "Неуспешно зареждане на проекти. Моля, опитайте отново.",
      "adminProjects.noAuthToken": "Не е намерен токен за удостоверяване. Моля, влезте.",
      "adminProjects.activeProjects": "активни проекти",
      "adminProjects.completedProjects": "завършени проекти",
      "constructionType.tracker": "Тракер",
      "constructionType.static": "Статична",
      "projectStatus.onTrack": "По график",
      "projectStatus.atRisk": "Рисков",
      "projectStatus.completed": "Завършен",
      "projectStatus.notStarted": "Не е започнат",
      "projectDetails.projectDetails": "Детайли на проекта",
      "projectDetails.viewManageDescription": "Преглед и управление на информация за проекта, дейности и прогрес",
      "projectDetails.exportToPDF": "Експорт към PDF",
      "projectDetails.generatingPDF": "Генериране на PDF...",
      "projectDetails.exportFailed": "Експортът неуспешен",
      "projectDetails.projectInfo": "Информация за проекта",
      "projectDetails.projectName": "Име на проекта",
      "projectDetails.percentCompleted": "% Завършено",
      "projectDetails.status": "Статус",
      "projectDetails.assignedEmployee": "Ръководител обекта",
      "projectDetails.assignedWorkers": "Работници на обекта",
      "projectDetails.notificationMatrix": "Матрица за известия",
      "projectDetails.workingHours": "Работни часове",
      "projectDetails.additionalWorkingHours": "Допълнителни работни часове",
      "projectDetails.totalWorkingHours": "Общо работни часове",
      "projectDetails.firstLogDate": "Дата на първия запис",
      "projectDetails.finishDate": "Дата на завършване",
      "projectDetails.daysLeft": "Оставащи дни",
      "projectDetails.selectActivity": "Избери дейност",
      "projectDetails.select": "Избери...",
      "projectDetails.cancel": "Отказ",
      "projectDetails.add": "Добави",
      "projectDetails.activities": "Дейности",
      "projectDetails.activity": "Дейност",
      "projectDetails.unit": "Мярка",
      "projectDetails.planned": "Планирано",
      "projectDetails.dailyTarget": "Дневна цел",
      "projectDetails.completed": "Завършено",
      "projectDetails.remaining": "Оставащо",
      "projectDetails.percentCompletedCol": "% Завършено",
      "projectDetails.addActivity": "+ Добави дейност",
      "projectDetails.assignWorkers": "Назначи работници",
      "projectDetails.saveActivities": "Запази дейностите",
      "projectDetails.activitiesSaved": "Дейностите са запазени успешно!",
      "projectDetails.errorSavingActivities": "Грешка при запазване на дейностите.",
      "projectDetails.dailyLogs": "Дневни отчети",
      "projectDetails.noLogsAvailable": "Няма налични отчети.",
      "projectDetails.date": "Дата",
      "projectDetails.workingHoursLogs": "Работни часове",
      "projectDetails.logWorkingHours": "Запиши работни часове",
      "projectDetails.from": "От:",
      "projectDetails.to": "До:",
      "projectDetails.clear": "Изчисти",
      "projectDetails.worker": "Работник",
      "projectDetails.totalPerDay": "Общо за деня",
      "projectDetails.selectedDatesHours": "Избрани дати часове:",
      "projectDetails.grandTotalHours": "Общо часове:",
      "projectDetails.saveWorkingHours": "Запази работните часове",
      "projectDetails.workingHoursSaved": "Работните часове са запазени!",
      "projectDetails.errorSavingHours": "Грешка при запазване на работните часове",
      "projectDetails.logHoursForToday": "Запиши часове за днес",
      "projectDetails.save": "Запази",
      "projectDetails.additionalWork": "Допълнителна работа",
      "projectDetails.addAdditionalWork": "+ Добави",
      "projectDetails.description": "Описание",
      "projectDetails.hours": "Часове",
      "projectDetails.comments": "Коментари",
      "projectDetails.total": "Общо",
      "projectDetails.addAdditionalWorkModal": "Добави допълнителна работа",
      "projectDetails.projectPhotos": "Снимки на проекта",
      "projectDetails.uploaded": "Качено",
      "projectDetails.loadingProjectDetails": "Зареждане на детайлите на проекта...",
      "projectDetails.assignTitle": "Назначи работници",
      "projectDetails.assign.Search": "Търси работници по име, имейл или телефон...",
      "projectDetails.assignSelectAll": "Избери всички",
      "projectDetails.assignClearAll": "Премахни всички", 
      "projectDetails.assignCancel": "Отказ",
      "projectDetails.assignAssign": "Назначи",
      "adminAssignEmployees.assignProjectToEmployee": "Възложи проект на служител",
      "adminAssignEmployees.manageProjectAssignments": "Управляване на възлаганията на проекти и разпределение на екипа",
      "adminAssignEmployees.loading": "Зареждане...",
      "adminAssignEmployees.tryAgain": "Опитай отново",
      "adminAssignEmployees.projectAssignment": "Възлагане на проект",
      "adminAssignEmployees.selectProject": "Всички проекти",
      "adminAssignEmployees.chooseProject": "Избери проект...",
      "adminAssignEmployees.selectEmployee": "Всички служители",
      "adminAssignEmployees.chooseEmployee": "Избери служител...",
      "adminAssignEmployees.assignProject": "Възложи проект",
      "adminAssignEmployees.currentAssignments": "Текущи възлагания",
      "adminAssignEmployees.project": "Проект",
      "adminAssignEmployees.assignedTo": "Възложен на",
      "adminAssignEmployees.noOneAssigned": "Никой не е възложен",
      "adminAssignEmployees.noAssignmentsFound": "Не са намерени възлагания",
      "adminAssignEmployees.getStartedMessage": "Започнете като възложите проект на служител.",
      "adminAssignEmployees.employeeId": "ID на служител",
      "adminAssignEmployees.unknown": "Неизвестен",
      "adminAssignEmployees.selectBothProjectAndEmployee": "Моля, изберете и проект, и служител.",
      "adminAssignEmployees.projectAssignedSuccessfully": "Проектът е възложен успешно!",
      "adminAssignEmployees.assignmentFailed": "Възлагането неуспешно. Моля, опитайте отново.",
      "adminDaily.dailyLogs": "Дневни отчети",
      "adminDaily.trackDailyActivities": "Проследяване на дневните дейности и прогреса на проекта",
      "adminDaily.failedToLoadProjects": "Неуспешно зареждане на проекти. Моля, опитайте отново.",
      "adminDaily.tryAgain": "Опитайте отново",
      "adminDaily.selectProject": "Изберете проект",
      "adminDaily.status": "Статус",
      "adminDaily.completed": "Завършен",
      "adminDaily.atRisk": "В риск",
      "adminDaily.onTrack": "По график",
      "adminDaily.notStarted": "Не е започнат",
      "adminDaily.progress": "Прогрес",
      "adminDaily.assigned": "Възложен",
      "adminDaily.notAssigned": "Не е възложен",
      "adminDaily.project": "Проект",
      "adminDaily.loadingLogs": "Зареждане на отчети...",
      "adminAnalytics.overview": "Общ преглед",
      "adminAnalytics.activities": "Дейности",
      "adminAnalytics.comparisons": "Сравнения",
      "adminAnalytics.insights": "Прозрения",
      "adminAnalytics.performance": "Производителност",
      "adminAnalytics.workLogs": "Работни отчети",
      "adminAnalytics.failedToLoadProjects": "Неуспешно зареждане на проекти. Моля, опитайте отново.",
      "adminAnalytics.analyticsDashboard": "Aнализи",
      "adminAnalytics.monitorProjectPerformance": "Проследяване на производителността на проекта и ключови показатели",
      "adminAnalytics.projects": "Проекти:",
      "adminAnalytics.loading": "Зареждане...",
      "adminAnalytics.noProjectsFound": "Не са намерени проекти",
      "adminAnalytics.overallProgress": "Общ прогрес",
      "adminAnalytics.assignedWorkers": "Назначени работници",
      "adminAnalytics.loggedWorkers": "Влезли работници",
      "adminAnalytics.comingSoon": "скоро",
      "adminAnalytics.featureUnderDevelopment": "Тази функция е в процес на разработка и ще бъде достъпна скоро.",
      "adminAnalytics.noProjectSelected": "Не е избран проект",
      "adminAnalytics.selectProjectFromSidebar": "Моля, изберете проект от страничната лента за да видите анализа.",
      "adminForecasting.forecastResults": "Резултати от прогнозата",
      "adminForecasting.notEnoughData": "Няма достатъчно данни за генериране на прогноза. Моля, добавете повече завършени проекти.",
      "adminForecasting.estimatedDuration": "Приблизителна продължителност",
      "adminForecasting.estimatedWorkers": "Приблизителен брой работници",
      "adminForecasting.estimatedTotalWorkingHours": "Приблизителни общо работни часове",
      "adminForecasting.notificationThresholds": "Прагове за известия",
      "adminForecasting.fillRequiredFields": "Моля, попълнете всички задължителни полета.",
      "adminForecasting.projectForecasting": "Прогнозиране на проекти",
      "adminForecasting.generateAccurateForecasts": "Генериране на точни прогнози за проекти въз основа на исторически данни",
      "adminForecasting.projectDetails": "Детайли на проекта",
      "adminForecasting.projectName": "Име на проекта",
      "adminForecasting.projectNamePlaceholder": "напр. Слънчев парк Алфа",
      "adminForecasting.powerCapacity": "Мощност (MW)",
      "adminForecasting.powerCapacityPlaceholder": "напр. 1000",
      "adminForecasting.constructionType": "Тип конструкция",
      "adminForecasting.similarProjectsFound": "Намерени подобни проекти",
      "adminForecasting.calculating": "Изчисляване...",
      "adminForecasting.generateForecast": "Генерирай прогноза",
      "adminForecasting.static": "Статична",
      "adminForecasting.roof": "Покрив", 
      "adminForecasting.tracker": "Тракер",
      "autoPark.carsAndMachinery": "Автомобили и машини",
      "autoPark.manageVehicleFleet": "Управлявайте вашия автопарк и инвентар от оборудване",
      "autoPark.addNewCar": "Добави нов автомобил",
      "autoPark.addNewMachine": "Добави нова машина",
      "autoPark.cars": "Автомобили",
      "autoPark.machinery": "Машини",
      "autoPark.searchCars": "Търсене на автомобили...",
      "autoPark.searchMachinery": "Търсене на машини...",
      "autoPark.allStatuses": "Всички статуси",
      "autoPark.active": "Активен",
      "autoPark.maintenance": "Поддръжка",
      "autoPark.repair": "Ремонт",
      "autoPark.inactive": "Неактивен",
      "autoPark.retired": "Изведен от експлоатация",
      "autoPark.model": "Модел",
      "autoPark.plate": "Регистрация",
      "autoPark.driver": "Шофьор",
      "autoPark.type": "Тип",
      "autoPark.insurance": "Застраховка",
      "autoPark.vignette": "Винетка",
      "autoPark.techInsp": "Тех. преглед",
      "autoPark.status": "Статус",
      "autoPark.contact": "Контакт",
      "autoPark.actions": "Действия",
      "autoPark.machineName": "Име на машината",
      "autoPark.operator": "Оператор",
      "autoPark.location": "Локация",
      "autoPark.nextMaintenance": "Следваща поддръжка",
      "autoPark.noCarsFound": "Не са намерени автомобили",
      "autoPark.noMachineryFound": "Не са намерени машини",
      "autoPark.tryAdjustingSearch": "Опитайте да коригирате критериите за търсене или филтъра за статус.",
      "autoPark.getStartedAddingCar": "Започнете като добавите нов автомобил.",
      "autoPark.getStartedAddingMachinery": "Започнете като добавите нови машини.",
      "autoPark.totalCars": "Общо автомобили",
      "autoPark.totalMachinery": "Общо машини",
      "autoPark.editCar": "Редактирай автомобил",
      "autoPark.carModel": "Модел на автомобила",
      "autoPark.licensePlate": "Регистрационен номер",
      "autoPark.techInspectionExpiry": "Изтичане на тех. преглед",
      "autoPark.insuranceExpiry": "Изтичане на застраховка",
      "autoPark.vignetteExpiry": "Изтичане на винетка",
      "autoPark.driverName": "Име на шофьора",
      "autoPark.carType": "Тип на автомобила",
      "autoPark.contactNumber": "Телефонен номер",
      "autoPark.save": "Запази",
      "autoPark.cancel": "Отказ",
      "autoPark.carInformation": "Информация за автомобила",
      "autoPark.techInspExpiry": "Изтичане на тех. преглед",
      "autoPark.notSet": "Не е зададен",
      "autoPark.services": "Услуги",
      "autoPark.addService": "Добави услуга",
      "autoPark.notes": "Бележки",
      "autoPark.addNote": "Добави бележка",
      "autoPark.exportToPDF": "Експорт към PDF",
      "autoPark.preparingPDF": "Подготовка на PDF...",
      "autoPark.statusActive": "Активен",
      "autoPark.statusMaintenance": "Поддръжка", 
      "autoPark.statusRepair": "Ремонт",
      "autoPark.statusInactive": "Неактивен",
      "autoPark.statusRetired": "Изведен от експлоатация",
      "autoPark.description": "Описание",
      "autoPark.date": "Дата",
      "autoPark.price": "Цена",
      "autoPark.total": "Общо",
      "autoPark.noServicesYet": "Все още няма услуги.",
      "autoPark.noNotesYet": "Все още няма бележки.",
      "autoPark.serviceType": "Тип услуга",
      "autoPark.regularService": "Редовна услуга",
      "autoPark.techInspection": "Технически преглед",
      "autoPark.insurance": "Застраховка",
      "autoPark.vignette": "Винетка",
      "autoPark.serviceDescriptionPlaceholder": "Описание на услугата...",
      "autoPark.newExpiryDate": "Нова дата на изтичане",
      "autoPark.noteDescriptionPlaceholder": "Въведете описание на бележката...",
      "autoPark.reset": "Отказ",
      "autoPark.manufacturer": "Производител",
      "autoPark.year": "Година",
      "autoPark.cost": "Цена",
      "autoPark.fuelType": "Вид гориво",
      "autoPark.lastMaintenance": "Последно обслужване",
      "autoPark.registrationExpiry": "Изтичане на регистрацията",
      "autoPark.machineryInformation": "Детайлна информация",
      "autoPark.noServicesRecordedYet": "Все още няма услуги.",
      "adminInventory.inventoryManagement": "Управление на инвентара",
      "adminInventory.manageCompanyAssets": "Управлявайте активите, устройствата и назначенията на оборудването на компанията",
      "adminInventory.addNewAsset": "Добави нов актив",
      "adminInventory.searchAssets": "Търси активи...",
      "adminInventory.name": "Име",
      "adminInventory.email": "Имейл",
      "adminInventory.device": "Устройство",
      "adminInventory.brand": "Марка",
      "adminInventory.model": "Модел",
      "adminInventory.serialNumber": "Сериен номер",
      "adminInventory.actions": "Действия",
      "adminInventory.protocol": "Протокол",
      "adminInventory.noAssetsFound": "Не са намерени активи",
      "adminInventory.tryAdjustingSearch": "Опитайте да коригирате критериите за търсене.",
      "adminInventory.getStartedAddingAsset": "Започнете като добавите нов актив.",
      "adminInventory.download": "Изтегли",
      "adminInventory.totalAssets": "Общо активи",
      "adminInventory.editAsset": "Редактирай актив",
      "adminInventory.employeeWorker": "Служител/Работник",
      "adminInventory.selectEmployeeAdminWorker": "Избери служител/администратор/работник",
      "adminInventory.deviceType": "Тип устройство",
      "adminInventory.selectDeviceType": "Избери тип устройство",
      "adminInventory.enterBrandName": "Въведи име на марката",
      "adminInventory.enterModelName": "Въведи име на модела",
      "adminInventory.enterSerialNumber": "Въведи сериен номер",
      "adminInventory.updateAsset": "Обнови",
      "adminInventory.createAsset": "Създай актив",
      "adminInventory.close": "Затвори",
      "adminInventory.assetInformation": "Информация за актива",
      "adminInventory.addedAt": "Добавен на",
      "adminInventory.updatedAt": "Обновен на",
      "adminInventory.cancel": "Отказ",
      "adminInventory.pleaseFillRequiredFields": "Моля, попълнете всички задължителни полета: Тип устройство, Марка и Сериен номер",
      "adminInventory.failedToSave": "Неуспешно запазване",
      "adminInventory.failedToSaveAsset": "Неуспешно запазване на актива. Моля, опитайте отново.",
      "adminUsers.areYouSureDeleteUser": "Сигурни ли сте, че искате да изтриете този потребител?",
      "adminUsers.cannotDeleteUserInventory": "Не можете да изтриете потребителя. Потребителят има назначени инвентарни артикули, които трябва първо да бъдат върнати. Моля, върнете всички назначени артикули преди да изтриете потребителя.",
      "adminUsers.failedToDeleteUser": "Неуспешно изтриване на потребителя. Моля, опитайте отново.",
      "adminUsers.user": "Потребител",
      "adminUsers.email": "Имейл",
      "adminUsers.role": "Роля",
      "adminUsers.actions": "Действия",
      "adminUsers.hasAssignedInventoryItems": "Има {count} назначени инвентарни артикула",
      "adminUsers.cannotDeleteAssignedInventory": "Не може да се изтрие - потребителят има назначен инвентар",
      "adminUsers.deleteUser": "Изтрий потребител",
      "adminUsers.noUsersFound": "Не са намерени потребители",
      "adminUsers.tryAdjustingSearch": "Опитайте да коригирате критериите за търсене.",
      "adminUsers.getStartedCreatingUser": "Започнете като създадете нов потребител.",
      "adminUsers.noDeletedUsersToDisplay": "Няма изтрити потребители за показване.",
      "adminUsers.usersManagement": "Управление на потребителите",
      "adminUsers.manageOrganizationUsers": "Управлявайте всички потребители в организацията",
      "adminUsers.addNewUser": "Добави нов потребител",
      "adminUsers.searchUsers": "Търси потребители...",
      "adminUsers.currentUsers": "Текущи потребители",
      "adminUsers.deletedUsers": "Изтрити потребители",
      "adminUsers.totalUsers": "Общо потребители",
      "adminUsers.fullName": "Пълно име",
      "adminUsers.enterFullName": "Въведи пълно име",
      "adminUsers.enterEmailAddress": "Въведи имейл адрес",
      "adminUsers.password": "Парола",
      "adminUsers.enterPassword": "Въведи парола",
      "adminUsers.avatar": "Аватар",
      "adminUsers.useDefaultAvatar": "Използвай стандартен аватар",
      "adminUsers.uploadCustomAvatar": "Качи персонализиран аватар",
      "adminUsers.enterImageURL": "Въведи URL на изображението...",
      "adminUsers.cancel": "Отказ",
      "adminUsers.createUser": "Създай потребител",
      "adminUsers.userDetails": "Детайли за потребителя",
      "adminUsers.assignedProjects": "Назначени проекти",
      "adminUsers.loading": "Зареждане...",
      "adminUsers.noAssignedProjects": "Няма назначени проекти.",
      "adminUsers.assignedAssets": "Назначени активи",
      "adminUsers.noAssetsAssigned": "Няма назначени активи.",
      "adminUsers.close": "Затвори",
      "adminUsers.specialPermissions": "Специални разрешения",
      "adminUsers.autoparkAccess": "Достъп до автопарк",
      "adminUsers.inventoryAccess": "Достъп до инвентар",
      "adminUsers.contractsAccess": "Достъп до договори",
      "adminUsers.workersAccess": "Достъп до работници",
      "adminUsers.invoicesAccess": "Достъп до фактури",
      "adminUsers.analyticsAccess": "Достъп до анализи",
      "adminUsers.forecastingAccess": "Достъп до прогнози",
      "adminUsers.resourcesAccess": "Достъп до ресурси",
      "adminUsers.usersAccess": "Достъп до потребители",
      "adminUsers.settingsAccess": "Достъп до настройки",
      "adminUsers.specialPermissionsNote": "Тези разрешения позволяват на служителите да достъпват конкретни административни страници.",
      "adminUsers.failedToUpdatePermissions": "Неуспешно актуализиране на разрешенията. Моля, опитайте отново.",
      "adminUsers.unsavedChanges": "Имате незапазени промени",
      "adminUsers.saveChanges": "Запази промените",
      "adminUsers.saving": "Запазване...",
      "accessDenied.title": "Достъпът е отказан",
      "accessDenied.autoparkMessage": "Нямате разрешение за достъп до страницата за автопарк.",
      "accessDenied.inventoryMessage": "Нямате разрешение за достъп до страницата за инвентар.",
      "accessDenied.contractsMessage": "Нямате разрешение за достъп до страницата за договори.",
      "accessDenied.contactAdmin": "Моля, свържете се с вашия администратор, за да поискате достъп.",
      "employeeAccess.restrictedAccess": "Ограничен достъп",
      "employeeAccess.autoparkDescription": "Имате ограничен достъп до управлението на автопарка.",
      "employeeAccess.inventoryDescription": "Имате ограничен достъп до управлението на инвентара.",
      "employeeAccess.contractsDescription": "Имате ограничен достъп до управлението на договорите.",
      "adminUsers.employee": "Служител",
      "adminUsers.admin": "Администратор",
      "adminResources.resourcesManagement": "Управление на ресурси",
      "adminResources.manageBusinessResources": "Управлявайте всички ваши ресурси за дейности",
      "adminResources.addNewResource": "Добави нов ресурс",
      "adminResources.searchResources": "Търси ресурси...",
      "adminResources.resourceName": "Име на ресурса",
      "adminResources.actions": "Действия",
      "adminResources.deleteResource": "Изтрий ресурс",
      "adminResources.noResourcesFound": "Не са намерени ресурси",
      "adminResources.tryAdjustingSearch": "Опитайте да коригирате критериите за търсене.",
      "adminResources.getStartedCreatingResource": "Започнете като създадете нов ресурс.",
      "adminResources.totalResources": "Общо ресурси",
      "adminResources.enterResourceName": "Въведи име на ресурса",
      "adminResources.cancel": "Отказ",
      "adminResources.createResource": "Създай ресурс",
      "allNotifications.notifications": "Известия",
      "allNotifications.viewAndManageNotifications": "Преглеждайте и управлявайте всички ваши известия",
      "allNotifications.unread": "Непрочетено",
      "allNotifications.totalNotifications": "Общо известия",
      "allNotifications.noNotifications": "Няма известия",
      "allNotifications.allCaughtUp": "Всичко е актуално! Няма нови известия.",
      "allNotifications.status": "Статус",
      "allNotifications.message": "Съобщение",
      "allNotifications.date": "Дата",
      "allNotifications.actions": "Действия",
      "allNotifications.read": "Прочетено",
      "allNotifications.markAsRead": "Маркирай като прочетено",
      "adminSettings.advancedSettings": "Разширени настройки",
      "adminSettings.manageUserPermissions": "Управлявайте потребителски права, роли и контрол на достъпа",
      "adminSettings.permissions": "Права",
      "adminSettings.roleManagement": "Управление на роли",
      "adminSettings.customRoles": "Персонализирани роли",
      "adminSettings.users": "Потребители",
      "adminSettings.loadingUsers": "Зареждане на потребители...",
      "adminSettings.noUsersFound": "Не са намерени потребители",
      "adminSettings.noUserSelected": "Не е избран потребител",
      "adminSettings.selectUserToConfigure": "Моля, изберете потребител от списъка, за да конфигурирате настройките му.",
      "adminSettings.custom": "Персонализирана",
      "adminSettings.active": "Активен",
      "adminSettings.inactive": "Неактивен",
      "adminSettings.pagePermissions": "Права за страници",
      "adminSettings.readOnlyMode": "Режим само за четене",
      "adminSettings.fullAccess": "Пълен достъп",
      "adminSettings.page": "Страница",
      "adminSettings.access": "Достъп",
      "adminSettings.selectAll": "Избери всички",
      "adminSettings.restrictUserToViewOnly": "Ограничи потребителя до достъп само за четене",
      "adminSettings.saveChanges": "Запази промените",
      "adminSettings.roleHierarchyAndPermissions": "Йерархия на ролите и права",
      "adminSettings.roleHierarchy": "Йерархия на ролите",
      "adminSettings.level": "Ниво",
      "adminSettings.canManage": "Може да управлява",
      "adminSettings.cannotManage": "Не може да управлява",
      "adminSettings.defaultPermissions": "Права по подразбиране",
      "adminSettings.pagesAccessible": "достъпни страници",
      "adminSettings.customRoleManagement": "Управление на персонализирани роли",
      "adminSettings.removeCustomRole": "Премахни персонализирана роля",
      "adminSettings.assignCustomRole": "Присвои персонализирана роля",
      "adminSettings.currentCustomRole": "Текуща персонализирана роля",
      "adminSettings.createCustomRole": "Създай персонализирана роля",
      "adminSettings.roleName": "Име на ролята",
      "adminSettings.enterCustomRoleName": "Въведи име на персонализираната роля",
      "adminSettings.description": "Описание",
      "adminSettings.describeCustomRole": "Опиши тази персонализирана роля",
      "adminSettings.cancel": "Отказ",
      "adminUsers.admin": "Администратор",
      "adminUsers.employee": "Служител",
"invoices.dashboard": "Начало",
"invoices.invoiceList": "Списък с фактури",
"invoices.company": "Компании",
"invoices.partners": "Партньори",
"invoices.creditNotes": "Кредитни известия",
"invoices.debitNotes": "Дебитни известия",
"invoices.reports": "Отчети",
"invoices.incomingInvoices": "Входящи фактури",
"invoices.financeDashboard": "Финансов мениджмънт",
"invoices.manageInvoicesCompanyPartners": "Управлявайте вашите фактури, детайли на компанията и партньори",
"invoiceDashboard.failedToLoadDashboardData": "Неуспешно зареждане на данните от таблото",
"invoiceDashboard.loadingDashboard": "Зареждане на таблото...",
"invoiceDashboard.totalPartners": "Общо партньори",
"invoiceDashboard.active": "Активни",
"invoiceDashboard.totalInvoices": "Общо фактури",
"invoiceDashboard.paid": "Платени",
"invoiceDashboard.sentInvoices": "Изпратени фактури",
"invoiceDashboard.overdue": "Просрочени",
"invoiceDashboard.totalPaymentsReceived": "Общо получени плащания",
"invoiceDashboard.fromAllInvoices": "От всички фактури",
"invoiceDashboard.recentInvoices": "Последни фактури",
"invoiceDashboard.viewAll": "Виж всички",
"invoiceDashboard.noInvoicesYet": "Все още няма фактури",
"invoiceDashboard.createFirstInvoice": "Създай първа фактура",
"invoiceDashboard.unknownPartner": "Неизвестен партньор",
"invoiceDashboard.due": "Падеж",
"invoiceDashboard.viewInvoiceDetails": "Виж детайли на фактурата",
"invoiceDashboard.quickActions": "Бързи действия",
"invoiceDashboard.createInvoice": "Създай фактура",
"invoiceDashboard.addPartner": "Добави партньор",
"invoiceDashboard.viewAllInvoices": "Виж всички фактури",
"invoiceDashboard.invoiceStatus": "Статус на фактурите",
"invoiceDashboard.draft": "Чернова",
"invoiceDashboard.sent": "Изпратена",
"invoiceDashboard.partial": "Частична",
"invoiceDashboard.statusDraft": "Чернова",
"invoiceDashboard.statusSent": "Изпратена",
"invoiceDashboard.statusPaid": "Платена", 
"invoiceDashboard.statusPartial": "Частична",
"invoiceDashboard.statusOverdue": "Просрочена",
"invoiceList.failedToFetchInvoices": "Неуспешно зареждане на фактурите",
"invoiceList.failedToLoadInvoices": "Неуспешно зареждане на фактурите",
"invoiceList.failedToDeleteInvoice": "Неуспешно изтриване на фактурата",
"invoiceList.invoiceDeletedSuccessfully": "Фактурата е изтрита успешно!",
"invoiceList.failedToUpdateInvoiceStatus": "Неуспешно обновяване на статуса на фактурата",
"invoiceList.invoiceStatusUpdatedSuccessfully": "Статусът на фактурата е обновен успешно!",
"invoiceList.failedToDownloadInvoiceAsPDF": "Неуспешно изтегляне на фактурата като PDF",
"invoiceList.invoiceDownloadedSuccessfully": "Фактурата е изтеглена като {{type}} PDF успешно!",
"invoiceList.failedToLoadInvoiceForPrinting": "Неуспешно зареждане на фактурата за печат",
"invoiceList.failedToPrintInvoice": "Неуспешен печат на фактурата",
"invoiceList.invoices": "Фактури",
"invoiceList.manageInvoicesTrackPayments": "Управлявайте вашите фактури, проследявайте плащанията и наблюдавайте финансовото представяне",
"invoiceList.newInvoice": "Създай фактура",
"invoiceList.searchInvoicesItemsNotes": "Търси фактури, артикули, бележки...",
"invoiceList.allStatus": "Всички статуси",
"invoiceList.draft": "Чернова",
"invoiceList.sent": "Изпратена",
"invoiceList.partial": "Частична",
"invoiceList.paid": "Платена",
"invoiceList.overdue": "Просрочена",
"invoiceList.cancelled": "Отменена",
"invoiceList.allPartners": "Всички партньори",
"invoiceList.allCompanies": "Всички компании",
"invoiceList.allProjects": "Всички проекти",
"invoiceList.loadingInvoices": "Зареждане на фактурите...",
"invoiceList.noInvoicesFound": "Не са намерени фактури",
"invoiceList.createFirstInvoice": "Създай първа фактура",
"invoiceList.invoicesFound": "Намерени {{count}} фактури",
"invoiceList.invoice": "Фактура",
"invoiceList.partner": "Партньор",
"invoiceList.project": "Проект",
"invoiceList.amount": "Сума",
"invoiceList.status": "Статус",
"invoiceList.issueDate": "Дата на издаване",
"invoiceList.dueDate": "Дата на падеж",
"invoiceList.actions": "Действия",
"invoiceList.unknownCompany": "Неизвестна компания",
"invoiceList.unknownPartner": "Неизвестен партньор",
"invoiceList.noProject": "Няма проект",
"invoiceList.itemsCount": "{{count}} артикула",
"invoiceList.statusDraft": "Чернова",
"invoiceList.statusSent": "Изпратена",
"invoiceList.statusPartial": "Частична",
"invoiceList.statusPaid": "Платена",
"invoiceList.statusOverdue": "Просрочена",
"invoiceList.statusCancelled": "Отменена",
"invoiceList.downloadOriginal": "Изтегли оригинал",
"invoiceList.downloadCopy": "Изтегли копие",
"invoiceList.printOriginal": "Печат оригинал",
"invoiceList.printCopy": "Печат копие",
"invoiceList.previous": "Предишна",
"invoiceList.next": "Следваща",
"invoiceList.showingResults": "Показване от <span class=\"font-medium\">{{start}}</span> до <span class=\"font-medium\">{{end}}</span> от <span class=\"font-medium\">{{total}}</span> резултата",
"invoiceList.deleteInvoice": "Изтрий фактура",
"invoiceList.deleteInvoiceConfirmation": "Сигурни ли сте, че искате да изтриете фактура <strong>{{invoiceNumber}}</strong>? Това действие не може да бъде отменено.",
"invoiceList.cancel": "Отказ",
"invoiceList.deleting": "Изтриване...",
"invoiceList.delete": "Изтрий",
"invoiceList.oneInvoiceFound": "Намерена 1 фактура",
"invoiceList.multipleInvoicesFound": "{{count}} фактури намерени",
"invoiceCreate.loadingInvoiceForm": "Зареждане на формата за фактура...",
"invoiceCreate.failedToLoadData": "Неуспешно зареждане на данните за партньори и компании",
"invoiceCreate.pleaseSelectPartner": "Моля, изберете партньор",
"invoiceCreate.pleaseFillItemDescriptions": "Моля, попълнете всички описания на артикулите",
"invoiceCreate.invoiceCreatedSuccessfully": "Фактурата е създадена успешно!",
"invoiceCreate.failedToCreateInvoice": "Неуспешно създаване на фактура",
"invoiceCreate.createNewInvoice": "Създаване на нова фактура",
"invoiceCreate.createProfessionalInvoice": "Създайте професионална фактура за вашия клиент",
"invoiceCreate.invoiceDetails": "Детайли на фактурата",
"invoiceCreate.company": "Компания",
"invoiceCreate.selectCompany": "Изберете компания",
"invoiceCreate.bankAccountForPayment": "Банкова сметка за плащане",
"invoiceCreate.selectBankAccount": "Изберете банкова сметка",
"invoiceCreate.default": "(По подразбиране)",
"invoiceCreate.partnerClient": "Партньор/Клиент",
"invoiceCreate.selectPartner": "Изберете партньор",
"invoiceCreate.project": "Проект",
"invoiceCreate.optional": "По желание",
"invoiceCreate.selectProjectOptional": "Изберете проект (по желание)",
"invoiceCreate.currency": "Валута",
"invoiceCreate.bgnBulgarianLev": "BGN (Български лев)",
"invoiceCreate.eurEuro": "EUR (Евро)",
"invoiceCreate.usdUsDollar": "USD (Американски долар)",
"invoiceCreate.issueDate": "Дата на издаване",
"invoiceCreate.dueDate": "Дата на падеж",
"invoiceCreate.dateFormat": "ДД.ММ.ГГГГ",
"invoiceCreate.items": "Артикули",
"invoiceCreate.addItem": "Добави артикул",
"invoiceCreate.description": "Описание",
"invoiceCreate.chars": "символа",
"invoiceCreate.itemDescription": "Описание на артикула",
"invoiceCreate.quantity": "Количество",
"invoiceCreate.unitPrice": "Единична цена",
"invoiceCreate.total": "Общо",
"invoiceCreate.invoiceSummary": "Обобщение на фактурата",
"invoiceCreate.subtotal": "Междинна сума",
"invoiceCreate.taxAmount": "20% ДДС",
"invoiceCreate.totalAmount": "Обща сума",
"invoiceCreate.euroConversion": "Евро (1 EUR = 1.95583 BGN)",
"invoiceCreate.additionalNotes": "Допълнителни бележки",
"invoiceCreate.notes": "Бележки",
"invoiceCreate.addNotesPlaceholder": "Добавете допълнителни бележки или условия...",
"invoiceCreate.cancel": "Отказ",
"invoiceCreate.creatingInvoice": "Създаване на фактура...",
"invoiceCreate.createInvoice": "Създай фактура",
"invoiceDetails.loadingInvoiceDetails": "Зареждане на детайлите на фактурата...",
"invoiceDetails.invoiceNotFound": "Фактурата не е намерена",
"invoiceDetails.backToInvoiceList": "Обратно към списъка с фактури",
"invoiceDetails.failedToLoadInvoiceDetails": "Неуспешно зареждане на детайлите на фактурата",
"invoiceDetails.failedToDeleteInvoice": "Неуспешно изтриване на фактурата",
"invoiceDetails.failedToUpdateInvoiceStatus": "Неуспешно обновяване на статуса на фактурата",
"invoiceDetails.failedToRecordPayment": "Неуспешно записване на плащането",
"invoiceDetails.failedToDownloadInvoiceAsPDF": "Неуспешно изтегляне на фактурата като PDF",
"invoiceDetails.failedToLoadInvoiceForPrinting": "Неуспешно зареждане на фактурата за печат",
"invoiceDetails.failedToPrintInvoice": "Неуспешен печат на фактурата",
"invoiceDetails.invoiceDeletedSuccessfully": "Фактурата е изтрита успешно",
"invoiceDetails.invoiceStatusUpdatedSuccessfully": "Статусът на фактурата е обновен успешно",
"invoiceDetails.paymentRecordedSuccessfully": "Плащането е записано успешно",
"invoiceDetails.invoiceDownloadedSuccessfully": "Фактурата е изтеглена успешно",
"invoiceDetails.pleaseEnterValidPaymentAmount": "Моля, въведете валидна сума за плащане",
"invoiceDetails.invoiceDetails": "Детайли на фактурата",
"invoiceDetails.invoiceInformation": "Информация за фактурата",
"invoiceDetails.lineItems": "Артикули",
"invoiceDetails.notes": "Бележки",
"invoiceDetails.companyAndPartner": "Компания и партньор",
"invoiceDetails.paymentStatus": "Статус на плащането",
"invoiceDetails.statusActions": "Действия за статуса",
"invoiceDetails.paymentHistory": "История на плащанията",
"invoiceDetails.invoiceNumber": "Номер на фактурата",
"invoiceDetails.invoiceType": "Тип на фактурата",
"invoiceDetails.status": "Статус",
"invoiceDetails.issueDate": "Дата на издаване",
"invoiceDetails.dueDate": "Дата на падеж",
"invoiceDetails.currency": "Валута",
"invoiceDetails.project": "Проект",
"invoiceDetails.description": "Описание",
"invoiceDetails.quantity": "Количество",
"invoiceDetails.unitPrice": "Единична цена",
"invoiceDetails.total": "Общо",
"invoiceDetails.subtotal": "Междинна сума",
"invoiceDetails.taxAmount": "Сума за данък",
"invoiceDetails.totalAmount": "Обща сума",
"invoiceDetails.fromCompany": "От (Компания)",
"invoiceDetails.toPartner": "До (Партньор)",
"invoiceDetails.taxId": "Данъчен номер",
"invoiceDetails.vatTaxId": "ДДС номер",
"invoiceDetails.contact": "Контакт",
"invoiceDetails.email": "Имейл",
"invoiceDetails.noProjectAssigned": "Не е назначен проект",
"invoiceDetails.amountPaid": "Платена сума",
"invoiceDetails.remaining": "Оставаща сума",
"invoiceDetails.recordPayment": "Запиши плащане",
"invoiceDetails.amount": "Сума",
"invoiceDetails.paymentMethod": "Начин на плащане",
"invoiceDetails.reference": "Референция",
"invoiceDetails.date": "Дата",
"invoiceDetails.method": "Метод",
"invoiceDetails.euroEquivalent": "Еквивалент в евро",
"invoiceDetails.total": "Общо",
"invoiceDetails.paid": "Платено",
"invoiceDetails.markAsSent": "Маркирай като изпратена",
"invoiceDetails.markAsPaid": "Маркирай като платена",
"invoiceDetails.markAsDraft": "Маркирай като чернова",
"invoiceDetails.deleteInvoice": "Изтрий фактурата",
"invoiceDetails.deleteInvoiceConfirmation": "Сигурни ли сте, че искате да изтриете фактурата",
"invoiceDetails.deleteInvoiceWarning": "Това действие не може да бъде отменено.",
"invoiceDetails.cancel": "Отказ",
"invoiceDetails.delete": "Изтрий",
"invoiceDetails.referenceOptional": "Референция (По желание)",
"invoiceDetails.transactionReference": "Референция на транзакцията",
"invoiceDetails.recording": "Записване...",
"invoiceDetails.max": "Макс",
"invoiceDetails.downloadAsPDF": "Изтегли като PDF",
"invoiceDetails.downloadOriginal": "Изтегли оригинал",
"invoiceDetails.downloadCopy": "Изтегли копие",
"invoiceDetails.printPDF": "Печат на PDF",
"invoiceDetails.printOriginal": "Печат на оригинал",
"invoiceDetails.printCopy": "Печат на копие",
"invoiceDetails.overdue": "Просрочена",
"invoiceDetails.bankTransfer": "Банков превод",
"invoiceDetails.cash": "В брой",
"invoiceDetails.card": "Карта",
"invoiceDetails.check": "Чек",
"invoiceDetails.statusPaid": "Платена",
"invoiceDetails.statusSent": "Изпратена",
"invoiceDetails.statusPartial": "Частично платена",
"invoiceDetails.statusOverdue": "Просрочена",
"invoiceDetails.statusDraft": "Чернова",
"invoiceDetails.invoiceTypeORIGINAL": "ОРИГИНАЛ",
"invoiceDetails.invoiceTypeCOPY": "КОПИЕ",
"companyManagement.failedToLoadCompanies": "Неуспешно зареждане на компаниите",
"companyManagement.pleaseFillAllRequiredFields": "Моля, попълнете всички задължителни полета",
"companyManagement.bankAccountUpdatedSuccessfully": "Банковата сметка е {action} успешно!",
"companyManagement.updated": "обновена",
"companyManagement.added": "добавена",
"companyManagement.confirmDeleteBankAccount": "Сигурни ли сте, че искате да изтриете тази банкова сметка?",
"companyManagement.bankAccountDeletedSuccessfully": "Банковата сметка е изтрита успешно!",
"companyManagement.defaultBankAccountUpdatedSuccessfully": "Стандартната банкова сметка е обновена успешно!",
"companyManagement.eitherTaxIdOrVatTaxIdRequired": "Трябва да бъде предоставен или данъчен номер, или ДДС номер",
"companyManagement.companySavedSuccessfully": "Компанията е {action} успешно!",
"companyManagement.created": "създадена",
"companyManagement.failedToSaveCompany": "Неуспешно запазване на компанията",
"companyManagement.confirmDeleteCompany": "Сигурни ли сте, че искате да изтриете тази компания? Това действие не може да бъде отменено.",
"companyManagement.companyDeletedSuccessfully": "Компанията е изтрита успешно!",
"companyManagement.failedToDeleteCompany": "Неуспешно изтриване на компанията",
"companyManagement.loadingCompanies": "Зареждане на компаниите...",
"companyManagement.companies": "Компании",
"companyManagement.manageCompanyInformation": "Управлявайте информацията и настройките на вашата компания",
"companyManagement.addCompany": "Добави компания",
"companyManagement.noCompaniesFound": "Не са намерени компании",
"companyManagement.addYourFirstCompany": "Добавете първата си компания",
"companyManagement.companiesFound": "Намерени са {count} компани{plural}",
"companyManagement.company": "Компания",
"companyManagement.contact": "Контакт",
"companyManagement.location": "Местоположение",
"companyManagement.mrp": "МОЛ",
"companyManagement.bankAccounts": "Банкови сметки",
"companyManagement.actions": "Действия",
"companyManagement.taxId": "Данъчен номер",
"companyManagement.vatTaxId": "ДДС номер",
"companyManagement.notSpecified": "Не е посочено",
"companyManagement.bankAccountsCount": "{count} сметк{plural}",
"companyManagement.defaultSet": "Стандартна зададена",
"companyManagement.noDefault": "Няма стандартна",
"companyManagement.editCompany": "Редактирай компания",
"companyManagement.addNewCompany": "Добави нова компания",
"companyManagement.companyInformation": "Информация за компанията",
"companyManagement.companyName": "Име на компанията",
"companyManagement.taxIdRequired": "Данъчен номер (задължителен, ако няма ДДС номер)",
"companyManagement.vatTaxIdRequired": "ДДС номер (ИН по ДДС) (задължителен, ако няма данъчен номер)",
"companyManagement.city": "Град",
"companyManagement.address": "Адрес",
"companyManagement.mrpName": "Име на МОЛ",
"companyManagement.country": "Държава",
"companyManagement.contactInformation": "Контактна информация",
"companyManagement.contactEmail": "Контактен имейл",
"companyManagement.contactPhone": "Контактен телефон",
"companyManagement.website": "Уебсайт",
"companyManagement.logoUrl": "URL на лого",
"companyManagement.addBank": "Добави банка",
"companyManagement.noBankAccountsAdded": "Все още не са добавени банкови сметки",
"companyManagement.default": "Стандартна",
"companyManagement.invoiceSettings": "Настройки за фактурите",
"companyManagement.defaultCurrency": "Стандартна валута",
"companyManagement.bgnBulgarianLev": "BGN (Български лев)",
"companyManagement.eurEuro": "EUR (Евро)",
"companyManagement.usdUsDollar": "USD (Американски долар)",
"companyManagement.defaultTaxRate": "Стандартен данъчен процент",
"companyManagement.percent": "%",
"companyManagement.paymentTerms": "Условия за плащане",
"companyManagement.days": "Дни",
"companyManagement.invoiceNumberPrefix": "Префикс на номера на фактурата",
"companyManagement.cancel": "Отказ",
"companyManagement.saving": "Запазване...",
"companyManagement.updateCompany": "Обнови",
"companyManagement.createCompany": "Създай компания",
"companyManagement.editBankAccount": "Редактирай банкова сметка",
"companyManagement.addBankAccount": "Добави банкова сметка",
"companyManagement.bankName": "Име на банката",
"companyManagement.swiftCode": "SWIFT код",
"companyManagement.iban": "IBAN",
"companyManagement.setAsDefaultBankAccount": "Задай като стандартна банкова сметка",
"companyManagement.update": "Обнови",
"companyManagement.companyFound": "компания намерена",
"companyManagement.companiesFound": "компании намерени",
"companyManagement.bankAccount": "сметка",
"companyManagement.bankAccounts": "сметки",
"partnerManagement.failedToLoadPartners": "Неуспешно зареждане на партньорите",
"partnerManagement.eitherTaxIdOrVatTaxIdRequired": "Трябва да бъде предоставен или данъчен номер, или ДДС номер",
"partnerManagement.partnerUpdatedSuccessfully": "Партньорът е обновен успешно!",
"partnerManagement.partnerCreatedSuccessfully": "Партньорът е създаден успешно!",
"partnerManagement.failedToSavePartner": "Неуспешно запазване на партньора",
"partnerManagement.confirmDeletePartner": "Сигурни ли сте, че искате да изтриете този партньор?",
"partnerManagement.partnerDeletedSuccessfully": "Партньорът е изтрит успешно!",
"partnerManagement.failedToDeletePartner": "Неуспешно изтриване на партньора",
"partnerManagement.partners": "Партньори",
"partnerManagement.manageBusinessPartners": "Управлявайте вашите бизнес партньори и клиенти",
"partnerManagement.addPartner": "Добави партньор",
"partnerManagement.searchPartners": "Търси партньори...",
"partnerManagement.allStatus": "Всички статуси",
"partnerManagement.statusActive": "Активен",
"partnerManagement.statusInactive": "Неактивен",
"partnerManagement.loadingPartners": "Зареждане на партньорите...",
"partnerManagement.noPartnersFound": "Не са намерени партньори",
"partnerManagement.addYourFirstPartner": "Добавете първия си партньор",
"partnerManagement.partnerFound": "партньор намерен",
"partnerManagement.partnersFound": "партньори намерени",
"partnerManagement.partner": "Партньор",
"partnerManagement.contact": "Контакт",
"partnerManagement.location": "Местоположение",
"partnerManagement.status": "Статус",
"partnerManagement.paymentTerms": "Условия за плащане",
"partnerManagement.bankDetails": "Банкови детайли",
"partnerManagement.actions": "Действия",
"partnerManagement.taxId": "Данъчен номер",
"partnerManagement.vatTaxId": "ДДС номер",
"partnerManagement.days": "дни",
"partnerManagement.notSpecified": "Не е посочено",
"partnerManagement.previous": "Предишен",
"partnerManagement.next": "Следващ",
"partnerManagement.showing": "Показване на",
"partnerManagement.to": "до",
"partnerManagement.of": "от",
"partnerManagement.results": "резултата",
"partnerManagement.editPartner": "Редактирай партньор",
"partnerManagement.addNewPartner": "Добави нов партньор",
"partnerManagement.partnerName": "Име на партньора",
"partnerManagement.taxIdRequired": "Данъчен номер (задължителен, ако няма ДДС номер)",
"partnerManagement.vatTaxIdRequired": "ДДС номер (ИН по ДДС) (задължителен, ако няма данъчен номер)",
"partnerManagement.address": "Адрес",
"partnerManagement.city": "Град",
"partnerManagement.country": "Държава",
"partnerManagement.contactPerson": "Лице за контакт",
"partnerManagement.email": "Имейл",
"partnerManagement.phone": "Телефон",
"partnerManagement.creditLimit": "Кредитен лимит",
"partnerManagement.bankName": "Име на банката",
"partnerManagement.swiftCode": "SWIFT код",
"partnerManagement.iban": "IBAN",
"partnerManagement.notes": "Бележки",
"partnerManagement.cancel": "Отказ",
"partnerManagement.saving": "Запазване...",
"partnerManagement.updatePartner": "Обнови",
"partnerManagement.createPartner": "Създай партньор",
"reports.authenticationFailed": "Удостоверяването е неуспешно. Моля, влезте отново.",
"reports.failedToLoadReportsData": "Неуспешно зареждане на данните за отчетите",
"reports.reportGeneratedSuccessfully": "Отчетът {type} е генериран успешно!",
"reports.failedToGenerateReport": "Неуспешно генериране на отчета",
"reports.overdueAlertSentSuccessfully": "Известието за просрочена фактура е изпратено успешно!",
"reports.failedToSendAlert": "Неуспешно изпращане на известие",
"reports.failedToSendOverdueAlert": "Неуспешно изпращане на известие за просрочена фактура",
"reports.loadingReports": "Зареждане на отчетите...",
"reports.financialReportsAndAnalytics": "Финансови отчети и анализ",
"reports.comprehensiveFinancialInsights": "Цялостни финансови прозрения, анализ на приходите и мониторинг на просрочените",
"reports.exportRevenueReport": "Отчет Приходи",
"reports.exportOverdueReport": "Отчет Просрочия",
"reports.dateRange": "Период",
"reports.lastWeek": "Последната седмица",
"reports.lastMonth": "Последният месец",
"reports.lastQuarter": "Последното тримесечие",
"reports.lastYear": "Последната година",
"reports.company": "Компания",
"reports.allCompanies": "Всички компании",
"reports.partner": "Партньор",
"reports.allPartners": "Всички партньори",
"reports.applyFilters": "Приложи филтри",
"reports.analyticsDashboard": "Табло за анализ",
"reports.revenueReports": "Отчети за приходите",
"reports.overdueAlerts": "Известия за просрочени",
"reports.alertSettings": "Настройки за известия",
"reports.totalRevenue": "Общи приходи",
"reports.paymentsReceived": "Получени плащания",
"reports.outstanding": "Неплатени",
"reports.totalInvoiceAmount": "Обща сума на фактурите",
"reports.revenueTrend": "Тенденция на приходите",
"reports.invoiceStatusDistribution": "Разпределение на статуса на фактурите",
"reports.topPartnersByRevenue": "Топ партньори по приходи",
"reports.monthlyRevenueReport": "Месечен отчет за приходите",
"reports.comprehensiveMonthlyRevenueAnalysis": "Цялостен месечен анализ на приходите с разбивка по партньори",
"reports.generateReport": "Генерирай отчет",
"reports.partnerPerformanceReport": "Отчет за представянето на партньорите",
"reports.detailedAnalysisOfPartnerPayment": "Детайлен анализ на поведението на партньорите при плащане и принос за приходите",
"reports.collectionEfficiencyReport": "Отчет за ефективността на събирането",
"reports.analysisOfPaymentCollectionRates": "Анализ на процентите на събиране на плащания и неплатени суми",
"reports.revenueSummary": "Обобщение на приходите",
"reports.averageInvoice": "Средна фактура",
"reports.overdueInvoices": "Просрочени фактури",
"reports.exportReport": "Експортирай отчет",
"reports.noOverdueInvoicesFound": "Не са намерени просрочени фактури!",
"reports.invoice": "Фактура",
"reports.amount": "Сума",
"reports.dueDate": "Дата на падеж",
"reports.daysOverdue": "Дни просрочение",
"reports.severity": "Приоритет",
"reports.actions": "Действия",
"reports.unknownPartner": "Неизвестен партньор",
"reports.days": "дни",
"reports.sendAlert": "Изпрати известие",
"reports.viewInvoice": "Преглед на фактурата",
"reports.overdueAlertSettings": "Настройки за известия за просрочени",
"reports.enableOverdueAlerts": "Активирай известия за просрочени",
"reports.automaticallySendAlerts": "Автоматично изпращане на известия за просрочени фактури",
"reports.earlyWarning": "Ранно предупреждение",
"reports.moderateAlert": "Умерено известие",
"reports.criticalAlert": "Критично известие",
"reports.alertSettingsSavedSuccessfully": "Настройките за известия са запазени успешно!",
"reports.saveSettings": "Запази настройки",
"reports.severityHigh": "ВИСОК",
"reports.severityMedium": "СРЕДЕН",
"reports.severityLow": "НИСЪК",
"incomingInvoices.failedToLoadIncomingInvoices": "Неуспешно зареждане на входящите фактури",
"incomingInvoices.invoiceUploadedSuccessfully": "Фактурата е качена успешно! Моля, прегледайте я по-долу.",
"incomingInvoices.uploadFailed": "Качването е неуспешно",
"incomingInvoices.failedToUploadInvoice": "Неуспешно качване на фактурата",
"incomingInvoices.partnerCreatedSuccessfully": "Партньорът е създаден успешно!",
"incomingInvoices.partnerCreatedSuccessfullyInvoicePending": "Партньорът е създаден успешно! Фактурата сега е в изчакване за преглед.",
"incomingInvoices.failedToCreatePartner": "Неуспешно създаване на партньор",
"incomingInvoices.confirmDeleteInvoice": "Сигурни ли сте, че искате да изтриете тази фактура?",
"incomingInvoices.invoiceDeletedSuccessfully": "Фактурата е изтрита успешно!",
"incomingInvoices.failedToDeleteInvoice": "Неуспешно изтриване на фактурата",
"incomingInvoices.invoiceApprovedSuccessfully": "Фактурата е одобрена успешно!",
"incomingInvoices.failedToApproveInvoice": "Неуспешно одобряване на фактурата",
"incomingInvoices.provideRejectionReason": "Моля, предоставете причина за отхвърлянето:",
"incomingInvoices.invoiceRejectedSuccessfully": "Фактурата е отхвърлена успешно!",
"incomingInvoices.failedToRejectInvoice": "Неуспешно отхвърляне на фактурата",
"incomingInvoices.loadingIncomingInvoices": "Зареждане на входящите фактури...",
"incomingInvoices.incomingInvoices": "Входящи фактури",
"incomingInvoices.uploadAndManageIncomingInvoices": "Качвайте и управлявайте входящи фактури с OCR обработка",
"incomingInvoices.uploadInvoice": "Качи фактура",
"incomingInvoices.incomingInvoicesList": "Списък с входящи фактури",
"incomingInvoices.uploadAFile": "Качи файл",
"incomingInvoices.orDragAndDrop": "или влачи и пусни",
"incomingInvoices.fileTypesSupported": "PNG, JPG, PDF до 10MB",
"incomingInvoices.processingInvoice": "Обработка на фактурата...",
"incomingInvoices.pendingReview": "В изчакване на преглед",
"incomingInvoices.invoice": "фактура",
"incomingInvoices.invoices": "фактури",
"incomingInvoices.awaitingReview": "в изчакване на преглед",
"incomingInvoices.noInvoicesPendingReview": "Няма фактури в изчакване на преглед",
"incomingInvoices.uploadInvoiceToStartReview": "Качете фактура, за да започнете процеса на преглед",
"incomingInvoices.supplier": "Доставчик",
"incomingInvoices.amount": "Сума",
"incomingInvoices.uploaded": "Качена",
"incomingInvoices.actions": "Действия",
"incomingInvoices.viewDetails": "Преглед на детайлите",
"incomingInvoices.approve": "Одобри",
"incomingInvoices.reject": "Отхвърли",
"incomingInvoices.searchInvoices": "Търси фактури...",
"incomingInvoices.allPartners": "Всички партньори",
"incomingInvoices.allPaymentTypes": "Всички типове плащания",
"incomingInvoices.paymentTypeCash": "В брой",
"incomingInvoices.paymentTypeBankTransfer": "Банков превод",
"incomingInvoices.paymentTypeUnknown": "Неизвестен",
"incomingInvoices.clearFilters": "Изчисти филтрите",
"incomingInvoices.incomingInvoice": "входяща фактура",
"incomingInvoices.found": "намерени",
"incomingInvoices.noIncomingInvoicesYet": "Все още няма входящи фактури",
"incomingInvoices.noInvoicesMatchFilters": "Няма фактури, които отговарят на вашите филтри",
"incomingInvoices.uploadInvoiceToGetStarted": "Качете фактура, за да започнете",
"incomingInvoices.tryAdjustingSearchOrFilters": "Опитайте да коригирате търсенето или филтрите",
"incomingInvoices.issueDate": "Дата на издаване",
"incomingInvoices.dueDate": "Дата на падеж",
"incomingInvoices.status": "Статус",
"incomingInvoices.paymentType": "Тип плащане",
"incomingInvoices.edit": "Редактирай",
"incomingInvoices.delete": "Изтрий",
"incomingInvoices.createNewPartner": "Създай нов партньор",
"incomingInvoices.newSupplierDetected": "Беше открит нов доставчик. Моля, прегледайте и потвърдете детайлите на партньора.",
"incomingInvoices.supplierNameNotExtracted": "Името на доставчика не може да бъде извлечено автоматично. Моля, въведете детайлите на партньора ръчно.",
"incomingInvoices.partnerName": "Име на партньора",
"incomingInvoices.taxIdIfStartsWithoutBG": "Данъчен номер (ако не започва с BG)",
"incomingInvoices.vatTaxIdIfStartsWithBG": "ДДС номер (ако започва с BG)",
"incomingInvoices.address": "Адрес",
"incomingInvoices.city": "Град",
"incomingInvoices.country": "Държава",
"incomingInvoices.mrp": "МОЛ",
"incomingInvoices.bankName": "Име на банката",
"incomingInvoices.swiftBicCode": "SWIFT/BIC код",
"incomingInvoices.iban": "IBAN",
"incomingInvoices.email": "Имейл",
"incomingInvoices.phone": "Телефон",
"incomingInvoices.cancel": "Отказ",
"incomingInvoices.createPartner": "Създай партньор",
"incomingInvoices.statusPaid": "Платена",
"incomingInvoices.statusPending": "В изчакване",
"incomingInvoices.statusRejected": "Отхвърлена",
"incomingInvoiceDetails.failedToFetchInvoiceDetails": "Неуспешно извличане на детайлите на фактурата",
"incomingInvoiceDetails.failedToLoadInvoiceDetails": "Неуспешно зареждане на детайлите на фактурата",
"incomingInvoiceDetails.invoiceDeletedSuccessfully": "Фактурата е изтрита успешно!",
"incomingInvoiceDetails.failedToDeleteInvoice": "Неуспешно изтриване на фактурата",
"incomingInvoiceDetails.invoiceStatusUpdatedSuccessfully": "Статусът на фактурата е обновен успешно!",
"incomingInvoiceDetails.failedToUpdateInvoiceStatus": "Неуспешно обновяване на статуса на фактурата",
"incomingInvoiceDetails.loadingInvoiceDetails": "Зареждане на детайлите на фактурата...",
"incomingInvoiceDetails.invoiceNotFound": "Фактурата не е намерена",
"incomingInvoiceDetails.backToIncomingInvoices": "Обратно към входящите фактури",
"incomingInvoiceDetails.incomingInvoiceDetails": "Детайли на входяща фактура",
"incomingInvoiceDetails.invoiceInformation": "Информация за фактурата",
"incomingInvoiceDetails.invoiceNumber": "Номер на фактурата",
"incomingInvoiceDetails.invoiceType": "Тип на фактурата",
"incomingInvoiceDetails.original": "ОРИГИНАЛ",
"incomingInvoiceDetails.status": "Статус",
"incomingInvoiceDetails.createdAt": "Създадена на",
"incomingInvoiceDetails.issueDate": "Дата на издаване",
"incomingInvoiceDetails.dueDate": "Дата на падеж",
"incomingInvoiceDetails.currency": "Валута",
"incomingInvoiceDetails.paymentType": "Тип плащане",
"incomingInvoiceDetails.unknown": "Неизвестен",
"incomingInvoiceDetails.lineItems": "Артикули",
"incomingInvoiceDetails.description": "Описание",
"incomingInvoiceDetails.quantity": "Количество",
"incomingInvoiceDetails.unitPrice": "Единична цена",
"incomingInvoiceDetails.total": "Общо",
"incomingInvoiceDetails.noItemsExtractedFromOCR": "Не могат да бъдат извлечени артикули от OCR данните",
"incomingInvoiceDetails.subtotal": "Междинна сума",
"incomingInvoiceDetails.vat": "ДДС",
"incomingInvoiceDetails.totalAmount": "Обща сума",
"incomingInvoiceDetails.euroEquivalent": "Еквивалент в евро",
"incomingInvoiceDetails.partnerDetails": "Детайли за партньора",
"incomingInvoiceDetails.contact": "Контакт",
"incomingInvoiceDetails.email": "Имейл",
"incomingInvoiceDetails.phone": "Телефон",
"incomingInvoiceDetails.taxId": "Данъчен номер",
"incomingInvoiceDetails.vatTaxId": "ДДС номер",
"incomingInvoiceDetails.bank": "Банка",
"incomingInvoiceDetails.noPartnerDetailsAvailable": "Няма налични детайли за партньора",
"incomingInvoiceDetails.paymentStatus": "Статус на плащането",
"incomingInvoiceDetails.amountPaid": "Платена сума",
"incomingInvoiceDetails.remaining": "Оставаща",
"incomingInvoiceDetails.paid": "Платена",
"incomingInvoiceDetails.statusActions": "Действия за статуса",
"incomingInvoiceDetails.markAsApproved": "Маркирай като одобрена",
"incomingInvoiceDetails.markAsRejected": "Маркирай като отхвърлена",
"incomingInvoiceDetails.markAsPaid": "Маркирай като платена",
"incomingInvoiceDetails.deleteInvoice": "Изтрий фактурата",
"incomingInvoiceDetails.confirmDeleteInvoice": "Сигурни ли сте, че искате да изтриете фактурата",
"incomingInvoiceDetails.actionCannotBeUndone": "Това действие не може да бъде отменено.",
"incomingInvoiceDetails.cancel": "Отказ",
"incomingInvoiceDetails.delete": "Изтрий",
"incomingInvoiceDetails.statusPaid": "Платена",
"incomingInvoiceDetails.statusPending": "В изчакване",
"incomingInvoiceDetails.statusApproved": "Одобрена",
"incomingInvoiceDetails.statusRejected": "Отхвърлена",
"creditNoteCreate.failedToCreateCreditNote": "Неуспешно създаване на кредитно известие",
"creditNoteCreate.creditNoteCreatedSuccessfully": "Кредитното известие е създадено успешно!",
"creditNoteCreate.createCreditNote": "Създай кредитно известие",
"creditNoteCreate.createNewCreditNoteDescription": "Създайте ново кредитно известие за връщания, отстъпки или корекции",
"creditNoteCreate.originalInvoice": "Оригинална фактура",
"creditNoteCreate.selectOriginalInvoice": "Избери оригинална фактура",
"creditNoteCreate.chooseAnInvoice": "Избери фактура...",
"creditNoteCreate.selectedInvoiceDetails": "Детайли за избраната фактура",
"creditNoteCreate.invoiceNumber": "Номер на фактурата",
"creditNoteCreate.partner": "Партньор",
"creditNoteCreate.issueDate": "Дата на издаване",
"creditNoteCreate.totalAmount": "Обща сума",
"creditNoteCreate.creditNoteDetails": "Детайли за кредитното известие",
"creditNoteCreate.dueDate": "Дата на падеж",
"creditNoteCreate.currency": "Валута",
"creditNoteCreate.items": "Артикули",
"creditNoteCreate.addItem": "Добави артикул",
"creditNoteCreate.description": "Описание",
"creditNoteCreate.itemDescription": "Описание на артикула",
"creditNoteCreate.quantity": "Количество",
"creditNoteCreate.unitPrice": "Единична цена",
"creditNoteCreate.total": "Общо",
"creditNoteCreate.summary": "Обобщение",
"creditNoteCreate.subtotal": "Междинна сума",
"creditNoteCreate.taxAmount": "Данъчна сума",
"creditNoteCreate.notes": "Бележки",
"creditNoteCreate.additionalNotesOrComments": "Допълнителни бележки или коментари...",
"creditNoteCreate.cancel": "Отказ",
"creditNoteCreate.creating": "Създаване...",
"creditNoteCreate.createCreditNote": "Създай кредитно известие",
"creditNoteList.failedToFetchCreditNotes": "Неуспешно извличане на кредитните известия",
"creditNoteList.failedToLoadCreditNotes": "Неуспешно зареждане на кредитните известия",
"creditNoteList.failedToDownloadCreditNoteAsPDF": "Неуспешно изтегляне на кредитното известие като PDF",
"creditNoteList.creditNoteDownloadedSuccessfully": "Кредитното известие е изтеглено като {type} PDF успешно!",
"creditNoteList.failedToLoadCreditNoteForPrinting": "Неуспешно зареждане на кредитното известие за печат",
"creditNoteList.failedToPrintCreditNote": "Неуспешен печат на кредитното известие",
"creditNoteList.confirmDeleteCreditNote": "Сигурни ли сте, че искате да изтриете това кредитно известие?",
"creditNoteList.failedToDeleteCreditNote": "Неуспешно изтриване на кредитното известие",
"creditNoteList.creditNoteDeletedSuccessfully": "Кредитното известие е изтрито успешно!",
"creditNoteList.creditNotes": "Кредитни известия",
"creditNoteList.manageCreditNotesDescription": "Управлявайте кредитни известия за връщания, отстъпки и корекции",
"creditNoteList.newCreditNote": "Ново кредитно известие",
"creditNoteList.searchCreditNotes": "Търси кредитни известия...",
"creditNoteList.allStatuses": "Всички статуси",
"creditNoteList.statusDraft": "Чернова",
"creditNoteList.statusSent": "Изпратено",
"creditNoteList.statusPaid": "Платено",
"creditNoteList.statusPartial": "Частично",
"creditNoteList.statusOverdue": "Просрочено",
"creditNoteList.statusCancelled": "Отменено",
"creditNoteList.allPartners": "Всички партньори",
"creditNoteList.allCompanies": "Всички компании",
"creditNoteList.clearFilters": "Изчисти филтрите",
"creditNoteList.creditNote": "Кредитно известие",
"creditNoteList.creditNotes": "Кредитни известия",
"creditNoteList.found": "намерени",
"creditNoteList.originalInvoice": "Оригинална фактура",
"creditNoteList.partner": "Партньор",
"creditNoteList.issueDate": "Дата на издаване",
"creditNoteList.dueDate": "Дата на падеж",
"creditNoteList.amount": "Сума",
"creditNoteList.status": "Статус",
"creditNoteList.actions": "Действия",
"creditNoteList.notAvailable": "Н/Д",
"creditNoteList.viewDetails": "Преглед на детайлите",
"creditNoteList.download": "Изтегли",
"creditNoteList.downloadOriginal": "Изтегли оригинал",
"creditNoteList.downloadCopy": "Изтегли копие",
"creditNoteList.print": "Печат",
"creditNoteList.printOriginal": "Печат оригинал",
"creditNoteList.printCopy": "Печат копие",
"creditNoteList.edit": "Редактирай",
"creditNoteList.delete": "Изтрий",
"creditNoteList.previous": "Предишна",
"creditNoteList.next": "Следваща",
"creditNoteList.showing": "Показване на",
"creditNoteList.to": "до",
"creditNoteList.of": "от",
"creditNoteList.results": "резултата",
"creditNoteList.noCreditNotes": "Няма кредитни известия",
"creditNoteList.getStartedByCreatingNewCreditNote": "Започнете като създадете ново кредитно известие.",
"creditNoteDetails.creditNoteDetails": "Детайли за кредитно известие",
"creditNoteDetails.backToCreditNotes": "Обратно към кредитни известия",
"creditNoteDetails.downloadAsPDF": "Изтегли като PDF",
"creditNoteDetails.downloadOriginal": "Изтегли оригинал",
"creditNoteDetails.downloadCopy": "Изтегли копие",
"creditNoteDetails.printPDF": "Принтирай PDF",
"creditNoteDetails.printOriginal": "Принтирай оригинал",
"creditNoteDetails.printCopy": "Принтирай копие",
"creditNoteDetails.creditNoteInformation": "Информация за кредитно известие",
"creditNoteDetails.items": "Артикули",
"creditNoteDetails.summary": "Обобщение",
"creditNoteDetails.notes": "Бележки",
"creditNoteDetails.companyInformation": "Компания (Доставчик)",
"creditNoteDetails.partnerInformation": "Партньор (Получател)",
"creditNoteDetails.bankAccountInformation": "Банкова сметка",
"creditNoteDetails.creditNoteNumber": "Номер на кредитно известие",
"creditNoteDetails.originalInvoice": "Оригинална фактура",
"creditNoteDetails.issueDate": "Дата на издаване",
"creditNoteDetails.dueDate": "Дата на падеж",
"creditNoteDetails.status": "Статус",
"creditNoteDetails.currency": "Валута",
"creditNoteDetails.type": "Тип",
"creditNoteDetails.no": "№",
"creditNoteDetails.description": "Описание",
"creditNoteDetails.quantity": "Количество",
"creditNoteDetails.unitPrice": "Единична цена",
"creditNoteDetails.total": "Общо",
"creditNoteDetails.bgn": "лв.",
"creditNoteDetails.eur": "EUR",
"creditNoteDetails.subtotal": "Междинна сума",
"creditNoteDetails.taxAmount": "Данъчна сума (20%)",
"creditNoteDetails.totalAmount": "Обща сума",
"creditNoteDetails.mol": "МОЛ",
"creditNoteDetails.vatTaxId": "ДДС номер",
"creditNoteDetails.taxId": "Данъчен номер",
"creditNoteDetails.contact": "Контакт",
"creditNoteDetails.bank": "Банка",
"creditNoteDetails.bic": "BIC",
"creditNoteDetails.iban": "IBAN",
"creditNoteDetails.authenticationRequired": "Изисква се удостоверяване",
"creditNoteDetails.pleaseLoginToContinue": "Моля, влезте в профила си, за да продължите с прегледа на детайлите за кредитно известие.",
"creditNoteDetails.refreshAndLogin": "Обнови и влез",
"creditNoteDetails.noTokenError": "Не е намерен токен за удостоверяване. Моля, влезте отново.",
"creditNoteDetails.authenticationError": "Грешка при удостоверяване: JWT изтекъл",
"creditNoteDetails.pleaseLoginAgain": "Моля, влезте отново, за да продължите.",
"creditNoteDetails.failedToFetchCreditNote": "Неуспешно извличане на кредитно известие",
"creditNoteDetails.failedToLoadCreditNoteDetails": "Неуспешно зареждане на детайлите за кредитно известие",
"creditNoteDetails.creditNoteNotFound": "Кредитно известие не е намерено",
"creditNoteDetails.failedToDownloadCreditNote": "Неуспешно изтегляне на кредитно известие",
"creditNoteDetails.downloadSuccess": "Кредитно известие изтеглено като {type} PDF успешно!",
"creditNoteDetails.failedToPrintCreditNote": "Неуспешно принтиране на кредитно известие",
"creditNoteDetails.printSuccess": "Кредитно известие принтирано като {type} успешно!",
"creditNoteDetails.statusDraft": "Чернова",
"creditNoteDetails.statusSent": "Изпратено",
"creditNoteDetails.statusPaid": "Платено",
"creditNoteDetails.statusPartial": "Частично платено",
"creditNoteDetails.statusOverdue": "Просрочено",
"creditNoteDetails.statusCancelled": "Отменено",
"creditNoteDetails.typeORIGINAL": "ОРИГИНАЛ",
"creditNoteDetails.typeCOPY": "КОПИЕ",
  "debitNoteCreate.title": "Създаване на дебитно известие",
  "debitNoteCreate.subtitle": "Създайте ново дебитно известие за допълнителни такси, корекции или допълнително фактуриране",
  "debitNoteCreate.originalInvoice.title": "Оригинална фактура",
  "debitNoteCreate.originalInvoice.selectLabel": "Изберете оригинална фактура",
  "debitNoteCreate.originalInvoice.placeholder": "Изберете фактура...",
  "debitNoteCreate.originalInvoice.detailsTitle": "Детайли на избраната фактура",
  "debitNoteCreate.originalInvoice.invoiceNumber": "Номер на фактурата",
  "debitNoteCreate.originalInvoice.partner": "Партньор",
  "debitNoteCreate.originalInvoice.issueDate": "Дата на издаване",
  "debitNoteCreate.originalInvoice.totalAmount": "Обща сума",
  "debitNoteCreate.details.title": "Детайли на дебитното известие",
  "debitNoteCreate.details.issueDate": "Дата на издаване",
  "debitNoteCreate.details.dueDate": "Дата на падеж",
  "debitNoteCreate.details.currency": "Валута",
  "debitNoteCreate.items.title": "Артикули",
  "debitNoteCreate.items.addItem": "Добави артикул",
  "debitNoteCreate.items.description": "Описание",
  "debitNoteCreate.items.descriptionPlaceholder": "Описание на артикула",
  "debitNoteCreate.items.quantity": "Количество",
  "debitNoteCreate.items.unitPrice": "Единична цена",
  "debitNoteCreate.items.total": "Общо",
  "debitNoteCreate.summary.title": "Обобщение",
  "debitNoteCreate.summary.subtotal": "Междинна сума",
  "debitNoteCreate.summary.taxAmount": "Данъчна сума",
  "debitNoteCreate.summary.totalAmount": "Обща сума",
  "debitNoteCreate.notes.title": "Бележки",
  "debitNoteCreate.notes.placeholder": "Допълнителни бележки или коментари...",
  "debitNoteCreate.buttons.cancel": "Отказ",
  "debitNoteCreate.buttons.create": "Създай дебитно известие",
  "debitNoteCreate.buttons.creating": "Създаване...",
  "debitNoteCreate.successMessage": "Дебитното известие е създадено успешно!",
"debitNoteList.failedToFetchDebitNotes": "Грешка при зареждане на дебитни известия",
  "debitNoteList.failedToFetchPartners": "Грешка при зареждане на партньори",
  "debitNoteList.failedToFetchCompanies": "Грешка при зареждане на компании",
  "debitNoteList.downloadSuccess": "Дебитното известие е изтеглено като {type} PDF успешно!",
  "debitNoteList.failedToDownload": "Грешка при изтегляне на дебитното известие като PDF",
  "debitNoteList.failedToLoadForPrinting": "Грешка при зареждане на дебитното известие за печат",
  "debitNoteList.failedToPrint": "Грешка при печат на дебитното известие",
  "debitNoteList.confirmDelete": "Сигурни ли сте, че искате да изтриете това дебитно известие?",
  "debitNoteList.failedToDelete": "Грешка при изтриване на дебитното известие",
  "debitNoteList.deleteSuccess": "Дебитното известие е изтрито успешно!",
  "debitNoteList.statusDraft": "Чернова",
  "debitNoteList.statusSent": "Изпратено",
  "debitNoteList.statusPartial": "Частично",
  "debitNoteList.statusPaid": "Платено",
  "debitNoteList.statusOverdue": "Просрочено",
  "debitNoteList.statusCancelled": "Отменено",
  "debitNoteList.title": "Дебитни известия",
  "debitNoteList.subtitle": "Управление на дебитни известия за допълнителни такси и корекции",
  "debitNoteList.newDebitNote": "Ново дебитно известие",
  "debitNoteList.searchPlaceholder": "Търсене на дебитни известия...",
  "debitNoteList.allStatuses": "Всички статуси",
  "debitNoteList.allPartners": "Всички партньори",
  "debitNoteList.allCompanies": "Всички компании",
  "debitNoteList.clearFilters": "Изчисти филтрите",
  "debitNoteList.debitNote": "дебитно известие",
  "debitNoteList.debitNotes": "дебитни известия",
  "debitNoteList.found": "намерени",
  "debitNoteList.originalInvoice": "Оригинална фактура",
  "debitNoteList.partner": "Партньор",
  "debitNoteList.issueDate": "Дата на издаване",
  "debitNoteList.amount": "Сума",
  "debitNoteList.status": "Статус",
  "debitNoteList.actions": "Действия",
  "debitNoteList.notAvailable": "Н/Д",
  "debitNoteList.viewDetails": "Преглед на детайлите",
  "debitNoteList.download": "Изтегляне",
  "debitNoteList.downloadOriginal": "Изтегли оригинал",
  "debitNoteList.downloadCopy": "Изтегли копие",
  "debitNoteList.print": "Печат",
  "debitNoteList.printOriginal": "Печат оригинал",
  "debitNoteList.printCopy": "Печат копие",
  "debitNoteList.edit": "Редактиране",
  "debitNoteList.delete": "Изтриване",
  "debitNoteList.previous": "Предишна",
  "debitNoteList.next": "Следваща",
  "debitNoteList.showingPage": "Показване на страница",
  "debitNoteList.of": "от",
  "debitNoteList.noDebitNotesFound": "Не са намерени дебитни известия.",
 "debitNoteDetails.failedToFetchDebitNote": "Грешка при зареждане на дебитното известие",
  "debitNoteDetails.failedToLoadDebitNoteDetails": "Грешка при зареждане на детайлите на дебитното известие",
  "debitNoteDetails.failedToDownloadDebitNote": "Грешка при изтегляне на дебитното известие",
  "debitNoteDetails.downloadSuccess": "Дебитното известие е изтеглено като {type} PDF успешно!",
  "debitNoteDetails.failedToPrintDebitNote": "Грешка при печат на дебитното известие",
  "debitNoteDetails.printSuccess": "Дебитното известие е отворено за печат като {type}!",
  "debitNoteDetails.statusDraft": "Чернова",
  "debitNoteDetails.statusSent": "Изпратено",
  "debitNoteDetails.statusPaid": "Платено",
  "debitNoteDetails.statusPartial": "Частично",
  "debitNoteDetails.statusOverdue": "Просрочено",
  "debitNoteDetails.statusCancelled": "Отменено",
  "debitNoteDetails.debitNoteNotFound": "Дебитното известие не е намерено",
  "debitNoteDetails.backToDebitNotes": "Назад към дебитните известия",
  "debitNoteDetails.debitNoteDetails": "Детайли на дебитното известие",
  "debitNoteDetails.downloadAsPDF": "Изтегли като PDF",
  "debitNoteDetails.downloadOriginal": "Изтегли оригинал",
  "debitNoteDetails.downloadCopy": "Изтегли копие",
  "debitNoteDetails.printPDF": "Печат PDF",
  "debitNoteDetails.printOriginal": "Печат оригинал",
  "debitNoteDetails.printCopy": "Печат копие",
  "debitNoteDetails.debitNoteInformation": "Информация за дебитното известие",
  "debitNoteDetails.debitNoteNumber": "Номер на дебитното известие",
  "debitNoteDetails.originalInvoice": "Оригинална фактура",
  "debitNoteDetails.issueDate": "Дата на издаване",
  "debitNoteDetails.dueDate": "Дата на падеж",
  "debitNoteDetails.status": "Статус",
  "debitNoteDetails.currency": "Валута",
  "debitNoteDetails.type": "Тип",
  "debitNoteDetails.items": "Артикули",
  "debitNoteDetails.no": "№",
  "debitNoteDetails.description": "Описание",
  "debitNoteDetails.quantity": "Количество",
  "debitNoteDetails.unitPrice": "Единична цена",
  "debitNoteDetails.total": "Общо",
  "debitNoteDetails.summary": "Обобщение",
  "debitNoteDetails.subtotal": "Междинна сума",
  "debitNoteDetails.taxAmount": "Данъчна сума",
  "debitNoteDetails.totalAmount": "Обща сума",
  "debitNoteDetails.notes": "Бележки",
  "debitNoteDetails.companySupplier": "Компания (Доставчик)",
  "debitNoteDetails.mol": "МОЛ",
  "debitNoteDetails.vatTaxId": "ДДС номер",
  "debitNoteDetails.taxId": "Данъчен номер",
  "debitNoteDetails.partnerRecipient": "Партньор (Получател)",
  "debitNoteDetails.contact": "Контакт",
  "debitNoteDetails.bankAccount": "Банкова сметка",
  "debitNoteDetails.bank": "Банка",
  "debitNoteDetails.bic": "BIC",
  "debitNoteDetails.iban": "IBAN",
 "debitNoteDetails.typeORIGINAL": "ОРИГИНАЛ",
  "debitNoteDetails.typeCOPY": "КОПИЕ",
"contracts.contractsManagement": "Управление на договори",
  "contracts.manageBusinessContracts": "Управлявайте всички ваши бизнес договори и документи",
  "contracts.addNewContract": "Добави нов договор",
  "contracts.contracts": "Договори",
  "contracts.settings": "Настройки",
  "contracts.searchContracts": "Търсене на договори...",
  "contracts.allStatuses": "Всички статуси",
  "contracts.active": "Активен",
  "contracts.pending": "Чакащ",
  "contracts.completed": "Завършен",
  "contracts.terminated": "Прекратен",
  "contracts.expired": "Изтекъл",
  "contracts.contractId": "ID на договора",
  "contracts.name": "Име",
  "contracts.client": "Клиент",
  "contracts.type": "Тип",
  "contracts.value": "Стойност",
  "contracts.status": "Статус",
  "contracts.expiryDate": "Дата на изтичане",
  "contracts.actions": "Действия",
  "contracts.noContractsFound": "Не са намерени договори",
  "contracts.tryAdjustingSearch": "Опитайте да коригирате критериите за търсене или филтриране.",
  "contracts.getStartedCreatingContract": "Започнете със създаването на нов договор.",
  "contracts.storageConfiguration": "Конфигурация на съхранението",
  "contracts.uploadDirectory": "Директория за качване",
  "contracts.enterFullPathToStorage": "Въведете пълния път до директорията за съхранение",
  "contracts.saving": "Запазване...",
  "contracts.savePath": "Запази пътя",
  "contracts.resetToDefault": "Възстанови по подразбиране",
  "contracts.enterFullPathForContractFiles": "Въведете пълния път, където искате да съхраните качените файлове на договорите",
  "contracts.examplePaths": "Пример: /Users/username/Documents/Contracts или C:\\Users\\username\\Documents\\Contracts",
  "contracts.currentStorageDirectory": "Текуща директория за съхранение",
  "contracts.defaultBackendDirectory": "Директория по подразбиране на backend",
  "contracts.newFilesWillBeStoredHere": "Новите файлове ще се съхраняват на това място",
  "contracts.maximumFileSize": "Максимален размер на файла",
  "contracts.allowedFileTypes": "Разрешени типове файлове",
  "contracts.contractTemplates": "Шаблони за договори",
  "contracts.autoGenerateContractId": "Автоматично генериране на ID на договора",
  "contracts.requireProjectAssignment": "Изисква се назначение на проект",
  "contracts.sendExpiryNotifications": "Изпращане на известия за изтичане",
  "contracts.contractStatusManagement": "Управление на статуса на договорите",
  "contracts.automaticallyUpdateContractStatuses": "Автоматично актуализиране на всички статуси на договорите въз основа на техните начални и крайни дати.",
  "contracts.updating": "Актуализиране...",
  "contracts.updateAllContractStatuses": "Актуализирай всички статуси на договорите",
  "contracts.statusUpdateFlow": "Това ще актуализира Чакащ → Активен → Изтекъл въз основа на текущата дата",
  "contracts.editContract": "Редактирай договора",
  "contracts.contractName": "Име на договора",
  "contracts.clientName": "Име на клиента",
  "contracts.contractType": "Тип на договора",
  "contracts.service": "Услуга",
  "contracts.supply": "Доставка",
  "contracts.construction": "Строителство",
  "contracts.consulting": "Консултиране",
  "contracts.other": "Друго",
  "contracts.startDate": "Начална дата",
  "contracts.contractValue": "Стойност на договора",
  "contracts.description": "Описание",
  "contracts.responsiblePerson": "Отговорно лице",
  "contracts.cancel": "Отказ",
  "contracts.createContract": "Създай договор",
  "contracts.updateContract": "Актуализирай договора",
  "contracts.contractDetails": "Детайли на договора",
  "contracts.createdBy": "Създаден от",
  "contracts.unknown": "Неизвестно",
  "contracts.attachedFiles": "Прикачени файлове",
  "contracts.openFileLocation": "Отвори местоположението на файла",
  "contracts.deleteFile": "Изтрий файла",
  "contracts.close": "Затвори",
  "contracts.uploadFiles": "Качи файлове",
  "contracts.fileCategory": "Категория на файла",
  "contracts.mainContract": "Основен договор",
  "contracts.amendment": "Изменение",
  "contracts.attachment": "Приложение",
  "contracts.selectFiles": "Избери файлове",
  "contracts.maxFileSizeAndTypes": "Макс. размер на файла: 10MB. Разрешени типове: PDF, DOC, DOCX, TXT, JPG, JPEG, PNG",
  "contracts.selectedFiles": "Избрани файлове",
  "contracts.storageDirectoryUpdated": "Директорията за съхранение е актуализирана успешно!",
  "contracts.errorUpdatingStorageDirectory": "Грешка при актуализиране на директорията за съхранение. Моля, проверете пътя и правата.",
  "contracts.resetToDefaultDirectory": "Възстановяването до директорията по подразбиране е успешно!",
  "contracts.errorResettingToDefault": "Грешка при възстановяване до директорията по подразбиране.",
  "contracts.successfullyUpdatedContractStatuses": "Успешно актуализирани {{count}} статуса на договори!",
  "contracts.errorUpdatingContractStatuses": "Грешка при актуализираne на статусите на договорите. Моля, опитайте отново.",
  "contracts.errorSavingContract": "Грешка при запазване на договора. Моля, опитайте отново.",
  "contracts.confirmDeleteContract": "Сигурни ли сте, че искате да изтриете този договор?",
  "contracts.errorDeletingContract": "Грешка при изтриване на договора. Моля, опитайте отново.",
  "contracts.confirmDeleteFile": "Сигурни ли сте, че искате да изтриете този файл?",
  "contracts.errorDeletingFile": "Грешка при изтриване на файла. Моля, опитайте отново.",
  "contracts.contractNotFound": "Договорът не е намерен",
  "contracts.fileNotFound": "Файлът не е намерен",
  "contracts.couldNotOpenFileLocation": "Не може да се отвори местоположението на файла. Файлът може да е преместен или изтрит.",
  "contracts.errorOpeningFileLocation": "Грешка при отваряне на местоположението на файла. Моля, проверете дали файлът все още съществува.",
  "contracts.fileUploadFailed": "Качването на файла неуспешно",
  "contracts.errorUploadingFiles": "Грешка при качване на файлове: {{error}}",
  "contracts.viewDetails": "Преглед на детайлите",
  "contracts.manageFiles": "Управление на файлове",
  "contracts.deleteContract": "Изтрий договора",
  "contracts.mb": "MB",
  "contracts.loading": "Зареждане...",
"contracts.statusActive": "Активен",
  "contracts.statusPending": "Чакащ",
  "contracts.statusCompleted": "Завършен",
  "contracts.statusTerminated": "Прекратен",
  "contracts.statusExpired": "Изтекъл",
 "workers.workersManagement": "Управление на работници",
  "workers.manageWorkersAnalyzeProjects": "Управлявайте работници, анализирайте назначенията на проекти и проследявайте работните часове",
  "workers.addWorker": "Добави работник",
  "workers.importExcel": "Импортирай Excel",
  "workers.readOnlyMode": "Режим само за четене",
  "workers.searchWorkers": "Търсене на работници...",
  "workers.searchDisabledReadOnly": "Търсенето е деактивирано в режим само за четене",
  "workers.tabSwitchingDisabledReadOnly": "Превключването на табове е деактивирано в режим само за четене",
  "workers.activeWorkers": "Активни работници",
  "workers.workerAnalysis": "Анализ на работниците",
  "workers.archivedWorkers": "Архивирани работници",
  "workers.workerName": "Име на работника",
  "workers.location": "Местоположение",
  "workers.contact": "Контакт",
  "workers.status": "Статус",
  "workers.totalHours": "Общо часове",
  "workers.projects": "Проекти",
  "workers.actions": "Действия",
  "workers.loadingWorkersData": "Зареждане на данните за работниците...",
  "workers.noWorkersFound": "Не са намерени работници",
  "workers.tryAdjustingSearchCriteria": "Опитайте да коригирате критериите за търсене.",
  "workers.getStartedAddingNewWorker": "Започнете с добавянето на нов работник.",
  "workers.projectDetails": "Детайли на проекта",
  "workers.totalWorkers": "Общо работници",
  "workers.selectProject": "Избери проект",
  "workers.chooseAProject": "Избери проект...",
  "workers.project": "Проект",
  "workers.unknownProject": "Неизвестен проект",
  "workers.additionalWorkingHours": "Допълнителни работни часове",
  "workers.noProjectDataAvailable": "Няма налични данни за проекта",
  "workers.projectNoWorkingHoursRecorded": "Този проект може да няма записани работни часове все още.",
  "workers.view": "Изглед",
  "workers.hours": "Часове",
  "workers.percentage": "Процент",
  "workers.showWeekends": "Покажи уикендите",
  "workers.showHolidays": "Покажи празниците",
  "workers.worker": "Работник",
  "workers.monthlyTotals": "Месечни общо",
  "workers.loadingMonthlyDutyData": "Зареждане на месечните данни за дежурства...",
  "workers.noWorkersFoundForProject": "Не са намерени работници за този проект през {{month}} {{year}}",
  "workers.dailyTotals": "Дневни общо",
  "workers.workingDays": "Работни дни",
  "workers.avgDailyWorkers": "Средно дневни работници",
  "workers.noMonthlyDutyDataAvailable": "Няма налични месечни данни за дежурства",
  "workers.projectNoWorkingHoursRecordedForMonth": "Този проект може да няма записани работни часове за {{month}} {{year}}.",
  "workers.searchArchivedWorkers": "Търсене на архивирани работници...",
  "workers.loadingArchivedWorkers": "Зареждане на архивираните работници...",
  "workers.noArchivedWorkersFound": "Не са намерени архивирани работници",
  "workers.noWorkersArchivedYet": "Все още не са архивирани работници.",
  "workers.totalArchivedWorkers": "Общо архивирани работници",
  "workers.contractFrom": "Договор от",
  "workers.editWorker": "Редактирай работника",
  "workers.addNewWorker": "Добави нов работник",
  "workers.name": "Име",
  "workers.enterWorkerName": "Въведете име на работника",
  "workers.cityVillage": "Град/Село",
  "workers.phoneNumberOrEmail": "Телефонен номер или имейл",
  "workers.statusActive": "Активен",
  "workers.statusInactive": "Неактивен",
  "workers.cancel": "Отказ",
  "workers.save": "Запази",
  "workers.inputDisabledReadOnly": "Въвеждането е деактивирано в режим само за четене",
  "workers.selectDisabledReadOnly": "Изборът е деактивиран в режим само за четене",
  "workers.cancelDisabledReadOnly": "Отказът е деактивиран в режим само за четене",
  "workers.saveDisabledReadOnly": "Запазването е деактивирано в режим само за четене",
  "workers.noPermissionToEdit": "Нямате разрешение за редактиране.",
  "workers.importComplete": "Импортирането завърши: {{added}} добавени, {{skipped}} пропуснати.",
  "workers.importFailed": "Импортирането неуспешно.",
  "workers.january": "Януари",
  "workers.february": "Февруари",
  "workers.march": "Март",
  "workers.april": "Април",
  "workers.may": "Май",
  "workers.june": "Юни",
  "workers.july": "Юли",
  "workers.august": "Август",
  "workers.september": "Септември",
  "workers.october": "Октомври",
  "workers.november": "Ноември",
  "workers.december": "Декември",
 "workers.project": "проект",
  "workers.projects": "проекта",
  "workers.day": "ден",
  "workers.days": "дни",
 "employeeDashboard.loadingYourDashboard": "Зареждане на вашия панел...",
  "employeeDashboard.noAuthenticationTokenFound": "Не е намерен токен за удостоверяване. Моля, влезте в системата.",
  "employeeDashboard.userDataNotFound": "Данните за потребителя не са намерени. Моля, влезте отново в системата.",
  "employeeDashboard.authenticationFailed": "Удостоверяването неуспешно. Моля, влезте отново в системата.",
  "employeeDashboard.failedToLoadData": "Неуспешно зареждане на данните. Моля, опитайте отново.",
  "employeeDashboard.tryAgain": "Опитайте отново",
  "employeeDashboard.goToLogin": "Отидете на влизане",
  "employeeDashboard.welcomeBack": "Добре дошли отново",
  "employeeDashboard.employee": "Служител",
  "employeeDashboard.online": "Онлайн",
  "employeeDashboard.offline": "Офлайн",
  "employeeDashboard.notifications": "Известия",
  "employeeDashboard.noNotifications": "Няма известия",
  "employeeDashboard.loadingNotifications": "Зареждане на известия...",
  "employeeDashboard.lastUpdated": "Последно актуализирано",
  "employeeDashboard.totalProjects": "Общо проекти",
  "employeeDashboard.activeProjects": "Активни проекти",
  "employeeDashboard.completedToday": "Завършени днес",
  "employeeDashboard.totalHours": "Общо часове",
  "employeeDashboard.yourProjects": "Вашите проекти",
  "employeeDashboard.progress": "Прогрес",
  "employeeDashboard.location": "Местоположение",
  "employeeDashboard.dueDate": "Крайна дата",
  "employeeDashboard.assignedWorkers": "Назначени работници",
  "employeeDashboard.dailyTargets": "Дневни цели",
  "employeeDashboard.workingHours": "Работни часове",
  "employeeDashboard.additionalWork": "Допълнителна работа",
  "employeeDashboard.totalProjectHours": "Общо часове на проекта",
  "employeeDashboard.workers": "работници",
  "employeeDashboard.units": "единици",
  "employeeDashboard.hrs": "ч",
  "employeeDashboard.noProjectsAssignedYet": "Все още няма назначени проекти",
  "employeeDashboard.youWillSeeYourAssignedProjects": "Ще видите вашите назначени проекти тук, след като станат налични.",
  "employeeDashboard.quickActions": "Бързи действия",
  "employeeDashboard.schedule": "График",
  "employeeDashboard.timeTrack": "Проследяване на времето",
  "employeeDashboard.reports": "Отчети",
  "employeeDashboard.teamChat": "Екипен чат",
  "employeeDashboard.specialAccess": "Специален достъп",
  "employeeDashboard.autoPark": "Автопарк",
  "employeeDashboard.inventory": "Инвентар",
  "employeeDashboard.contracts": "Договори",
  "employeeDashboard.workers": "Работници",
  "employeeDashboard.noSpecialAccess": "Няма предоставен специален достъп"
   

    }
  },
"it": {
  "translation": {
      "loginTitle": "Portale dipendenti",
      "loginSubtitle": "Questa pagina è riservata esclusivamente ai dipendenti di Infinity Energy Solar.",
    "home": "Home",
    "services": "Servizi",
    "machinesHero": "Attrezzature e macchinari",
    "machinesIntro": "Utilizziamo macchine ad alte prestazioni e di precisione per ogni fase dello sviluppo di parchi solari. Le nostre attrezzature garantiscono affidabilità, efficienza e scalabilità.",
    "machine0Title": "Caricatore per camion",
    "machine0Desc": "Per una gestione efficiente dei materiali e della logistica.",
    "machine1Title": "Macchina battipalo",
    "machine1Desc": "Per lavori di fondazione precisi e stabili.",
    "machine2Title": "Caricatori telescopici",
    "machine2Desc": "Per sollevamento e trasporto flessibile su terreni complessi.",
    "machine3Title": "Miniescavatore cingolato da 9 tonnellate",
    "machine3Desc": "Per supportare la flotta in tutte le esigenze speciali.",
    "machinesBrowseGallery": "Esplora le nostre macchine",
    "machinesGalleryTitle": "Galleria macchinari",
    "machineryListButton": "Elenco macchine",
    "machineryFleetTitle": "Il nostro parco macchine",
    "machineryFleetRow0": "Sistema idraulico Mazaka per pali",
    "machineryFleetRow1": "Battipalo Orteco",
    "machineryFleetRow2": "Battipalo Gayk",
    "machineryFleetRow3": "Minipala compatta Bobcat (modello: T86)",
    "machineryFleetRow4": "Carrello telescopico Manitou (telehandler)",
    "machineryFleetRow5": "Carrello telescopico Bobcat (telehandler, modello: T76)",
    "machineryFleetRow6": "Escavatore cingolato Develon 9 t",
    "machineryFleetRow7": "Escavatore cingolato Develon 14 t",
    "machineryFleetRow8": "Macchina perforatrice",
    "machineryFleetRow9": "Mini escavatore Bobcat 3,5 t (modello: E35)",
    "machineryFleetRow10": "Mini escavatore Bobcat 5,5 t (modello: E55)",
    "machinesCloseModal": "Chiudi",
    "machines": "Macchinari",
    "certificatesHero": "Le nostre Certificazioni",
    "certificatesIntro": "Siamo certificati secondo i più alti standard del settore, garantendo affidabilità, qualità e conformità in tutti i nostri progetti.",
    "certificate0Title": "ISO 9001:2015",
    "certificate0Desc": "Certificazione dei sistemi di gestione della qualità per prestazioni costanti.",
    "certificate1Title": "ISO 14001:2015",
    "certificate1Desc": "Certificazione dei sistemi di gestione ambientale per ridurre l’impatto ecologico.",
    "certificate2Title": "ISO 45001:2018",
    "certificate2Desc": "Certificazione per la salute e la sicurezza sul lavoro per i nostri team e partner.",
    "certificates": "Certificati",
    "projects": "Progetti",
    "projectsHero": "Stiamo alimentando un'Europa più pulita e luminosa.",
    "projectsIntro": "Questi sono i nostri progetti in diversi paesi d'Europa - ognuno è molto più di un semplice cantiere per noi. Rappresentano partnership solide, obiettivi condivisi e la fiducia che i nostri clienti ripongono in noi. Ogni luogo è un passo verso un domani più verde, alimentato da innovazione, affidabilità e visione.",
    "countryBulgaria": "Bulgaria",
    "countryFrance": "Francia",
    "countryItaly": "Italia",
    "countryGermany": "Germania",
      "countrySerbia": "Serbia",
      "countryNorthMacedonia": "Macedonia del Nord",
      "countryBelgium": "Belgio",
      "countryDenmark": "Danimarca",
      "chooseCountry": "Scegli un paese",
      "selectCountry": "Seleziona un paese",
      "selectProject": "Seleziona un progetto",
      "selectCountryToBrowse": "Seleziona un paese per sfogliare i progetti",
      "selectProjectFromDropdown": "Seleziona un progetto dal menu a tendina sopra",
    "projectsBelgiumTitle": "Progetti in Belgio",
    "projectsDenmarkTitle": "Progetti in Danimarca",
    "projectsFranceTitle": "Progetti in Francia",
    "projectBelgiumMain": "Progetto principale in Belgio",
    "projectsGermanyTitle": "Progetti in Germania",
    "projectsSerbiaTitle": "Progetti in Serbia",
    "projectsNorthMacedoniaTitle": "Progetti in Macedonia del Nord",
    "projectsItalyTitle": "Progetti in Italia",
    "projectGermanyDiesel": "Diesel Technic",
    "projectNessebar": "Nessebar",
    "projectVitaminka": "Vitaminka, Prilep",
    "projectPernikOne": "Pernik 1",
    "projectPernikTwo": "Pernik 2",
    "projectMoussoulens": "Moussoulens",
    "projectPerpignan": "Perpignan",
    "projectStGermain": "Saint Germain",
    "projectLesMes": "Les Mées",
    "projectSBRU": "SBRU",
    "projectStElix": "St. Elix",
    "projectSlivnitsa": "Slivnitsa",
    "projectRasovo": "Rasovo, Lom",
    "projectPolch": "Polch",
    "projectVillerup": "Villerup",
    "nessebarTitle": "Nessebar",
    "lapovoTitle": "Lapovo",
    "vitaminkaTitle": "Vitaminka, Prilep",
    "projectLapovo": "Lapovo",
    "pernikoneTitle": "Pernik 1",
    "perniktwoTitle": "Pernik 2",
    "slivnitsaTitle": "Slivnitsa",
    "rasovoTitle": "Rasovo, Lom",
    "polchTitle": "Polch",
    "villerupTitle": "Villerup",
    "monrealeTitle": "Monreale",
    "projectMonreale": "Monreale, Sicilia",
    "moussoulensTitle": "Moussoulens",
    "perpignanTitle": "Perpignan",
    "stgermainTitle": "Saint Germain",
    "lesmesTitle": "Les Mées",
    "sbruTitle": "SBRU",
    "stelixTitle": "St. Elix",
    "projectPower": "Capacità Totale",
    "projectType": "Tipo di Costruzione",
    "projectTypeStatic": "Statica",
    "projectTypeTracker": "Inseguitore",
    "projectYear": "Anno",
    "photoGallery": "Galleria fotografica",
    "projectsBulgariaTitle": "Progetti in Bulgaria",
    "projectsBulgariaIntro": "Questi sono i nostri progetti in Bulgaria - ognuno di essi è molto più di un semplice cantiere. Rappresentano collaborazioni solide, obiettivi condivisi e la fiducia che i clienti ripongono nella nostra azienda.",
    "projectKyustendil": "Kyustendil",
    "projectPlovdiv": "Impianto di Plovdiv",
    "projectRazlog": "Polo Energetico Razlog",
    "kyustendilTitle": "Parco Solare Kyustendil",
    "loadingImage": "Caricamento immagine...",
    "back": "Indietro",
    "whyInfinity": "Perché Infinity?",
    "whyHero": "Perché scegliere Infinity?",
    "whyIntro": "In Infinity Energy Solar, combiniamo tecnologia all'avanguardia con un team di esperti appassionati per offrire soluzioni di energia solare senza pari.",
    "why0Title": "Esperienza e Competenza",
    "why0Desc": "Il nostro team altamente qualificato vanta un comprovato successo in progetti solari in tutta Europa.",
    "why1Title": "Soluzioni Personalizzate",
    "why1Desc": "Progettiamo ogni sistema fotovoltaico per soddisfare le esigenze specifiche e le condizioni del sito.",
    "why2Title": "Impegno per la Sostenibilità",
    "why2Desc": "Diamo priorità a pratiche ecologiche e alla sostenibilità a lungo termine in tutto ciò che realizziamo.",
    "why3Title": "Assistenza per il Supporto Finanziario",
    "why3Desc": "Prepariamo documentazione tecnica e finanziaria per aiutare a ottenere finanziamenti da enti bulgari e internazionali per il tuo progetto.",
    "why4Title": "Impegno per l’Eccellenza",
    "why4Desc": "La nostra dedizione alla qualità e al successo dei clienti ci spinge a fornire solo le migliori soluzioni, collaborando con marchi di primo livello per garantire risultati eccellenti.",
    "contact": "Contatto",
    "contactHero": "Alimentiamo insieme il tuo futuro.",
    "contactText": "Siamo qui per assisterti con le tue esigenze energetiche solari. Che tu abbia domande, bisogno di consulenza esperta o sia pronto a iniziare il tuo progetto, il nostro team è pronto a fornirti soluzioni e supporto personalizzati. Contattaci oggi e alimentiamo insieme il futuro!",
    "contactTitle": "Contattaci",
    "contactPhone": "Telefono",
    "contactEmail": "Email",
    "contactAddress": "Indirizzo",
    "contactFullAddress": "ul. \"Hristo Botev\" 2, 2760 Razlog, Bulgaria",
    "futureText": "Il tuo futuro, alimentato dal Sole",
    "futureTextLine1": "Il tuo futuro,",
    "futureTextLine2": "alimentato dal Sole!",
    "heroText": "Il tuo futuro, alimentato dal Sole!",
    "heroSubtitle": "Sviluppiamo parchi solari in tutta Europa, presto oltre.",
    "contactUs": "Contattaci",
    "exploreProjects": "Esplora i nostri progetti",
    "whoAreWe": "Chi siamo?",
    "whoAreWeText": "Infinity Energy Solar è una giovane azienda in rapida espansione che fornisce soluzioni innovative e sostenibili per la produzione e lo stoccaggio di energia rinnovabile. L'azienda è specializzata nella progettazione e costruzione di parchi fotovoltaici e ha già completato con successo progetti in Bulgaria e in diversi paesi europei. Con una forte enfasi su standard elevati e innovazione tecnologica, Infinity Energy Solar si è affermata come partner affidabile nell'implementazione di installazioni solari di varie dimensioni. Il nostro team di esperti gestisce l'intero processo con un focus su efficienza, durabilità e sostenibilità. L'azienda sviluppa soluzioni personalizzate su misura per le esigenze e i requisiti specifici dei suoi partner e clienti. Infinity Energy Solar si è rapidamente espansa e attualmente vanta un team di oltre 100 dipendenti. Crediamo che il nostro successo sia guidato dalla dedizione, competenza e unità delle nostre persone, che sono al centro di ogni passo di successo che facciamo.",
    "homeAbout": "Infinity Energy Solar è una giovane azienda in rapida crescita che offre soluzioni innovative e sostenibili per la produzione e lo stoccaggio di energia rinnovabile. Specializzata nella progettazione e costruzione di parchi fotovoltaici, l'azienda ha già completato con successo progetti sia in Bulgaria che in diversi paesi europei.\n\nCon un forte focus su standard elevati e innovazione tecnologica, ci siamo affermati come partner affidabile nella realizzazione di impianti solari di varie dimensioni. Il nostro team di esperti gestisce l'intero processo con attenzione a efficienza, durabilità e sostenibilità.\n\nL'azienda sviluppa soluzioni personalizzate in base alle esigenze e ai requisiti specifici di partner e clienti. Infinity Energy Solar si è rapidamente espansa e oggi conta un team di oltre 180 dipendenti. Crediamo che il nostro successo sia guidato dalla dedizione, dalla competenza e dall'unità delle nostre persone, che sono il cuore di ogni passo vincente che compiamo.",
    "getStarted": "Inizia ora",
    "projectsStat": "Progetti",
    "powerStat": "Capacità Totale",
    "countriesStat": "Paesi",
    "workersStat": "Dipendenti",
    "servicesHero": "I nostri servizi sono progettati per l’eccellenza.",
    "servicesIntro": "Dalla progettazione iniziale alla manutenzione a lungo termine, offriamo soluzioni complete per ogni progetto di energia solare.",
    "designTitle": "Progettazione",
    "designDesc": "In base alle esigenze della tua azienda, progettiamo il tuo impianto fotovoltaico, fornendo un progetto accurato secondo la tua idea.",
    "constructTitle": "Costruzione",
    "constructDesc": "Il nostro team di specialisti realizza l’installazione in base alla soluzione più adatta per il tuo impianto, assicurando un piano preciso e dettagliato per l’implementazione nel sito designato.",
    "maintainTitle": "Manutenzione",
    "ourServices": "I Nostri Servizi",
    "ourServicesDesc": "Dalla progettazione iniziale alla manutenzione a lungo termine, offriamo soluzioni complete per ogni progetto di energia solare.",
    "labelPrintingTitle": "Stampa di Etichette",
    "labelPrintingDesc": "La nostra azienda offre servizi professionali di stampa di etichette per parchi solari e altri progetti infrastrutturali utilizzando il Brady i7500 - garantendo etichette durevoli, precise e conformi per pannelli, cavi, attrezzature e componenti infrastrutturali.",
    "kyustendilContractor": "Appaltatore: Rashev & Co LTD",
    "pernikoneContractor": "Appaltatore: Rashev & Co LTD",
    "slivnitsaContractor": "Appaltatore: Rashev & Co LTD",
    "moussoulensContractor": "Appaltatore: Rashev & Co LTD",
    "monrealeContractor": "Appaltatore: Rashev & Co LTD",
    "perpignanContractor": "Appaltatore: Rashev & Co LTD",
    "stgermainContractor": "Appaltatore: Rashev & Co LTD",
    "lesmesContractor": "Appaltatore: Rashev & Co LTD",
    "lesmesNotes": "Repowering",
    "maintainDesc": "Il nostro team esegue la manutenzione tecnica dei sistemi fotovoltaici costruiti secondo i requisiti, osservando tutte le specifiche tecniche dei produttori con cui collaboriamo.",
    "upcomingProjects": "PROGETTI IN ARRIVO:",
    "projectsInProgressUpcoming": "Progetti in corso",
    "inProgress": "In corso",
    "upcoming": "In arrivo",
    "projectAunslev": "Aunslev",
    "projectAunslevCapacity": "31 MWh",
    "projectStElix": "St. Elix",
    "projectStElixCapacity": "4.1 MWp",
    "projectBalkantsi": "Balkantsi, Bulgaria",
    "projectBalkantsiCapacity": "5 MWp",
    "projectIhtiman": "Ihtiman, Bulgaria",
    "projectIhtimanCapacity": "12 MWp",
    "projectMorocco": "Beni Mathar, Africa",
    "projectMoroccoCapacity": "120 MWp",
    "projectPrevancher": "Prévenchères, Francia",
    "projectPrevancherCapacity": "42 MWp",
    "upcomingProjectsDesc": "Da gennaio 2026, stiamo per avviare diversi progetti in tutta Europa e Bulgaria.",
    "mapConsentRequired": "Google Maps è disattivato finché non vengono accettati i cookie.",
    "cookiesTitle": "Infinity Energy Solar - Politica sui Cookie",
    "cookiesHeader": "Politica sui Cookie",
    "cookiesIntro": "Utilizziamo i cookie per migliorare la tua esperienza di navigazione e analizzare il traffico del sito. I cookie sono piccoli file di testo memorizzati sul tuo dispositivo che ci aiutano a riconoscerti e a ricordare le tue preferenze.",
    "cookiesTypesTitle": "Tipi di Cookie che Utilizziamo",
    "cookiesTypes.0": "Cookie Necessari – essenziali per il funzionamento principale del sito",
    "cookiesTypes.1": "Cookie Analitici – ci aiutano a comprendere il comportamento degli utenti (es. Google Analytics)",
    "cookiesTypes.2": "Cookie Funzionali – ricordano le tue preferenze (es. lingua)",
    "cookiesThirdPartyTitle": "Servizi di Terze Parti",
    "cookiesThirdParty": "Utilizziamo Google Maps per mostrare la posizione della nostra azienda nella pagina Contatti. Google può impostare cookie e raccogliere dati di utilizzo. Puoi visualizzare la loro Privacy Policy.",
    "cookiesManageTitle": "Gestione dei Cookie",
    "cookiesManage": "Puoi controllare o disabilitare i cookie tramite le impostazioni del tuo browser. La disattivazione di alcuni tipi può influenzare la funzionalità del sito.",
    "cookiesContactTitle": "Contatti",
    "cookiesContact": "Se hai domande sulla nostra politica sui cookie, ti preghiamo di contattarci all'indirizzo office@infisolarbg.com.",
    "cookieBannerText": "Questo sito utilizza i cookie. Continuando, accetti o rifiuti la nostra Politica sui Cookie.",
    "cookieBannerLearnMore": "Scopri di più",
    "cookieBannerAccept": "Accetta",
    "cookieBannerDecline": "Rifiuta",
    "employeesTitle": "Per i dipendenti",
    "employeesInfo": "Questi contatti sono esclusivamente riservati ai dipendenti per segnalare problemi, condizioni di lavoro non sicure o altre questioni legate al luogo di lavoro. Tutte le segnalazioni sono trattate con la massima riservatezza, garantendo che i dipendenti possano esprimere le loro preoccupazioni senza timore di ritorsioni. Questi canali di comunicazione sono gestiti dal nostro reparto Risorse Umane per garantire un ambiente di lavoro sicuro e di supporto per tutti."
  }
},
"fr": {
  "translation": {
      "loginTitle": "Portail des employés",
      "loginSubtitle": "Cette page est uniquement dédiée aux employés d’Infinity Energy Solar.",
    "home": "Accueil",
    "services": "Services",
    "machinesHero": "Équipements et machines",
    "machinesIntro": "Nous utilisons des machines haute performance et de précision à chaque étape du développement de parcs solaires. Nos équipements garantissent fiabilité, efficacité et évolutivité.",
    "machine0Title": "Chargeur de camion",
    "machine0Desc": "Pour une gestion efficace des matériaux et de la logistique.",
    "machine1Title": "Machine à damer",
    "machine1Desc": "Pour des fondations précises et stables.",
    "machine2Title": "Chargeurs télescopiques",
    "machine2Desc": "Pour un levage et un transport flexibles sur des terrains complexes.",
    "machine3Title": "Mini-pelle chenillée de 9 tonnes",
    "machine3Desc": "Pour soutenir la flotte selon les besoins spécifiques.",
    "machinesBrowseGallery": "Découvrez nos équipements",
    "machinesGalleryTitle": "Galerie des équipements",
    "machineryListButton": "Liste des engins",
    "machineryFleetTitle": "Notre parc d’engins",
    "machineryFleetRow0": "Système hydraulique d’enfoncement de pieux Mazaka",
    "machineryFleetRow1": "Enfonce-pieux Orteco",
    "machineryFleetRow2": "Enfonce-pieux Gayk",
    "machineryFleetRow3": "Chargeuse compacte Bobcat (modèle : T86)",
    "machineryFleetRow4": "Télescopique Manitou (téléhandler)",
    "machineryFleetRow5": "Télescopique Bobcat (téléhandler, modèle : T76)",
    "machineryFleetRow6": "Pelle sur chenilles Develon 9 t",
    "machineryFleetRow7": "Pelle sur chenilles Develon 14 t",
    "machineryFleetRow8": "Machine de forage",
    "machineryFleetRow9": "Mini-pelle Bobcat 3,5 t (modèle : E35)",
    "machineryFleetRow10": "Mini-pelle Bobcat 5,5 t (modèle : E55)",
    "machinesCloseModal": "Fermer",
    "machines": "Machines",
    "certificatesHero": "Nos Certifications",
    "certificatesIntro": "Nous sommes certifiés selon les normes les plus strictes de l'industrie, garantissant fiabilité, qualité et conformité dans tous nos projets.",
    "certificate0Title": "ISO 9001:2015",
    "certificate0Desc": "Certification des systèmes de gestion de la qualité pour des performances constantes.",
    "certificate1Title": "ISO 14001:2015",
    "certificate1Desc": "Certification des systèmes de gestion environnementale pour minimiser l'impact écologique.",
    "certificate2Title": "ISO 45001:2018",
    "certificate2Desc": "Certification santé et sécurité au travail pour nos équipes et partenaires.",
    "certificates": "Certificats",
    "projects": "Projets",
    "projectsHero": "Nous alimentons une Europe plus propre et plus lumineuse.",
    "projectsIntro": "Ce sont nos projets dans plusieurs pays à travers l'Europe - chacun représente bien plus qu'un simple chantier pour nous. Ils incarnent des partenariats solides, des objectifs communs et la confiance que nos clients nous accordent. Chaque site représente une avancée vers un avenir plus vert, porté par l'innovation, la fiabilité et une vision durable.",
    "countryBulgaria": "Bulgarie",
    "countryFrance": "France",
    "countryItaly": "Italie",
    "countryGermany": "Allemagne",
      "countrySerbia": "Serbie",
      "countryNorthMacedonia": "Macédoine du Nord",
      "countryBelgium": "Belgique",
      "countryDenmark": "Danemark",
      "chooseCountry": "Choisissez un pays",
      "selectCountry": "Sélectionnez un pays",
      "selectProject": "Sélectionnez un projet",
      "selectCountryToBrowse": "Sélectionnez un pays pour parcourir les projets",
      "selectProjectFromDropdown": "Sélectionnez un projet dans le menu déroulant ci-dessus",
    "projectsBelgiumTitle": "Projets en Belgique",
    "projectsDenmarkTitle": "Projets au Danemark",
    "projectBelgiumMain": "Projet principal de Belgique",
    "projectsGermanyTitle": "Projets en Allemagne",
    "projectsSerbiaTitle": "Projets en Serbie",
    "projectsNorthMacedoniaTitle": "Projets en Macédoine du Nord",
    "projectsItalyTitle": "Projets en Italie",
    "projectGermanyDiesel": "Diesel Technic",
    "projectNessebar": "Nessebar",
    "projectVitaminka": "Vitaminka, Prilep",
    "projectPernikOne": "Pernik 1",
    "projectPernikTwo": "Pernik 2",
    "projectMoussoulens": "Moussoulens",
    "projectPerpignan": "Perpignan",
    "projectStGermain": "Saint Germain",
    "projectLesMes": "Les Mées",
    "projectSBRU": "SBRU",
    "projectStElix": "St. Elix",
    "projectSlivnitsa": "Slivnitsa",
    "projectRasovo": "Rasovo, Lom",
    "projectPolch": "Polch",
    "projectVillerup": "Villerup",
    "nessebarTitle": "Nessebar",
    "lapovoTitle": "Lapovo",
    "vitaminkaTitle": "Vitaminka, Prilep",
    "projectLapovo": "Lapovo",
    "pernikoneTitle": "Pernik 1",
    "perniktwoTitle": "Pernik 2",
    "slivnitsaTitle": "Slivnitsa",
    "rasovoTitle": "Rasovo, Lom",
    "polchTitle": "Polch",
    "villerupTitle": "Villerup",
    "monrealeTitle": "Monreale",
    "projectMonreale": "Monreale, Sicile",
    "moussoulensTitle": "Moussoulens",
    "perpignanTitle": "Perpignan",
    "stgermainTitle": "Saint Germain",
    "lesmesTitle": "Les Mées",
    "sbruTitle": "SBRU",
    "stelixTitle": "St. Elix",
    "projectPower": "Puissance Totale",
    "projectType": "Type de Construction",
    "projectTypeStatic": "Statique",
    "projectTypeTracker": "Suiveur",
    "projectYear": "Année",
    "photoGallery": "Galerie photo",
    "projectsBulgariaTitle": "Projets en Bulgarie",
    "projectsFranceTitle": "Projets en France",
    "projectsBulgariaIntro": "Voici nos projets en Bulgarie - chacun d'eux est bien plus qu'un simple chantier. Ils représentent des partenariats solides, des objectifs communs et la confiance que nos clients accordent à notre entreprise.",
    "projectKyustendil": "Kyustendil",
    "projectPlovdiv": "Installation à Plovdiv",
    "projectRazlog": "Centre Énergétique de Razlog",
    "kyustendilTitle": "Parc Solaire de Kyustendil",
    "loadingImage": "Chargement de l'image...",
    "back": "Retour",
    "whyInfinity": "Pourquoi Infinity ?",
    "whyHero": "Pourquoi choisir Infinity ?",
    "whyIntro": "Chez Infinity Energy Solar, nous combinons la technologie de pointe avec une équipe d'experts passionnés pour fournir des solutions d'énergie solaire inégalées.",
    "why0Title": "Expérience et Expertise",
    "why0Desc": "Notre équipe hautement qualifiée a fait ses preuves dans la réalisation de projets solaires à travers l'Europe.",
    "why1Title": "Solutions Personnalisées",
    "why1Desc": "Nous adaptons chaque système photovoltaïque à vos besoins spécifiques et aux conditions de votre site.",
    "why2Title": "Engagement Durable",
    "why2Desc": "Nous privilégions des pratiques respectueuses de l'environnement et la durabilité à long terme dans toutes nos réalisations.",
    "why3Title": "Aide au Financement",
    "why3Desc": "Nous préparons la documentation technique et financière pour vous aider à obtenir des financements auprès d'organismes bulgares et internationaux.",
    "why4Title": "Engagement pour l’Excellence",
    "why4Desc": "Notre engagement envers la qualité et le succès de nos clients nous pousse à proposer les meilleures solutions, en collaborant avec des marques de premier plan pour garantir les meilleurs résultats.",
    "contact": "Contact",
    "contactHero": "Construisons ensemble votre avenir énergétique.",
    "contactText": "Nous sommes là pour vous accompagner dans vos besoins en énergie solaire. Que vous ayez des questions, besoin de conseils d'experts ou que vous soyez prêt à démarrer votre projet, notre équipe vous offre des solutions sur mesure et un accompagnement personnalisé. Contactez-nous dès aujourd'hui et construisons ensemble l'avenir !",
    "contactTitle": "Nous Contacter",
    "contactPhone": "Téléphone",
    "contactEmail": "E-mail",
    "contactAddress": "Adresse",
    "contactFullAddress": "ul. \"Hristo Botev\" 2, 2760 Razlog, Bulgarie",
    "futureText": "Votre avenir, propulsé par le Soleil",
    "futureTextLine1": "Votre avenir,",
    "futureTextLine2": "propulsé par le Soleil!",
    "heroText": "Votre avenir, propulsé par le Soleil!",
    "heroSubtitle": "Nous développons des parcs solaires à travers l'Europe, bientôt au-delà.",
    "contactUs": "Contactez-nous",
    "exploreProjects": "Découvrez nos projets",
    "whoAreWe": "Qui sommes-nous?",
    "whoAreWeText": "Infinity Energy Solar est une entreprise jeune et en pleine expansion qui fournit des solutions innovantes et durables pour la production et le stockage d'énergie renouvelable. L'entreprise est spécialisée dans la conception et la construction de parcs photovoltaïques et a déjà mené à bien des projets en Bulgarie et dans plusieurs pays européens. Avec un fort accent sur les normes élevées et l'innovation technologique, Infinity Energy Solar s'est imposée comme un partenaire fiable dans la mise en œuvre d'installations solaires de toutes tailles. Notre équipe d'experts gère l'ensemble du processus avec un focus sur l'efficacité, la durabilité et la durabilité. L'entreprise développe des solutions sur mesure adaptées aux besoins et exigences spécifiques de ses partenaires et clients. Infinity Energy Solar s'est rapidement développée et compte actuellement une équipe de plus de 100 employés. Nous croyons que notre succès repose sur la dévotion, les compétences et l'unité de nos collaborateurs, qui sont au cœur de chaque étape réussie que nous franchissons.",
    "homeAbout": "Infinity Energy Solar est une entreprise jeune et en pleine croissance qui propose des solutions innovantes et durables pour la production et le stockage d'énergie renouvelable. Spécialisée dans la conception et la construction de parcs photovoltaïques, l'entreprise a déjà mené à bien des projets en Bulgarie et dans plusieurs pays européens.\n\nForte d'un engagement envers les normes élevées et l'innovation technologique, nous nous sommes imposés comme un partenaire fiable pour la mise en œuvre d'installations solaires de toutes tailles. Notre équipe d'experts gère l'ensemble du processus avec un souci d'efficacité, de durabilité et de performance.\n\nL'entreprise développe des solutions sur mesure adaptées aux besoins et exigences spécifiques de ses partenaires et clients. Infinity Energy Solar s'est rapidement développée et compte aujourd'hui plus de 180 employés. Nous croyons que notre succès repose sur la dévotion, les compétences et l'unité de nos collaborateurs, qui sont au cœur de chaque étape réussie que nous franchissons.",
    "getStarted": "Commencer",
    "projectsStat": "Projets",
    "powerStat": "Puissance Totale",
    "countriesStat": "Pays",
    "workersStat": "Employés",
    "servicesHero": "Nos services sont conçus pour l'excellence.",
    "servicesIntro": "De la conception initiale à la maintenance à long terme, nous proposons des solutions complètes adaptées à chaque projet d'énergie solaire.",
    "ourServices": "Nos Services",
    "ourServicesDesc": "De la conception initiale à la maintenance à long terme, nous proposons des solutions complètes adaptées à chaque projet d'énergie solaire.",
    "labelPrintingTitle": "Impression d'étiquettes",
    "labelPrintingDesc": "Notre entreprise propose des services d'impression d'étiquettes professionnels pour les parcs solaires et autres projets d'infrastructure en utilisant le Brady i7500 - garantissant des étiquettes durables, précises et conformes pour les panneaux, câbles, équipements et composants d'infrastructure.",
    "designTitle": "Conception",
    "designDesc": "En fonction des besoins de votre entreprise, nous concevons votre système photovoltaïque et vous fournissons une conception précise selon votre idée.",
    "constructTitle": "Construction",
    "constructDesc": "Notre équipe de spécialistes réalise l'installation selon la solution la plus adaptée à votre système, en garantissant un plan précis et détaillé pour sa mise en œuvre sur le site désigné.",
    "maintainTitle": "Maintenance",
    "kyustendilContractor": "Entrepreneur : Rashev & Co LTD",
    "pernikoneContractor": "Entrepreneur : Rashev & Co LTD",
    "slivnitsaContractor": "Entrepreneur : Rashev & Co LTD",
    "moussoulensContractor": "Entrepreneur : Rashev & Co LTD",
    "monrealeContractor": "Entrepreneur : Rashev & Co LTD",
    "perpignanContractor": "Entrepreneur : Rashev & Co LTD",
    "stgermainContractor": "Entrepreneur : Rashev & Co LTD",
    "lesmesContractor": "Entrepreneur : Rashev & Co LTD",
    "lesmesNotes": "Repowering",
    "maintainDesc": "Notre équipe assure la maintenance technique des systèmes photovoltaïques construits selon les exigences, en respectant toutes les spécifications techniques des fabricants avec lesquels nous travaillons.",
    "upcomingProjects": "PROJETS À VENIR:",
    "projectsInProgressUpcoming": "Projets en cours",
    "inProgress": "En cours",
    "upcoming": "À venir",
    "projectAunslev": "Aunslev",
    "projectAunslevCapacity": "31 MWh",
    "projectStElix": "St. Elix",
    "projectStElixCapacity": "4.1 MWp",
    "projectBalkantsi": "Balkantsi, Bulgarie",
    "projectBalkantsiCapacity": "5 MWp",
    "projectIhtiman": "Ihtiman, Bulgarie",
    "projectIhtimanCapacity": "12 MWp",
    "projectMorocco": "Beni Mathar, Afrique",
    "projectMoroccoCapacity": "120 MWp",
    "projectPrevancher": "Prévenchères, France",
    "projectPrevancherCapacity": "42 MWp",
    "upcomingProjectsDesc": "À partir de janvier 2026, nous allons démarrer plusieurs projets à travers l'Europe et la Bulgarie.",
    "mapConsentRequired": "Google Maps est désactivé tant que les cookies ne sont pas acceptés.",
    "cookiesTitle": "Infinity Energy Solar - Politique de Cookies",
    "cookiesHeader": "Politique de Cookies",
    "cookiesIntro": "Nous utilisons des cookies pour améliorer votre expérience de navigation et analyser le trafic du site. Les cookies sont de petits fichiers texte stockés sur votre appareil qui nous aident à vous reconnaître et à mémoriser vos préférences.",
    "cookiesTypesTitle": "Types de Cookies que Nous Utilisons",
    "cookiesTypes.0": "Cookies Nécessaires – essentiels au bon fonctionnement du site",
    "cookiesTypes.1": "Cookies d’Analyse – nous aident à comprendre le comportement des utilisateurs (ex. Google Analytics)",
    "cookiesTypes.2": "Cookies Fonctionnels – mémorisent vos préférences (ex. langue)",
    "cookiesThirdPartyTitle": "Services Tiers",
    "cookiesThirdParty": "Nous utilisons Google Maps pour afficher l’emplacement de notre entreprise sur la page Contact. Google peut définir des cookies et collecter des données d’utilisation. Vous pouvez consulter leur politique de confidentialité.",
    "cookiesManageTitle": "Gestion des Cookies",
    "cookiesManage": "Vous pouvez contrôler ou désactiver les cookies via les paramètres de votre navigateur. La désactivation de certains types peut affecter la fonctionnalité du site.",
    "cookiesContactTitle": "Contact",
    "cookiesContact": "Si vous avez des questions concernant notre politique de cookies, veuillez nous contacter à l'adresse office@infisolarbg.com.",
    "cookieBannerText": "Ce site utilise des cookies. En continuant, vous acceptez ou refusez notre politique de cookies.",
    "cookieBannerLearnMore": "En savoir plus",
    "cookieBannerAccept": "Accepter",
    "cookieBannerDecline": "Refuser",
    "employeesTitle": "Pour les employés",
    "employeesInfo": "Ces contacts sont exclusivement réservés aux employés pour signaler tout problème, conditions de travail dangereuses ou autres questions liées au lieu de travail. Toutes les signalements sont traités avec la plus grande confidentialité, garantissant que les employés peuvent exprimer leurs préoccupations sans crainte de représailles. Ces canaux de communication sont gérés par notre département des ressources humaines afin d’assurer un environnement de travail sûr et favorable pour tous."
  }
},
"de": {
  "translation": {
      "loginTitle": "Mitarbeiterportal",
      "loginSubtitle": "Diese Seite ist ausschließlich für Mitarbeiter von Infinity Energy Solar bestimmt.",
    "home": "Startseite",
    "services": "Dienstleistungen",
    "machinesHero": "Ausrüstung & Maschinen",
    "machinesIntro": "Wir verwenden leistungsstarke, präzisionsgefertigte Maschinen für jede Phase der Entwicklung von Solarparks. Unsere Ausrüstung gewährleistet Zuverlässigkeit, Effizienz und Skalierbarkeit.",
    "machine0Title": "LKW-Lader",
    "machine0Desc": "Für effiziente Materialhandhabung und Logistik.",
    "machine1Title": "Rammmaschine",
    "machine1Desc": "Für präzise und stabile Fundamentarbeiten.",
    "machine2Title": "Teleskoplader",
    "machine2Desc": "Für flexibles Heben und Transportieren in schwierigem Gelände.",
    "machine3Title": "9-Tonnen-Kettenbagger",
    "machine3Desc": "Zur Unterstützung des Fuhrparks bei besonderen Anforderungen.",
    "machinesBrowseGallery": "Unsere Maschinen entdecken",
    "machinesGalleryTitle": "Maschinengalerie",
    "machineryListButton": "Maschinenliste",
    "machineryFleetTitle": "Unser Maschinenpark",
    "machineryFleetRow0": "Mazaka hydraulisches Ramm-System",
    "machineryFleetRow1": "Orteco Rammgerät",
    "machineryFleetRow2": "Gayk Rammgerät",
    "machineryFleetRow3": "Bobcat Kompaktlader (Modell: T86)",
    "machineryFleetRow4": "Manitou Teleskoplader (Teleskopstapler)",
    "machineryFleetRow5": "Bobcat Teleskoplader (Teleskopstapler, Modell: T76)",
    "machineryFleetRow6": "Develon Kettenbagger 9 t",
    "machineryFleetRow7": "Develon Kettenbagger 14 t",
    "machineryFleetRow8": "Bohrgerät",
    "machineryFleetRow9": "Bobcat Kompaktbagger 3,5 t (Modell: E35)",
    "machineryFleetRow10": "Bobcat Kompaktbagger 5,5 t (Modell: E55)",
    "machinesCloseModal": "Schließen",
    "machines": "Maschinen",
    "certificatesHero": "Unsere Zertifizierungen",
    "certificatesIntro": "Wir sind nach den höchsten Industriestandards zertifiziert und garantieren Zuverlässigkeit, Qualität und Konformität in all unseren Projekten.",
    "certificate0Title": "ISO 9001:2015",
    "certificate0Desc": "Zertifizierung für Qualitätsmanagementsysteme für konstante Leistung.",
    "certificate1Title": "ISO 14001:2015",
    "certificate1Desc": "Zertifizierung für Umweltmanagementsysteme zur Minimierung ökologischer Auswirkungen.",
    "certificate2Title": "ISO 45001:2018",
    "certificate2Desc": "Zertifizierung für Arbeitsschutz für unsere Teams und Partner.",
    "certificates": "Zertifikate",
    "projects": "Projekte",
    "projectsHero": "Wir treiben ein saubereres und helleres Europa voran.",
    "projectsIntro": "Das sind unsere Projekte in mehreren Ländern Europas – jedes ist für uns mehr als nur eine Baustelle. Sie stehen für starke Partnerschaften, gemeinsame Ziele und das Vertrauen, das unsere Kunden in uns setzen. Jeder Standort ist ein Schritt in Richtung einer grüneren Zukunft, getragen von Innovation, Zuverlässigkeit und Weitblick.",
    "countryBulgaria": "Bulgarien",
    "countryFrance": "Frankreich",
    "countryItaly": "Italien",
    "countryGermany": "Deutschland",
      "countrySerbia": "Serbien",
      "countryNorthMacedonia": "Nordmazedonien",
      "countryBelgium": "Belgien",
      "countryDenmark": "Dänemark",
      "chooseCountry": "Wählen Sie ein Land",
      "selectCountry": "Wählen Sie ein Land",
      "selectProject": "Wählen Sie ein Projekt",
      "selectCountryToBrowse": "Wählen Sie ein Land, um Projekte durchzusehen",
      "selectProjectFromDropdown": "Wählen Sie ein Projekt aus dem Dropdown-Menü oben",
    "projectsBelgiumTitle": "Projekte in Belgien",
    "projectsDenmarkTitle": "Projekte in Dänemark",
    "projectBelgiumMain": "Hauptprojekt in Belgien",
    "projectsGermanyTitle": "Projekte in Deutschland",
    "projectsSerbiaTitle": "Projekte in Serbien",
    "projectsNorthMacedoniaTitle": "Projekte in Nordmazedonien",
    "projectsItalyTitle": "Projekte in Italien",
    "projectGermanyDiesel": "Diesel Technic",
    "projectNessebar": "Nessebar",
    "projectVitaminka": "Vitaminka, Prilep",
    "projectPernikOne": "Pernik 1",
    "projectPernikTwo": "Pernik 2",
    "projectSlivnitsa": "Slivnitsa",
    "projectRasovo": "Rasovo, Lom",
    "projectPolch": "Polch",
    "projectVillerup": "Villerup",
    "projectMoussoulens": "Moussoulens",
    "projectPerpignan": "Perpignan",
    "projectStGermain": "Saint Germain",
    "projectLesMes": "Les Mées",
    "projectSBRU": "SBRU",
    "projectStElix": "St. Elix",
    "nessebarTitle": "Nessebar",
    "lapovoTitle": "Lapovo",
    "projectLapovo": "Lapovo",
    "vitaminkaTitle": "Vitaminka, Prilep",
    "pernikoneTitle": "Pernik 1",
    "perniktwoTitle": "Pernik 2",
    "slivnitsaTitle": "Slivnitsa",
    "rasovoTitle": "Rasovo, Lom",
    "polchTitle": "Polch",
    "villerupTitle": "Villerup",
    "monrealeTitle": "Monreale",
    "projectMonreale": "Monreale, Sizilien",
    "moussoulensTitle": "Moussoulens",
    "perpignanTitle": "Perpignan",
    "stgermainTitle": "Saint Germain",
    "lesmesTitle": "Les Mées",
    "sbruTitle": "SBRU",
    "stelixTitle": "St. Elix",
    "projectPower": "Gesamtkapazität",
    "projectType": "Bauart",
    "projectTypeStatic": "Statisch",
    "projectTypeTracker": "Nachführsystem",
    "projectYear": "Jahr",
    "photoGallery": "Fotogalerie",
    "projectsBulgariaTitle": "Projekte in Bulgarien",
    "projectsFranceTitle": "Projekte in Frankreich",
    "projectsBulgariaIntro": "Dies sind unsere Projekte in Bulgarien – jedes ist für uns mehr als nur eine Baustelle. Sie stehen für starke Partnerschaften, gemeinsame Ziele und das Vertrauen, das unsere Kunden in unser Unternehmen setzen.",
    "projectKyustendil": "Kyustendil",
    "projectPlovdiv": "Installation in Plovdiv",
    "projectRazlog": "Razlog Energiezentrum",
    "kyustendilTitle": "Solarpark Kyustendil",
    "loadingImage": "Bild wird geladen...",
    "back": "Zurück",
    "whyInfinity": "Warum Infinity?",
    "whyHero": "Warum Infinity wählen?",
    "whyIntro": "Bei Infinity Energy Solar kombinieren wir modernste Technologie mit einem Team leidenschaftlicher Experten, um unvergleichliche Solarenergielösungen zu liefern.",
    "why0Title": "Erfahrung und Fachwissen",
    "why0Desc": "Unser hochqualifiziertes Team hat eine nachgewiesene Erfolgsbilanz bei Solarprojekten in ganz Europa.",
    "why1Title": "Individuelle Lösungen",
    "why1Desc": "Wir passen jedes photovoltaische System an Ihre spezifischen Anforderungen und Standortbedingungen an.",
    "why2Title": "Nachhaltiges Engagement",
    "why2Desc": "Wir setzen auf umweltfreundliche Praktiken und langfristige Nachhaltigkeit in all unseren Bauvorhaben.",
    "why3Title": "Unterstützung bei der Finanzierung",
    "why3Desc": "Wir erstellen technische und finanzielle Unterlagen, um die Finanzierung Ihres Projekts durch bulgarische und internationale Finanzinstitute zu erleichtern.",
    "why4Title": "Streben nach Exzellenz",
    "why4Desc": "Unser Engagement für Qualität und Kundenerfolg treibt uns an, nur die besten Lösungen anzubieten – mit hochwertigen Marken und besten Ergebnissen.",
    "contact": "Kontakt",
    "contactHero": "Gestalten wir gemeinsam Ihre Zukunft mit Solarenergie.",
    "contactText": "Wir sind hier, um Sie bei all Ihren Anliegen rund um Solarenergie zu unterstützen. Ob Sie Fragen haben, fachkundige Beratung benötigen oder Ihr Projekt starten möchten – unser Team steht bereit, um maßgeschneiderte Lösungen und Support zu bieten. Kontaktieren Sie uns noch heute – und gestalten wir die Zukunft gemeinsam!",
    "contactTitle": "Kontaktieren Sie uns",
    "contactPhone": "Telefon",
    "contactEmail": "E-Mail",
    "contactAddress": "Adresse",
    "contactFullAddress": "ul. \"Hristo Botev\" 2, 2760 Razlog, Bulgarien",
    "futureText": "Ihre Zukunft, angetrieben von der Sonne",
    "futureTextLine1": "Ihre Zukunft,",
    "futureTextLine2": "angetrieben von der Sonne!",
    "heroText": "Ihre Zukunft, angetrieben von der Sonne!",
    "heroSubtitle": "Wir entwickeln Solarparks in ganz Europa, bald darüber hinaus.",
    "contactUs": "Kontaktieren Sie uns",
    "exploreProjects": "Entdecken Sie unsere Projekte",
    "whoAreWe": "Wer sind wir?",
    "whoAreWeText": "Infinity Energy Solar ist ein junges und schnell expandierendes Unternehmen, das innovative und nachhaltige Lösungen für die Erzeugung und Speicherung erneuerbarer Energien bereitstellt. Das Unternehmen ist auf die Planung und den Bau von Photovoltaikparks spezialisiert und hat bereits erfolgreich Projekte in Bulgarien und mehreren europäischen Ländern realisiert. Mit einem starken Fokus auf hohe Standards und technologische Innovationen hat sich Infinity Energy Solar als zuverlässiger Partner bei der Umsetzung von Solaranlagen in verschiedenen Größenordnungen etabliert. Unser Expertenteam übernimmt den gesamten Prozess mit einem Fokus auf Effizienz, Langlebigkeit und Nachhaltigkeit. Das Unternehmen entwickelt maßgeschneiderte Lösungen, die auf die spezifischen Bedürfnisse und Anforderungen seiner Partner und Kunden abgestimmt sind. Infinity Energy Solar ist schnell gewachsen und beschäftigt derzeit über 100 Mitarbeitende. Wir glauben, dass unser Erfolg auf dem Engagement, der Kompetenz und dem Zusammenhalt unserer Mitarbeitenden beruht – sie stehen im Zentrum jeder erfolgreichen Maßnahme, die wir ergreifen.",
    "homeAbout": "Infinity Energy Solar ist ein junges und schnell wachsendes Unternehmen, das innovative und nachhaltige Lösungen für die Erzeugung und Speicherung erneuerbarer Energien anbietet. Das Unternehmen ist auf die Planung und den Bau von Photovoltaikparks spezialisiert und hat bereits erfolgreich Projekte in Bulgarien und mehreren europäischen Ländern realisiert.\n\nMit einem starken Fokus auf hohe Standards und technologische Innovationen haben wir uns als zuverlässiger Partner für die Umsetzung von Solaranlagen in verschiedenen Größenordnungen etabliert. Unser Expertenteam übernimmt den gesamten Prozess mit einem Fokus auf Effizienz, Langlebigkeit und Nachhaltigkeit.\n\nDas Unternehmen entwickelt maßgeschneiderte Lösungen, die auf die spezifischen Bedürfnisse und Anforderungen seiner Partner und Kunden abgestimmt sind. Infinity Energy Solar ist schnell gewachsen und beschäftigt heute über 180 Mitarbeitende. Wir glauben, dass unser Erfolg auf dem Engagement, der Kompetenz und dem Zusammenhalt unserer Mitarbeitenden beruht – sie stehen im Zentrum jeder erfolgreichen Maßnahme, die wir ergreifen.",
    "getStarted": "Jetzt starten",
    "projectsStat": "Projekte",
    "powerStat": "Gesamtkapazität",
    "countriesStat": "Länder",
    "workersStat": "Mitarbeitende",
    "servicesHero": "Unsere Dienstleistungen sind auf Exzellenz ausgelegt.",
    "servicesIntro": "Von der ersten Planung bis zur langfristigen Wartung bieten wir umfassende Lösungen für jedes Solarenergieprojekt.",
    "ourServices": "Unsere Dienstleistungen",
    "ourServicesDesc": "Von der ersten Planung bis zur langfristigen Wartung bieten wir umfassende Lösungen für jedes Solarenergieprojekt.",
    "labelPrintingTitle": "Etikettendruck",
    "labelPrintingDesc": "Unser Unternehmen bietet professionelle Etikettendruckdienste für Solarparks und andere Infrastrukturprojekte mit dem Brady i7500 - für langlebige, präzise und konforme Etiketten für Paneele, Kabel, Geräte und Infrastrukturkomponenten.",
    "ourServices": "Unsere Dienstleistungen",
    "ourServicesDesc": "Von der ersten Planung bis zur langfristigen Wartung bieten wir umfassende Lösungen für jedes Solarenergieprojekt.",
    "labelPrintingTitle": "Etikettendruck",
    "labelPrintingDesc": "Unser Unternehmen bietet professionelle Etikettendruckdienste für Solarparks und andere Infrastrukturprojekte mit dem Brady i7500 - für langlebige, präzise und konforme Etiketten für Paneele, Kabel, Geräte und Infrastrukturkomponenten.",
    "designTitle": "Planung",
    "designDesc": "Entsprechend den Bedürfnissen Ihres Unternehmens planen wir Ihr Photovoltaiksystem und liefern ein präzises Design gemäß Ihrer Idee.",
    "constructTitle": "Bau",
    "constructDesc": "Unser Spezialistenteam führt die Installation gemäß der am besten geeigneten Lösung für Ihr System durch und gewährleistet einen präzisen und detaillierten Umsetzungsplan am vorgesehenen Standort.",
    "maintainTitle": "Wartung",
    "kyustendilContractor": "Auftragnehmer: Rashev & Co LTD",
    "pernikoneContractor": "Auftragnehmer: Rashev & Co LTD",
    "slivnitsaContractor": "Auftragnehmer: Rashev & Co LTD",
    "moussoulensContractor": "Auftragnehmer: Rashev & Co LTD",
    "monrealeContractor": "Auftragnehmer: Rashev & Co LTD",
    "perpignanContractor": "Auftragnehmer: Rashev & Co LTD",
    "stgermainContractor": "Auftragnehmer: Rashev & Co LTD",
    "lesmesContractor": "Auftragnehmer: Rashev & Co LTD",
    "lesmesNotes": "Repowering",
    "maintainDesc": "Unser Team führt die technische Wartung der errichteten Photovoltaikanlagen gemäß den Anforderungen durch und beachtet alle technischen Vorgaben der Hersteller, mit denen wir zusammenarbeiten.",
    "upcomingProjects": "KOMMENDE PROJEKTE:",
    "projectsInProgressUpcoming": "Projekte in Arbeit",
    "inProgress": "In Arbeit",
    "upcoming": "Geplant",
    "projectAunslev": "Aunslev",
    "projectAunslevCapacity": "31 MWh",
      "projectStElix": "St. Elix",
      "projectStElixCapacity": "4.1 MWp",
      "projectBalkantsi": "Balkantsi, Bulgarien",
    "projectBalkantsiCapacity": "5 MWp",
    "projectIhtiman": "Ihtiman, Bulgarien",
    "projectIhtimanCapacity": "12 MWp",
    "projectMorocco": "Beni Mathar, Afrika",
    "projectMoroccoCapacity": "120 MWp",
    "projectPrevancher": "Prévenchères, Frankreich",
    "projectPrevancherCapacity": "42 MWp",
    "upcomingProjectsDesc": "Ab Januar 2026 werden wir mehrere Projekte in ganz Europa und Bulgarien starten.",
    "mapConsentRequired": "Google Maps ist deaktiviert, bis Cookies akzeptiert werden.",
    "cookiesTitle": "Infinity Energy Solar - Cookie-Richtlinie",
    "cookiesHeader": "Cookie-Richtlinie",
    "cookiesIntro": "Wir verwenden Cookies, um Ihr Surferlebnis zu verbessern und den Website-Verkehr zu analysieren. Cookies sind kleine Textdateien, die auf Ihrem Gerät gespeichert werden und uns helfen, Sie wiederzuerkennen und Ihre Präferenzen zu speichern.",
    "cookiesTypesTitle": "Arten von Cookies, die wir verwenden",
    "cookiesTypes.0": "Notwendige Cookies – unerlässlich für die grundlegende Funktionalität der Website",
    "cookiesTypes.1": "Analyse-Cookies – helfen uns, das Nutzerverhalten zu verstehen (z. B. Google Analytics)",
    "cookiesTypes.2": "Funktionale Cookies – speichern Ihre Präferenzen (z. B. Sprache)",
    "cookiesThirdPartyTitle": "Drittanbieter-Dienste",
    "cookiesThirdParty": "Wir verwenden Google Maps, um den Standort unseres Unternehmens auf der Kontaktseite anzuzeigen. Google kann Cookies setzen und Nutzungsdaten erfassen. Sie können deren Datenschutzerklärung einsehen.",
    "cookiesManageTitle": "Cookie-Verwaltung",
    "cookiesManage": "Sie können Cookies über Ihre Browsereinstellungen steuern oder deaktivieren. Das Deaktivieren bestimmter Cookies kann die Funktionalität der Website beeinträchtigen.",
    "cookiesContactTitle": "Kontakt",
    "cookiesContact": "Wenn Sie Fragen zu unserer Cookie-Richtlinie haben, kontaktieren Sie uns bitte unter office@infisolarbg.com.",
    "cookieBannerText": "Diese Website verwendet Cookies. Wenn Sie fortfahren, akzeptieren oder lehnen Sie unsere Cookie-Richtlinie ab.",
    "cookieBannerLearnMore": "Mehr erfahren",
    "cookieBannerAccept": "Akzeptieren",
    "cookieBannerDecline": "Ablehnen",
    "employeesTitle": "Für Mitarbeiter",
    "employeesInfo": "Diese Kontakte sind ausschließlich für Mitarbeiter bestimmt, um Probleme, unsichere Arbeitsbedingungen oder andere arbeitsbezogene Anliegen zu melden. Alle Meldungen werden streng vertraulich behandelt, sodass die Mitarbeiter ihre Bedenken ohne Angst vor Repressalien äußern können. Diese Kommunikationskanäle werden von unserer Personalabteilung verwaltet, um eine sichere und unterstützende Arbeitsumgebung für alle zu gewährleisten."
  }
}
};

export default resources;